import V, { useSyncExternalStore as fO, useMemo as _i, forwardRef as Br, createContext as lO, useContext as pO, useState as hO, useEffect as dO, useId as tv, version as gO, useRef as rv, Children as yO, memo as vO, useCallback as jd } from "react";
import { IconButton as iv, Button as mO } from "@vector-im/compound-web";
function ov(e) {
  return fO(e.subscribe, e.getSnapshot, e.getSnapshot);
}
var hi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function av(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zs = { exports: {} };
var qd;
function _O() {
  return qd || (qd = 1, (function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function i() {
        for (var c = "", f = 0; f < arguments.length; f++) {
          var p = arguments[f];
          p && (c = u(c, a(p)));
        }
        return c;
      }
      function a(c) {
        if (typeof c == "string" || typeof c == "number")
          return c;
        if (typeof c != "object")
          return "";
        if (Array.isArray(c))
          return i.apply(null, c);
        if (c.toString !== Object.prototype.toString && !c.toString.toString().includes("[native code]"))
          return c.toString();
        var f = "";
        for (var p in c)
          r.call(c, p) && c[p] && (f = u(f, p));
        return f;
      }
      function u(c, f) {
        return f ? c ? c + " " + f : c + f : c;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  })(Zs)), Zs.exports;
}
var wO = _O();
const ot = /* @__PURE__ */ av(wO), bO = "_mediaBody_11o4b_8", EO = {
  mediaBody: bO
};
function AO({
  as: e,
  className: r,
  children: i,
  ...a
}) {
  const u = e || "div";
  return /* @__PURE__ */ V.createElement(u, { className: ot("mx_MediaBody", EO.mediaBody, r), ...a }, i);
}
const SO = "_flex_4dswl_9", OO = {
  flex: SO
};
function et({
  as: e = "div",
  display: r = "flex",
  direction: i = "row",
  align: a = "start",
  justify: u = "start",
  gap: c = "0",
  wrap: f = "nowrap",
  className: p,
  children: d,
  ...g
}) {
  const m = _i(
    () => ({
      "--mx-flex-display": r,
      "--mx-flex-direction": i,
      "--mx-flex-align": a,
      "--mx-flex-justify": u,
      "--mx-flex-gap": c,
      "--mx-flex-wrap": f
    }),
    [a, i, r, c, u, f]
  );
  return V.createElement(e, { ...g, className: ot(OO.flex, p), style: m }, d);
}
const TO = "_audioPlayer_1ly1h_8", RO = "_mediaInfo_1ly1h_12", IO = "_mediaName_1ly1h_17", xO = "_byline_1ly1h_26", PO = "_clock_1ly1h_30", MO = "_error_1ly1h_34", ai = {
  audioPlayer: TO,
  mediaInfo: RO,
  mediaName: IO,
  byline: xO,
  clock: PO,
  error: MO
};
var Sa = { exports: {} }, Vi = {};
var Ud;
function CO() {
  if (Ud) return Vi;
  Ud = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function i(a, u, c) {
    var f = null;
    if (c !== void 0 && (f = "" + c), u.key !== void 0 && (f = "" + u.key), "key" in u) {
      c = {};
      for (var p in u)
        p !== "key" && (c[p] = u[p]);
    } else c = u;
    return u = c.ref, {
      $$typeof: e,
      type: a,
      key: f,
      ref: u !== void 0 ? u : null,
      props: c
    };
  }
  return Vi.Fragment = r, Vi.jsx = i, Vi.jsxs = i, Vi;
}
var Xi = {};
var kd;
function DO() {
  return kd || (kd = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(q) {
      if (q == null) return null;
      if (typeof q == "function")
        return q.$$typeof === fn ? null : q.displayName || q.name || null;
      if (typeof q == "string") return q;
      switch (q) {
        case B:
          return "Fragment";
        case R:
          return "Profiler";
        case A:
          return "StrictMode";
        case L:
          return "Suspense";
        case j:
          return "SuspenseList";
        case J:
          return "Activity";
      }
      if (typeof q == "object")
        switch (typeof q.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), q.$$typeof) {
          case x:
            return "Portal";
          case S:
            return q.displayName || "Context";
          case D:
            return (q._context.displayName || "Context") + ".Consumer";
          case P:
            var T = q.render;
            return q = q.displayName, q || (q = T.displayName || T.name || "", q = q !== "" ? "ForwardRef(" + q + ")" : "ForwardRef"), q;
          case z:
            return T = q.displayName || null, T !== null ? T : e(q.type) || "Memo";
          case Z:
            T = q._payload, q = q._init;
            try {
              return e(q(T));
            } catch {
            }
        }
      return null;
    }
    function r(q) {
      return "" + q;
    }
    function i(q) {
      try {
        r(q);
        var T = !1;
      } catch {
        T = !0;
      }
      if (T) {
        T = console;
        var N = T.error, W = typeof Symbol == "function" && Symbol.toStringTag && q[Symbol.toStringTag] || q.constructor.name || "Object";
        return N.call(
          T,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          W
        ), r(q);
      }
    }
    function a(q) {
      if (q === B) return "<>";
      if (typeof q == "object" && q !== null && q.$$typeof === Z)
        return "<...>";
      try {
        var T = e(q);
        return T ? "<" + T + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function u() {
      var q = bn.A;
      return q === null ? null : q.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function f(q) {
      if (Ln.call(q, "key")) {
        var T = Object.getOwnPropertyDescriptor(q, "key").get;
        if (T && T.isReactWarning) return !1;
      }
      return q.key !== void 0;
    }
    function p(q, T) {
      function N() {
        Oe || (Oe = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          T
        ));
      }
      N.isReactWarning = !0, Object.defineProperty(q, "key", {
        get: N,
        configurable: !0
      });
    }
    function d() {
      var q = e(this.type);
      return Jn[q] || (Jn[q] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), q = this.props.ref, q !== void 0 ? q : null;
    }
    function g(q, T, N, W, X, cn) {
      var en = N.ref;
      return q = {
        $$typeof: E,
        type: q,
        key: T,
        props: N,
        _owner: W
      }, (en !== void 0 ? en : null) !== null ? Object.defineProperty(q, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(q, "ref", { enumerable: !1, value: null }), q._store = {}, Object.defineProperty(q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(q, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(q, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: X
      }), Object.defineProperty(q, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: cn
      }), Object.freeze && (Object.freeze(q.props), Object.freeze(q)), q;
    }
    function m(q, T, N, W, X, cn) {
      var en = T.children;
      if (en !== void 0)
        if (W)
          if (Fn(en)) {
            for (W = 0; W < en.length; W++)
              v(en[W]);
            Object.freeze && Object.freeze(en);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else v(en);
      if (Ln.call(T, "key")) {
        en = e(q);
        var tn = Object.keys(T).filter(function(nn) {
          return nn !== "key";
        });
        W = 0 < tn.length ? "{key: someKey, " + tn.join(": ..., ") + ": ...}" : "{key: someKey}", te[en + W] || (tn = 0 < tn.length ? "{" + tn.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          W,
          en,
          tn,
          en
        ), te[en + W] = !0);
      }
      if (en = null, N !== void 0 && (i(N), en = "" + N), f(T) && (i(T.key), en = "" + T.key), "key" in T) {
        N = {};
        for (var Q in T)
          Q !== "key" && (N[Q] = T[Q]);
      } else N = T;
      return en && p(
        N,
        typeof q == "function" ? q.displayName || q.name || "Unknown" : q
      ), g(
        q,
        en,
        N,
        u(),
        X,
        cn
      );
    }
    function v(q) {
      w(q) ? q._store && (q._store.validated = 1) : typeof q == "object" && q !== null && q.$$typeof === Z && (q._payload.status === "fulfilled" ? w(q._payload.value) && q._payload.value._store && (q._payload.value._store.validated = 1) : q._store && (q._store.validated = 1));
    }
    function w(q) {
      return typeof q == "object" && q !== null && q.$$typeof === E;
    }
    var M = V, E = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), B = Symbol.for("react.fragment"), A = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), D = Symbol.for("react.consumer"), S = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), j = Symbol.for("react.suspense_list"), z = Symbol.for("react.memo"), Z = Symbol.for("react.lazy"), J = Symbol.for("react.activity"), fn = Symbol.for("react.client.reference"), bn = M.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ln = Object.prototype.hasOwnProperty, Fn = Array.isArray, Se = console.createTask ? console.createTask : function() {
      return null;
    };
    M = {
      react_stack_bottom_frame: function(q) {
        return q();
      }
    };
    var Oe, Jn = {}, Dn = M.react_stack_bottom_frame.bind(
      M,
      c
    )(), $n = Se(a(c)), te = {};
    Xi.Fragment = B, Xi.jsx = function(q, T, N) {
      var W = 1e4 > bn.recentlyCreatedOwnerStacks++;
      return m(
        q,
        T,
        N,
        !1,
        W ? Error("react-stack-top-frame") : Dn,
        W ? Se(a(q)) : $n
      );
    }, Xi.jsxs = function(q, T, N) {
      var W = 1e4 > bn.recentlyCreatedOwnerStacks++;
      return m(
        q,
        T,
        N,
        !0,
        W ? Error("react-stack-top-frame") : Dn,
        W ? Se(a(q)) : $n
      );
    };
  })()), Xi;
}
var Wd;
function NO() {
  return Wd || (Wd = 1, process.env.NODE_ENV === "production" ? Sa.exports = CO() : Sa.exports = DO()), Sa.exports;
}
var pe = NO();
function uv(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "m8.98 4.677 9.921 5.58c1.36.764 1.36 2.722 0 3.486l-9.92 5.58C7.647 20.073 6 19.11 6 17.58V6.42c0-1.53 1.647-2.493 2.98-1.743"
    })
  });
}
uv.displayName = "PlaySolidIcon";
const LO = Br(uv);
function sv(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "M8 4a2 2 0 0 0-2 2v12a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2m8 0a2 2 0 0 0-2 2v12a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2"
    })
  });
}
sv.displayName = "PauseSolidIcon";
const FO = Br(sv), BO = "_button_yfjla_8", jO = {
  button: BO
}, cv = lO(null);
cv.displayName = "I18nContext";
function go() {
  const e = pO(cv);
  if (!e)
    throw new Error("useI18n must be used within an I18nContext.Provider");
  return e;
}
function qO({
  disabled: e = !1,
  playing: r = !1,
  togglePlay: i,
  ...a
}) {
  const { translate: u } = go(), c = u(r ? "action|pause" : "action|play");
  return /* @__PURE__ */ V.createElement(
    iv,
    {
      size: "32px",
      "aria-label": c,
      tooltip: c,
      onClick: i,
      className: jO.button,
      disabled: e,
      ...a
    },
    r ? /* @__PURE__ */ V.createElement(FO, null) : /* @__PURE__ */ V.createElement(LO, null)
  );
}
function UO(e, r = 2) {
  if (e === 0) return "0 Bytes";
  const i = 1024, a = r < 0 ? 0 : r, u = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], c = Math.floor(Math.log(e) / Math.log(i));
  return parseFloat((e / Math.pow(i, c)).toFixed(a)) + " " + u[c];
}
function De(e, r, i, a, u) {
  return Bt(r, ((c, f) => {
    const p = c[f];
    if (p === void 0)
      throw new TypeError(bl(f));
    return p;
  })(e, r), i, a, u);
}
function Bt(e, r, i, a, u, c) {
  const f = uo(r, i, a);
  if (u && r !== f)
    throw new RangeError(A0(e, r, i, a, c));
  return f;
}
function be(e) {
  return e !== null && /object|function/.test(typeof e);
}
function Ze(e, r = Map) {
  const i = new r();
  return (a, ...u) => {
    if (i.has(a))
      return i.get(a);
    const c = e(a, ...u);
    return i.set(a, c), c;
  };
}
function ao(e) {
  return gi({
    name: e
  }, 1);
}
function gi(e, r) {
  return jt(((i) => ({
    value: i,
    configurable: 1,
    writable: !r
  })), e);
}
function kO(e) {
  return jt(((r) => ({
    get: r,
    configurable: 1
  })), e);
}
function If(e) {
  return {
    [Symbol.toStringTag]: {
      value: e,
      configurable: 1
    }
  };
}
function wi(e, r) {
  const i = {};
  let a = e.length;
  for (const u of r)
    i[e[--a]] = u;
  return i;
}
function jt(e, r, i) {
  const a = {};
  for (const u in r)
    a[u] = e(r[u], u, i);
  return a;
}
function Ha(e, r, i) {
  const a = {};
  for (let u = 0; u < r.length; u++) {
    const c = r[u];
    a[c] = e(c, u, i);
  }
  return a;
}
function fv(e, r, i) {
  const a = {};
  for (let u = 0; u < e.length; u++)
    a[r[u]] = i[e[u]];
  return a;
}
function at(e, r) {
  const i = /* @__PURE__ */ Object.create(null);
  for (const a of e)
    i[a] = r[a];
  return i;
}
function Yd(e, r) {
  for (const i of r)
    if (i in e)
      return 1;
  return 0;
}
function lv(e, r, i) {
  for (const a of e)
    if (r[a] !== i[a])
      return 0;
  return 1;
}
function pv(e, r, i) {
  const a = {
    ...i
  };
  for (let u = 0; u < r; u++)
    a[e[u]] = 0;
  return a;
}
function Tn(e, ...r) {
  return (...i) => e(...r, ...i);
}
function $d(e) {
  return e[0].toUpperCase() + e.substring(1);
}
function yo(e) {
  return e.slice().sort();
}
function Ba(e, r) {
  return String(r).padStart(e, "0");
}
function ir(e, r) {
  return Math.sign(e - r);
}
function uo(e, r, i) {
  return Math.min(Math.max(e, r), i);
}
function Nt(e, r) {
  return [Math.floor(e / r), io(e, r)];
}
function io(e, r) {
  return (e % r + r) % r;
}
function ur(e, r) {
  return [Ka(e, r), xf(e, r)];
}
function Ka(e, r) {
  return Math.trunc(e / r) || 0;
}
function xf(e, r) {
  return e % r || 0;
}
function Oa(e) {
  return Math.abs(e % 1) === 0.5;
}
function hv(e, r, i) {
  let a = 0, u = 0;
  for (let p = 0; p <= r; p++) {
    const d = e[i[p]], g = _t[p], m = qn / g, [v, w] = ur(d, m);
    a += w * g, u += v;
  }
  const [c, f] = ur(a, qn);
  return [u + c, f];
}
function Ja(e, r, i) {
  const a = {};
  for (let u = r; u >= 0; u--) {
    const c = _t[u];
    a[i[u]] = Ka(e, c), e = xf(e, c);
  }
  return a;
}
function WO(e) {
  if (e !== void 0)
    return he(e);
}
function YO(e) {
  if (e !== void 0)
    return Dt(e);
}
function dv(e) {
  if (e !== void 0)
    return Pf(e);
}
function Dt(e) {
  return vv(Pf(e));
}
function Pf(e) {
  return yv(QR(e));
}
function gv(e, r) {
  if (r == null)
    throw new RangeError(bl(e));
  return r;
}
function vo(e) {
  if (!be(e))
    throw new TypeError(SR);
  return e;
}
function Mf(e, r, i = e) {
  if (typeof r !== e)
    throw new TypeError(vr(i, r));
  return r;
}
function yv(e, r = "number") {
  if (!Number.isInteger(e))
    throw new RangeError(mR(r, e));
  return e || 0;
}
function vv(e, r = "number") {
  if (e <= 0)
    throw new RangeError(_R(r, e));
  return e;
}
function Cf(e) {
  if (typeof e == "symbol")
    throw new TypeError(AR);
  return String(e);
}
function Da(e, r) {
  return be(e) ? String(e) : he(e, r);
}
function Df(e) {
  if (typeof e == "string")
    return BigInt(e);
  if (typeof e != "bigint")
    throw new TypeError(ER(e));
  return e;
}
function mv(e, r = "number") {
  if (typeof e == "bigint")
    throw new TypeError(bR(r));
  if (e = Number(e), !Number.isFinite(e))
    throw new RangeError(wR(r, e));
  return e;
}
function _e(e, r) {
  return Math.trunc(mv(e, r)) || 0;
}
function Nf(e, r) {
  return yv(mv(e, r), r);
}
function zd(e, r) {
  return vv(_e(e, r), r);
}
function Lf(e, r) {
  let [i, a] = ur(r, qn), u = e + i;
  const c = Math.sign(u);
  return c && c === -Math.sign(a) && (u -= c, a += c * qn), [u, a];
}
function yi(e, r, i = 1) {
  return Lf(e[0] + r[0] * i, e[1] + r[1] * i);
}
function Nr(e, r) {
  return Lf(e[0], e[1] + r);
}
function vt(e, r) {
  return yi(r, e, -1);
}
function He(e, r) {
  return ir(e[0], r[0]) || ir(e[1], r[1]);
}
function _v(e, r, i) {
  return He(e, r) === -1 || He(e, i) === 1;
}
function Ff(e, r = 1) {
  const i = BigInt(qn / r);
  return [Number(e / i), Number(e % i) * r];
}
function ja(e, r = 1) {
  const i = qn / r, [a, u] = ur(e, i);
  return [a, u * r];
}
function mt(e, r = 1, i) {
  const [a, u] = e, [c, f] = ur(u, r);
  return a * (qn / r) + (c + (i ? f / r : 0));
}
function Bf(e, r, i = Nt) {
  const [a, u] = e, [c, f] = i(u, r);
  return [a * (qn / r) + c, f];
}
function jf(e) {
  return De(e, "isoYear", ho, po, 1), e.isoYear === ho ? De(e, "isoMonth", 4, 12, 1) : e.isoYear === po && De(e, "isoMonth", 1, 9, 1), e;
}
function tt(e) {
  return Fe({
    ...e,
    ...Be,
    isoHour: 12
  }), e;
}
function Fe(e) {
  const r = De(e, "isoYear", ho, po, 1), i = r === ho ? 1 : r === po ? -1 : 0;
  return i && wt(ae({
    ...e,
    isoDay: e.isoDay + i,
    isoNanosecond: e.isoNanosecond - i
  })), e;
}
function wt(e) {
  if (!e || _v(e, a2, o2))
    throw new RangeError(mr);
  return e;
}
function sr(e) {
  return hv(e, 5, ct)[1];
}
function Va(e) {
  const [r, i] = Nt(e, qn);
  return [Ja(i, 5, ct), r];
}
function Gd(e) {
  return Bf(e, yt);
}
function we(e) {
  return bi(e.isoYear, e.isoMonth, e.isoDay, e.isoHour, e.isoMinute, e.isoSecond, e.isoMillisecond);
}
function ae(e) {
  const r = we(e);
  if (r !== void 0) {
    const [i, a] = ur(r, Le);
    return [i, a * kt + (e.isoMicrosecond || 0) * So + (e.isoNanosecond || 0)];
  }
}
function qf(e, r) {
  const [i, a] = Va(sr(e) - r);
  return wt(ae({
    ...e,
    isoDay: e.isoDay + a,
    ...i
  }));
}
function qa(...e) {
  return bi(...e) / C0;
}
function bi(...e) {
  const [r, i] = wv(...e), a = r.valueOf();
  if (!isNaN(a))
    return a - i * Le;
}
function wv(e, r = 1, i = 1, a = 0, u = 0, c = 0, f = 0) {
  const p = e === ho ? 1 : e === po ? -1 : 0, d = /* @__PURE__ */ new Date();
  return d.setUTCHours(a, u, c, f), d.setUTCFullYear(e, r - 1, i + p), [d, p];
}
function Ei(e, r) {
  let [i, a] = Nr(e, r);
  a < 0 && (a += qn, i -= 1);
  const [u, c] = Nt(a, kt), [f, p] = Nt(c, So);
  return Xa(i * Le + u, f, p);
}
function Xa(e, r = 0, i = 0) {
  const a = Math.ceil(Math.max(0, Math.abs(e) - Dl) / Le) * Math.sign(e), u = new Date(e - a * Le);
  return wi(_u, [u.getUTCFullYear(), u.getUTCMonth() + 1, u.getUTCDate() + a, u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds(), r, i]);
}
function Uf(e, r) {
  if (r < -Dl)
    throw new RangeError(mr);
  const i = e.formatToParts(r), a = {};
  for (const u of i)
    a[u.type] = u.value;
  return a;
}
function kf(e) {
  return [e.isoYear, e.isoMonth, e.isoDay];
}
function bv(e, r) {
  return [r, 0];
}
function Ev() {
  return nr;
}
function Av(e, r) {
  switch (r) {
    case 2:
      return Wf(e) ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
  }
  return 31;
}
function Sv(e) {
  return Wf(e) ? 366 : 365;
}
function Wf(e) {
  return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
function Ov(e) {
  const [r, i] = wv(e.isoYear, e.isoMonth, e.isoDay);
  return io(r.getUTCDay() - i, 7) || 7;
}
function Tv(e) {
  return this.id === Pi ? (({ isoYear: r }) => r < 1 ? ["gregory-inverse", 1 - r] : ["gregory", r])(e) : this.id === lr ? c2(e) : [];
}
function $O(e) {
  const r = we(e);
  if (r < s2) {
    const { isoYear: c } = e;
    return c < 1 ? ["japanese-inverse", 1 - c] : ["japanese", c];
  }
  const i = Uf(Yl(lr), r), { era: a, eraYear: u } = p0(i, lr);
  return [a, u];
}
function Qa(e) {
  return jr(e), Ai(e, 1), e;
}
function jr(e) {
  return Rv(e, 1), e;
}
function Zd(e) {
  return lv(Pl, e, Rv(e));
}
function Rv(e, r) {
  const { isoYear: i } = e, a = De(e, "isoMonth", 1, Ev(), r);
  return {
    isoYear: i,
    isoMonth: a,
    isoDay: De(e, "isoDay", 1, Av(i, a), r)
  };
}
function Ai(e, r) {
  return wi(ct, [De(e, "isoHour", 0, 23, r), De(e, "isoMinute", 0, 59, r), De(e, "isoSecond", 0, 59, r), De(e, "isoMillisecond", 0, 999, r), De(e, "isoMicrosecond", 0, 999, r), De(e, "isoNanosecond", 0, 999, r)]);
}
function Pn(e) {
  return e === void 0 ? 0 : Z0(vo(e));
}
function nu(e, r = 0) {
  e = bt(e);
  const i = H0(e), a = _2(e, r);
  return [Z0(e), a, i];
}
function Si(e, r, i, a = 9, u = 0, c = 4) {
  r = bt(r);
  let f = G0(r, a, u), p = zf(r), d = Ro(r, c);
  const g = To(r, a, u, 1);
  return f == null ? f = Math.max(i, g) : Mv(f, g), p = Gf(p, g, 1), e && (d = ((m) => m < 4 ? (m + 2) % 4 : m)(d)), [f, g, p, d];
}
function eu(e, r = 6, i) {
  let a = zf(e = tu(e, za));
  const u = Ro(e, 7);
  let c = To(e, r);
  return c = gv(za, c), a = Gf(a, c, void 0, i), [c, a, u];
}
function Yf(e) {
  return Nl(bt(e));
}
function Iv(e, r) {
  return $f(bt(e), r);
}
function zO(e) {
  const r = tu(e, ec), i = pr(ec, v2, r, 0);
  if (!i)
    throw new RangeError(vr(ec, i));
  return i;
}
function $f(e, r = 4) {
  const i = Pv(e);
  return [Ro(e, 4), ...xv(To(e, r), i)];
}
function xv(e, r) {
  return e != null ? [_t[e], e < 4 ? 9 - 3 * e : -1] : [r === void 0 ? 1 : 10 ** (9 - r), r];
}
function zf(e) {
  const r = e[oo];
  return r === void 0 ? 1 : _e(r, oo);
}
function Gf(e, r, i, a) {
  const u = a ? qn : _t[r + 1];
  if (u) {
    const c = _t[r];
    if (u % ((e = Bt(oo, e, 1, u / c - (a ? 0 : 1), 1)) * c))
      throw new RangeError(vr(oo, e));
  } else
    e = Bt(oo, e, 1, i ? 10 ** 9 : 1, 1);
  return e;
}
function Pv(e) {
  let r = e[nc];
  if (r !== void 0) {
    if (typeof r != "number") {
      if (Cf(r) === "auto")
        return;
      throw new RangeError(vr(nc, r));
    }
    r = Bt(nc, Math.floor(r), 0, 9, 1);
  }
  return r;
}
function bt(e) {
  return e === void 0 ? {} : vo(e);
}
function tu(e, r) {
  return typeof e == "string" ? {
    [r]: e
  } : vo(e);
}
function ru(e) {
  return {
    overflow: f2[e]
  };
}
function Zf(e, r, i = 9, a = 0, u) {
  let c = r[e];
  if (c === void 0)
    return u ? a : void 0;
  if (c = Cf(c), c === "auto")
    return u ? a : null;
  let f = bf[c];
  if (f === void 0 && (f = t2[c]), f === void 0)
    throw new RangeError(O0(e, c, bf));
  return Bt(e, f, a, i, 1, El), f;
}
function pr(e, r, i, a = 0) {
  const u = i[e];
  if (u === void 0)
    return a;
  const c = Cf(u), f = r[c];
  if (f === void 0)
    throw new RangeError(O0(e, c, r));
  return f;
}
function Mv(e, r) {
  if (r > e)
    throw new RangeError(zR);
}
function qt(e) {
  return {
    branding: jl,
    epochNanoseconds: e
  };
}
function ut(e, r, i) {
  return {
    branding: _r,
    calendar: i,
    timeZone: r,
    epochNanoseconds: e
  };
}
function st(e, r = e.calendar) {
  return {
    branding: Mi,
    calendar: r,
    ...at(r2, e)
  };
}
function Ut(e, r = e.calendar) {
  return {
    branding: Io,
    calendar: r,
    ...at(Ml, e)
  };
}
function so(e, r = e.calendar) {
  return {
    branding: Ll,
    calendar: r,
    ...at(Ml, e)
  };
}
function Ua(e, r = e.calendar) {
  return {
    branding: Fl,
    calendar: r,
    ...at(Ml, e)
  };
}
function Et(e) {
  return {
    branding: Bl,
    ...at(W0, e)
  };
}
function ee(e) {
  return {
    branding: ql,
    sign: hr(e),
    ...at(Rl, e)
  };
}
function Hf(e) {
  return Bf(e.epochNanoseconds, kt)[0];
}
function GO(e) {
  return ((r, i = 1) => {
    const [a, u] = r, c = Math.floor(u / i), f = qn / i;
    return BigInt(a) * BigInt(f) + BigInt(c);
  })(e.epochNanoseconds);
}
function Cv(e) {
  return e.epochNanoseconds;
}
function ZO(e, r, i, a, u) {
  const c = Lr(a), [f, p] = ((A, R) => {
    const D = R((A = tu(A, Sf))[$0]);
    let S = m2(A);
    return S = gv(Sf, S), [S, D];
  })(u, e), d = Math.max(f, c);
  if (!p && fo(d, p))
    return Hd(a, f);
  if (!p)
    throw new RangeError(yu);
  if (!a.sign)
    return 0;
  const [g, m, v] = su(r, i, p), w = rl(v), M = cu(v), E = il(v), x = M(m, g, a);
  vi(p) || (Fe(g), Fe(x));
  const B = E(m, g, x, f);
  return fo(f, p) ? Hd(B, f) : ((A, R, D, S, P, L, j) => {
    const z = hr(A), [Z, J] = Kf(S, xl(D, A), D, z, P, L, j), fn = Jf(R, Z, J);
    return A[Cn[D]] + fn * z;
  })(B, w(x), f, m, g, w, M);
}
function Hd(e, r) {
  return mt(ue(e), _t[r], 1);
}
function Kf(e, r, i, a, u, c, f) {
  const p = Cn[i], d = {
    ...r,
    [p]: r[p] + a
  }, g = f(e, u, r), m = f(e, u, d);
  return [c(g), c(m)];
}
function Jf(e, r, i) {
  const a = mt(vt(r, i));
  if (!a)
    throw new RangeError(xi);
  return mt(vt(r, e)) / a;
}
function HO(e, r) {
  const [i, a, u] = eu(r, 5, 1);
  return qt(ou(e.epochNanoseconds, i, a, u, 1));
}
function KO(e, r, i) {
  let { epochNanoseconds: a, timeZone: u, calendar: c } = r;
  const [f, p, d] = eu(i);
  if (f === 0 && p === 1)
    return r;
  const g = e(u);
  if (f === 6)
    a = ((m, v, w, M) => {
      const E = Je(w, v), [x, B] = m(E), A = w.epochNanoseconds, R = fr(v, x), D = fr(v, B);
      if (_v(A, R, D))
        throw new RangeError(xi);
      return Bv(Jf(A, R, D), M) ? D : R;
    })(Lv, g, r, d);
  else {
    const m = g.R(a);
    a = Oi(g, Dv(Ei(a, m), f, p, d), m, 2, 0, 1);
  }
  return ut(a, u, c);
}
function JO(e, r) {
  return st(Dv(e, ...eu(r)), e.calendar);
}
function VO(e, r) {
  const [i, a, u] = eu(r, 5);
  var c;
  return Et((c = u, Vf(e, mo(i, a), c)[0]));
}
function XO(e, r) {
  const i = e(r.timeZone), a = Je(r, i), [u, c] = Lv(a), f = mt(vt(fr(i, u), fr(i, c)), mu, 1);
  if (f <= 0)
    throw new RangeError(xi);
  return f;
}
function QO(e, r) {
  const { timeZone: i, calendar: a } = r, u = ((c, f, p) => fr(f, c(Je(p, f))))(Fv, e(i), r);
  return ut(u, i, a);
}
function Dv(e, r, i, a) {
  return Nv(e, mo(r, i), a);
}
function Nv(e, r, i) {
  const [a, u] = Vf(e, r, i);
  return Fe({
    ...qr(e, u),
    ...a
  });
}
function Vf(e, r, i) {
  return Va(cr(sr(e), r, i));
}
function ka(e) {
  return cr(e, vu, 7);
}
function mo(e, r) {
  return _t[e] * r;
}
function Lv(e) {
  const r = Fv(e);
  return [r, qr(r, 1)];
}
function Fv(e) {
  return i2(6, e);
}
function nT(e, r, i) {
  const a = Math.min(Lr(e), 6);
  return Ti(au(ue(e, a), r, i), a);
}
function iu(e, r, i, a, u, c, f, p, d, g) {
  if (a === 0 && u === 1)
    return e;
  const m = fo(a, p) ? vi(p) && a < 6 && i >= 6 ? tT : eT : rT;
  let [v, w, M] = m(e, r, i, a, u, c, f, p, d, g);
  return M && a !== 7 && (v = ((E, x, B, A, R, D, S, P) => {
    const L = hr(E);
    for (let j = A + 1; j <= B; j++) {
      if (j === 7 && B !== 7)
        continue;
      const z = xl(j, E);
      z[Cn[j]] += L;
      const Z = mt(vt(S(P(R, D, z)), x));
      if (Z && Math.sign(Z) !== L)
        break;
      E = z;
    }
    return E;
  })(v, w, i, Math.max(6, a), f, p, d, g)), v;
}
function ou(e, r, i, a, u) {
  if (r === 6) {
    const c = ((f) => f[0] + f[1] / qn)(e);
    return [cr(c, i, a), 0];
  }
  return au(e, mo(r, i), a, u);
}
function au(e, r, i, a) {
  let [u, c] = e;
  a && c < 0 && (c += qn, u -= 1);
  const [f, p] = Nt(cr(c, r, i), qn);
  return Lf(u + f, p);
}
function cr(e, r, i) {
  return Bv(e / r, i) * r;
}
function Bv(e, r) {
  return E2[r](e);
}
function eT(e, r, i, a, u, c) {
  const f = hr(e), p = ue(e), d = ou(p, a, u, c), g = vt(p, d), m = Math.sign(d[0] - p[0]) === f, v = Ti(d, Math.min(i, 6));
  return [{
    ...e,
    ...v
  }, yi(r, g), m];
}
function tT(e, r, i, a, u, c, f, p, d, g) {
  const m = hr(e) || 1, v = mt(ue(e, 5)), w = mo(a, u);
  let M = cr(v, w, c);
  const [E, x] = Kf(f, {
    ...e,
    ...Il
  }, 6, m, p, d, g), B = M - mt(vt(E, x));
  let A = 0;
  B && Math.sign(B) !== m ? r = Nr(E, M) : (A += m, M = cr(B, w, c), r = Nr(x, M));
  const R = fu(M);
  return [{
    ...e,
    ...R,
    days: e.days + A
  }, r, !!A];
}
function rT(e, r, i, a, u, c, f, p, d, g) {
  const m = hr(e), v = Cn[a], w = xl(a, e);
  a === 7 && (e = {
    ...e,
    weeks: e.weeks + Math.trunc(e.days / 7)
  });
  const M = Ka(e[v], u) * u;
  w[v] = M;
  const [E, x] = Kf(f, w, a, u * m, p, d, g), B = M + Jf(r, E, x) * m * u, A = cr(B, u, c), R = Math.sign(A - B) === m;
  return w[v] = A, [w, R ? x : E, R];
}
function Kd(e, r, i, a) {
  const [u, c, f, p] = ((g) => {
    const m = $f(g = bt(g));
    return [g.timeZone, ...m];
  })(a), d = u !== void 0;
  return ((g, m, v, w, M, E) => {
    v = au(v, M, w, 1);
    const x = m.R(v);
    return Xf(Ei(v, x), E) + (g ? _o(ka(x)) : "Z");
  })(d, r(d ? e(u) : Yr), i.epochNanoseconds, c, f, p);
}
function Jd(e, r, i) {
  const [a, u, c, f, p, d] = ((g) => {
    g = bt(g);
    const m = Nl(g), v = Pv(g), w = b2(g), M = Ro(g, 4), E = To(g, 4);
    return [m, w2(g), w, M, ...xv(E, v)];
  })(i);
  return ((g, m, v, w, M, E, x, B, A, R) => {
    w = au(w, A, B, 1);
    const D = g(v).R(w);
    return Xf(Ei(w, D), R) + _o(ka(D), x) + ((S, P) => P !== 1 ? "[" + (P === 2 ? "!" : "") + S + "]" : "")(v, E) + Qf(m, M);
  })(e, r.calendar, r.timeZone, r.epochNanoseconds, a, u, c, f, p, d);
}
function Vd(e, r) {
  const [i, a, u, c] = ((g) => (g = bt(g), [Nl(g), ...$f(g)]))(r);
  return f = e.calendar, p = i, d = c, Xf(Nv(e, u, a), d) + Qf(f, p);
  var f, p, d;
}
function Xd(e, r) {
  return i = e.calendar, a = e, u = Yf(r), Wa(a) + Qf(i, u);
  var i, a, u;
}
function Qd(e, r) {
  return jv(e.calendar, qv, e, Yf(r));
}
function ng(e, r) {
  return jv(e.calendar, iT, e, Yf(r));
}
function eg(e, r) {
  const [i, a, u] = Iv(r);
  return c = u, Uv(Vf(e, a, i)[0], c);
  var c;
}
function Hs(e, r) {
  const [i, a, u] = Iv(r, 3);
  return a > 1 && Ur(e = {
    ...e,
    ...nT(e, a, i)
  }), ((c, f) => {
    const { sign: p } = c, d = p === -1 ? Ee(c) : c, { hours: g, minutes: m } = d, [v, w] = Bf(ue(d, 3), yt, ur);
    $v(v);
    const M = nl(w, f), E = f >= 0 || !p || M;
    return (p < 0 ? "-" : "") + "P" + tg({
      Y: Mr(d.years),
      M: Mr(d.months),
      W: Mr(d.weeks),
      D: Mr(d.days)
    }) + (g || m || v || E ? "T" + tg({
      H: Mr(g),
      M: Mr(m),
      S: Mr(v, E) + M
    }) : "");
  })(e, u);
}
function jv(e, r, i, a) {
  const u = a > 1 || a === 0 && e !== In;
  return a === 1 ? e === In ? r(i) : Wa(i) : u ? Wa(i) + kv(e, a === 2) : r(i);
}
function tg(e) {
  const r = [];
  for (const i in e) {
    const a = e[i];
    a && r.push(a, i);
  }
  return r.join("");
}
function Xf(e, r) {
  return Wa(e) + "T" + Uv(e, r);
}
function Wa(e) {
  return qv(e) + "-" + rt(e.isoDay);
}
function qv(e) {
  const { isoYear: r } = e;
  return (r < 0 || r > 9999 ? Wv(r) + Ba(6, Math.abs(r)) : Ba(4, r)) + "-" + rt(e.isoMonth);
}
function iT(e) {
  return rt(e.isoMonth) + "-" + rt(e.isoDay);
}
function Uv(e, r) {
  const i = [rt(e.isoHour), rt(e.isoMinute)];
  return r !== -1 && i.push(rt(e.isoSecond) + ((a, u, c, f) => nl(a * kt + u * So + c, f))(e.isoMillisecond, e.isoMicrosecond, e.isoNanosecond, r)), i.join(":");
}
function _o(e, r = 0) {
  if (r === 1)
    return "";
  const [i, a] = Nt(Math.abs(e), mu), [u, c] = Nt(a, vu), [f, p] = Nt(c, yt);
  return Wv(e) + rt(i) + ":" + rt(u) + (f || p ? ":" + rt(f) + nl(p) : "");
}
function Qf(e, r) {
  return r !== 1 && (r > 1 || r === 0 && e !== In) ? kv(e, r === 2) : "";
}
function kv(e, r) {
  return "[" + (r ? "!" : "") + "u-ca=" + e + "]";
}
function nl(e, r) {
  let i = Ba(9, e);
  return i = r === void 0 ? i.replace(O2, "") : i.slice(0, r), i ? "." + i : "";
}
function Wv(e) {
  return e < 0 ? "-" : "+";
}
function Mr(e, r) {
  return e || r ? e.toLocaleString("fullwide", {
    useGrouping: 0
  }) : "";
}
function oT(e, r) {
  const { epochNanoseconds: i } = e, a = (r.R ? r : r(e.timeZone)).R(i), u = Ei(i, a);
  return {
    calendar: e.calendar,
    ...u,
    offsetNanoseconds: a
  };
}
function Oi(e, r, i, a = 0, u = 0, c, f) {
  if (i !== void 0 && a === 1 && (a === 1 || f))
    return qf(r, i);
  const p = e.I(r);
  if (i !== void 0 && a !== 3) {
    const d = ((g, m, v, w) => {
      const M = ae(m);
      w && (v = ka(v));
      for (const E of g) {
        let x = mt(vt(E, M));
        if (w && (x = ka(x)), x === v)
          return E;
      }
    })(p, r, i, c);
    if (d !== void 0)
      return d;
    if (a === 0)
      throw new RangeError(qR);
  }
  return f ? ae(r) : wo(e, r, u, p);
}
function wo(e, r, i = 0, a = e.I(r)) {
  if (a.length === 1)
    return a[0];
  if (i === 1)
    throw new RangeError(UR);
  if (a.length)
    return a[i === 3 ? 1 : 0];
  const u = ae(r), c = ((p, d) => {
    const g = p.R(Nr(d, -qn));
    return ((m) => {
      if (m > qn)
        throw new RangeError(jR);
      return m;
    })(p.R(Nr(d, qn)) - g);
  })(e, u), f = c * (i === 2 ? -1 : 1);
  return (a = e.I(Ei(u, f)))[i === 2 ? 0 : a.length - 1];
}
function fr(e, r) {
  const i = e.I(r);
  if (i.length)
    return i[0];
  const a = Nr(ae(r), -qn);
  return e.O(a, 1);
}
function rg(e, r, i) {
  return qt(wt(yi(r.epochNanoseconds, ((a) => {
    if (zv(a))
      throw new RangeError(YR);
    return ue(a, 5);
  })(e ? Ee(i) : i))));
}
function ig(e, r, i, a, u, c = /* @__PURE__ */ Object.create(null)) {
  const f = r(a.timeZone), p = e(a.calendar);
  return {
    ...a,
    ...el(f, p, a, i ? Ee(u) : u, c)
  };
}
function og(e, r, i, a, u = /* @__PURE__ */ Object.create(null)) {
  const { calendar: c } = i;
  return st(tl(e(c), i, r ? Ee(a) : a, u), c);
}
function ag(e, r, i, a, u) {
  const { calendar: c } = i;
  return Ut(uu(e(c), i, r ? Ee(a) : a, u), c);
}
function ug(e, r, i, a, u) {
  const c = i.calendar, f = e(c);
  let p = tt(co(f, i));
  r && (a = ol(a)), a.sign < 0 && (p = f.P(p, {
    ...se,
    months: 1
  }), p = qr(p, -1));
  const d = f.P(p, a, u);
  return so(co(f, d), c);
}
function sg(e, r, i) {
  return Et(Yv(r, e ? Ee(i) : i)[0]);
}
function el(e, r, i, a, u) {
  const c = ue(a, 5);
  let f = i.epochNanoseconds;
  if (zv(a)) {
    const p = Je(i, e);
    f = yi(wo(e, {
      ...uu(r, p, {
        ...a,
        ...Il
      }, u),
      ...at(ct, p)
    }), c);
  } else
    f = yi(f, c), Pn(u);
  return {
    epochNanoseconds: wt(f)
  };
}
function tl(e, r, i, a) {
  const [u, c] = Yv(r, i);
  return Fe({
    ...uu(e, r, {
      ...i,
      ...Il,
      days: i.days + c
    }, a),
    ...u
  });
}
function uu(e, r, i, a) {
  if (i.years || i.months || i.weeks)
    return e.P(r, i, a);
  Pn(a);
  const u = i.days + ue(i, 5)[0];
  return u ? tt(qr(r, u)) : r;
}
function co(e, r, i = 1) {
  return qr(r, i - e.day(r));
}
function Yv(e, r) {
  const [i, a] = ue(r, 5), [u, c] = Va(sr(e) + a);
  return [u, i + c];
}
function qr(e, r) {
  return r ? {
    ...e,
    ...Xa(we(e) + r * Le)
  } : e;
}
function su(e, r, i) {
  const a = e(i.calendar);
  return vi(i) ? [i, a, r(i.timeZone)] : [{
    ...i,
    ...Be
  }, a];
}
function rl(e) {
  return e ? Cv : ae;
}
function cu(e) {
  return e ? Tn(el, e) : tl;
}
function il(e) {
  return e ? Tn(xT, e) : PT;
}
function vi(e) {
  return e && e.epochNanoseconds;
}
function fo(e, r) {
  return e <= 6 - (vi(r) ? 1 : 0);
}
function cg(e, r, i, a, u, c, f) {
  const p = e(bt(f).relativeTo), d = Math.max(Lr(u), Lr(c));
  if (fo(d, p))
    return ee(Ur(((x, B, A, R) => {
      const D = yi(ue(x), ue(B), R ? -1 : 1);
      if (!Number.isFinite(D[0]))
        throw new RangeError(mr);
      return {
        ...se,
        ...Ti(D, A)
      };
    })(u, c, d, a)));
  if (!p)
    throw new RangeError(yu);
  a && (c = Ee(c));
  const [g, m, v] = su(r, i, p), w = cu(v), M = il(v), E = w(m, g, u);
  return ee(M(m, g, w(m, E, c), d));
}
function aT(e, r, i, a, u) {
  const c = Lr(a), [f, p, d, g, m] = ((L, j, z) => {
    L = tu(L, za);
    let Z = G0(L);
    const J = z(L[$0]);
    let fn = zf(L);
    const bn = Ro(L, 7);
    let Ln = To(L);
    if (Z === void 0 && Ln === void 0)
      throw new RangeError($R);
    if (Ln == null && (Ln = 0), Z == null && (Z = Math.max(Ln, j)), Mv(Z, Ln), fn = Gf(fn, Ln, 1), fn > 1 && Ln > 5 && Z !== Ln)
      throw new RangeError("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit");
    return [Z, Ln, fn, bn, J];
  })(u, c, e), v = Math.max(c, f);
  if (!m && v <= 6)
    return ee(Ur(((L, j, z, Z, J) => {
      const fn = ou(ue(L), z, Z, J);
      return {
        ...se,
        ...Ti(fn, j)
      };
    })(a, f, p, d, g)));
  if (!vi(m) && !a.sign)
    return a;
  if (!m)
    throw new RangeError(yu);
  const [w, M, E] = su(r, i, m), x = rl(E), B = cu(E), A = il(E), R = B(M, w, a);
  vi(m) || (Fe(w), Fe(R));
  let D = A(M, w, R, f);
  const S = a.sign, P = hr(D);
  if (S && P && S !== P)
    throw new RangeError(xi);
  return D = iu(D, x(R), f, p, d, g, M, w, x, B), ee(D);
}
function uT(e) {
  return e.sign === -1 ? ol(e) : e;
}
function ol(e) {
  return ee(Ee(e));
}
function Ee(e) {
  const r = {};
  for (const i of Cn)
    r[i] = -1 * e[i] || 0;
  return r;
}
function sT(e) {
  return !e.sign;
}
function hr(e, r = Cn) {
  let i = 0;
  for (const a of r) {
    const u = Math.sign(e[a]);
    if (u) {
      if (i && i !== u)
        throw new RangeError(WR);
      i = u;
    }
  }
  return i;
}
function Ur(e) {
  for (const r of e2)
    Bt(r, e[r], -wg, wg, 1);
  return $v(mt(ue(e), yt)), e;
}
function $v(e) {
  if (!Number.isSafeInteger(e))
    throw new RangeError(kR);
}
function ue(e, r = 6) {
  return hv(e, r, Cn);
}
function Ti(e, r = 6) {
  const [i, a] = e, u = Ja(a, r, Cn);
  if (u[Cn[r]] += i * (qn / _t[r]), !Number.isFinite(u[Cn[r]]))
    throw new RangeError(mr);
  return u;
}
function fu(e, r = 5) {
  return Ja(e, r, Cn);
}
function zv(e) {
  return !!hr(e, k0);
}
function Lr(e) {
  let r = 9;
  for (; r > 0 && !e[Cn[r]]; r--)
    ;
  return r;
}
function cT(e, r) {
  return [e, r];
}
function fg(e) {
  const r = Math.floor(e / La) * La;
  return [r, r + La];
}
function fT(e) {
  const r = dr(e = Da(e));
  if (!r)
    throw new RangeError(Ne(e));
  let i;
  if (r.j)
    i = 0;
  else {
    if (!r.offset)
      throw new RangeError(Ne(e));
    i = kr(r.offset);
  }
  return r.timeZone && fl(r.timeZone, 1), qt(qf(Qa(r), i));
}
function lT(e) {
  const r = dr(he(e));
  if (!r)
    throw new RangeError(Ne(e));
  if (r.timeZone)
    return Gv(r, r.offset ? kr(r.offset) : void 0);
  if (r.j)
    throw new RangeError(Ne(e));
  return Hv(r);
}
function pT(e, r) {
  const i = dr(he(e));
  if (!i || !i.timeZone)
    throw new RangeError(Ne(e));
  const { offset: a } = i, u = a ? kr(a) : void 0, [, c, f] = nu(r);
  return Gv(i, u, c, f);
}
function kr(e) {
  const r = fl(e);
  if (r === void 0)
    throw new RangeError(Ne(e));
  return r;
}
function hT(e) {
  const r = dr(he(e));
  if (!r || r.j)
    throw new RangeError(Ne(e));
  return st(Zv(r));
}
function al(e, r, i) {
  let a = dr(he(e));
  if (!a || a.j)
    throw new RangeError(Ne(e));
  return r ? a.calendar === In && (a = a.isoYear === -271821 && a.isoMonth === 4 ? {
    ...a,
    isoDay: 20,
    ...Be
  } : {
    ...a,
    isoDay: 1,
    ...Be
  }) : i && a.calendar === In && (a = {
    ...a,
    isoYear: Ft
  }), Ut(a.C ? Zv(a) : Hv(a));
}
function dT(e, r) {
  const i = sl(he(r));
  if (i)
    return ul(i), so(jf(jr(i)));
  const a = al(r, 1);
  return so(co(e(a.calendar), a));
}
function ul(e) {
  if (e.calendar !== In)
    throw new RangeError(Lt(e.calendar));
}
function gT(e, r) {
  const i = cl(he(r));
  if (i)
    return ul(i), Ua(jr(i));
  const a = al(r, 0, 1), { calendar: u } = a, c = e(u), [f, p, d] = c.v(a), [g, m] = c.q(f, p), [v, w] = c.G(g, m, d);
  return Ua(tt(c.V(v, w, d)), u);
}
function yT(e) {
  let r, i = ((a) => {
    const u = C2.exec(a);
    return u ? (lu(u[10]), Vv(u)) : void 0;
  })(he(e));
  if (!i) {
    if (i = dr(e), !i)
      throw new RangeError(Ne(e));
    if (!i.C)
      throw new RangeError(Ne(e));
    if (i.j)
      throw new RangeError(Lt("Z"));
    ul(i);
  }
  if ((r = sl(e)) && Zd(r))
    throw new RangeError(Ne(e));
  if ((r = cl(e)) && Zd(r))
    throw new RangeError(Ne(e));
  return Et(Ai(i, 1));
}
function vT(e) {
  const r = ((i) => {
    const a = L2.exec(i);
    return a ? ((u) => {
      function c(m, v, w) {
        let M = 0, E = 0;
        if (w && ([M, d] = Nt(d, _t[w])), m !== void 0) {
          if (p)
            throw new RangeError(Lt(m));
          E = ((x) => {
            const B = parseInt(x);
            if (!Number.isFinite(B))
              throw new RangeError(Lt(x));
            return B;
          })(m), f = 1, v && (d = ll(v) * (_t[w] / yt), p = 1);
        }
        return M + E;
      }
      let f = 0, p = 0, d = 0, g = {
        ...wi(Cn, [c(u[2]), c(u[3]), c(u[4]), c(u[5]), c(u[6], u[7], 5), c(u[8], u[9], 4), c(u[10], u[11], 3)]),
        ...Ja(d, 2, Cn)
      };
      if (!f)
        throw new RangeError(S0(Cn));
      return pl(u[1]) < 0 && (g = Ee(g)), g;
    })(a) : void 0;
  })(he(e));
  if (!r)
    throw new RangeError(Ne(e));
  return ee(Ur(r));
}
function mT(e) {
  const r = dr(e) || sl(e) || cl(e);
  return r ? r.calendar : e;
}
function _T(e) {
  const r = dr(e);
  return r && (r.timeZone || r.j && Yr || r.offset) || e;
}
function Gv(e, r, i = 0, a = 0) {
  const u = hl(e.timeZone), c = _n(u);
  let f;
  return Qa(e), f = e.C ? Oi(c, e, r, i, a, !c.$, e.j) : fr(c, e), ut(f, u, gu(e.calendar));
}
function Zv(e) {
  return Kv(Fe(Qa(e)));
}
function Hv(e) {
  return Kv(tt(jr(e)));
}
function Kv(e) {
  return {
    ...e,
    calendar: gu(e.calendar)
  };
}
function dr(e) {
  const r = M2.exec(e);
  return r ? ((i) => {
    const a = i[10], u = (a || "").toUpperCase() === "Z";
    return {
      isoYear: Jv(i),
      isoMonth: parseInt(i[4]),
      isoDay: parseInt(i[5]),
      ...Vv(i.slice(5)),
      ...lu(i[16]),
      C: !!i[6],
      j: u,
      offset: u ? void 0 : a
    };
  })(r) : void 0;
}
function sl(e) {
  const r = x2.exec(e);
  return r ? ((i) => ({
    isoYear: Jv(i),
    isoMonth: parseInt(i[4]),
    isoDay: 1,
    ...lu(i[5])
  }))(r) : void 0;
}
function cl(e) {
  const r = P2.exec(e);
  return r ? ((i) => ({
    isoYear: Ft,
    isoMonth: parseInt(i[1]),
    isoDay: parseInt(i[2]),
    ...lu(i[3])
  }))(r) : void 0;
}
function fl(e, r) {
  const i = D2.exec(e);
  return i ? ((a, u) => {
    const c = a[4] || a[5];
    if (u && c)
      throw new RangeError(Lt(c));
    return ((f) => {
      if (Math.abs(f) >= qn)
        throw new RangeError(BR);
      return f;
    })((di(a[2]) * mu + di(a[3]) * vu + di(a[4]) * yt + ll(a[5] || "")) * pl(a[1]));
  })(i, r) : void 0;
}
function Jv(e) {
  const r = pl(e[1]), i = parseInt(e[2] || e[3]);
  if (r < 0 && !i)
    throw new RangeError(Lt(-0));
  return r * i;
}
function Vv(e) {
  const r = di(e[3]);
  return {
    ...Va(ll(e[4] || ""))[0],
    isoHour: di(e[1]),
    isoMinute: di(e[2]),
    isoSecond: r === 60 ? 59 : r
  };
}
function lu(e) {
  let r, i;
  const a = [];
  if (e.replace(N2, ((u, c, f) => {
    const p = !!c, [d, g] = f.split("=").reverse();
    if (g) {
      if (g === "u-ca")
        a.push(d), r || (r = p);
      else if (p || /[A-Z]/.test(g))
        throw new RangeError(Lt(u));
    } else {
      if (i)
        throw new RangeError(Lt(u));
      i = d;
    }
    return "";
  })), a.length > 1 && r)
    throw new RangeError(Lt(e));
  return {
    timeZone: i,
    calendar: a[0] || In
  };
}
function ll(e) {
  return parseInt(e.padEnd(9, "0"));
}
function Ri(e) {
  return new RegExp(`^${e}$`, "i");
}
function pl(e) {
  return e && e !== "+" ? -1 : 1;
}
function di(e) {
  return e === void 0 ? 0 : parseInt(e);
}
function wT(e) {
  return hl(he(e));
}
function hl(e) {
  const r = dl(e);
  return typeof r == "number" ? _o(r) : r ? ((i) => {
    if (j2.test(i))
      throw new RangeError(x0(i));
    if (B2.test(i))
      throw new RangeError(FR);
    return i.toLowerCase().split("/").map(((a, u) => (a.length <= 3 || /\d/.test(a)) && !/etc|yap/.test(a) ? a.toUpperCase() : a.replace(/baja|dumont|[a-z]+/g, ((c, f) => c.length <= 2 && !u || c === "in" || c === "chat" ? c.toUpperCase() : c.length > 2 || !f ? $d(c).replace(/island|noronha|murdo|rivadavia|urville/, $d) : c)))).join("/");
  })(e) : Yr;
}
function lg(e) {
  const r = dl(e);
  return typeof r == "number" ? r : r ? r.resolvedOptions().timeZone : Yr;
}
function dl(e) {
  const r = fl(e = e.toUpperCase(), 1);
  return r !== void 0 ? r : e !== Yr ? F2(e) : void 0;
}
function Xv(e, r) {
  return He(e.epochNanoseconds, r.epochNanoseconds);
}
function Qv(e, r) {
  return He(e.epochNanoseconds, r.epochNanoseconds);
}
function bT(e, r, i, a, u, c) {
  const f = e(bt(c).relativeTo), p = Math.max(Lr(a), Lr(u));
  if (lv(Cn, a, u))
    return 0;
  if (fo(p, f))
    return He(ue(a), ue(u));
  if (!f)
    throw new RangeError(yu);
  const [d, g, m] = su(r, i, f), v = rl(m), w = cu(m);
  return He(v(w(g, d, a)), v(w(g, d, u)));
}
function n0(e, r) {
  return Ii(e, r) || gl(e, r);
}
function Ii(e, r) {
  return ir(we(e), we(r));
}
function gl(e, r) {
  return ir(sr(e), sr(r));
}
function ET(e, r) {
  return !Xv(e, r);
}
function AT(e, r) {
  return !Qv(e, r) && !!e0(e.timeZone, r.timeZone) && e.calendar === r.calendar;
}
function ST(e, r) {
  return !n0(e, r) && e.calendar === r.calendar;
}
function OT(e, r) {
  return !Ii(e, r) && e.calendar === r.calendar;
}
function TT(e, r) {
  return !Ii(e, r) && e.calendar === r.calendar;
}
function RT(e, r) {
  return !Ii(e, r) && e.calendar === r.calendar;
}
function IT(e, r) {
  return !gl(e, r);
}
function e0(e, r) {
  if (e === r)
    return 1;
  try {
    return lg(e) === lg(r);
  } catch {
  }
}
function pg(e, r, i, a) {
  const u = Si(e, a, 3, 5), c = pu(r.epochNanoseconds, i.epochNanoseconds, ...u);
  return ee(e ? Ee(c) : c);
}
function hg(e, r, i, a, u, c) {
  const f = du(a.calendar, u.calendar), [p, d, g, m] = Si(i, c, 5), v = a.epochNanoseconds, w = u.epochNanoseconds, M = He(w, v);
  let E;
  if (M)
    if (p < 6)
      E = pu(v, w, p, d, g, m);
    else {
      const x = r(((A, R) => {
        if (!e0(A, R))
          throw new RangeError(P0);
        return A;
      })(a.timeZone, u.timeZone)), B = e(f);
      E = r0(B, x, a, u, M, p, c), E = iu(E, w, p, d, g, m, B, a, Cv, Tn(el, x));
    }
  else
    E = se;
  return ee(i ? Ee(E) : E);
}
function dg(e, r, i, a, u) {
  const c = du(i.calendar, a.calendar), [f, p, d, g] = Si(r, u, 6), m = ae(i), v = ae(a), w = He(v, m);
  let M;
  if (w)
    if (f <= 6)
      M = pu(m, v, f, p, d, g);
    else {
      const E = e(c);
      M = i0(E, i, a, w, f, u), M = iu(M, v, f, p, d, g, E, i, ae, tl);
    }
  else
    M = se;
  return ee(r ? Ee(M) : M);
}
function gg(e, r, i, a, u) {
  const c = du(i.calendar, a.calendar);
  return t0(r, (() => e(c)), i, a, ...Si(r, u, 6, 9, 6));
}
function yg(e, r, i, a, u) {
  const c = du(i.calendar, a.calendar), f = Si(r, u, 9, 9, 8), p = e(c), d = co(p, i), g = co(p, a);
  return d.isoYear === g.isoYear && d.isoMonth === g.isoMonth && d.isoDay === g.isoDay ? ee(se) : t0(r, (() => p), tt(d), tt(g), ...f, 8);
}
function t0(e, r, i, a, u, c, f, p, d = 6) {
  const g = ae(i), m = ae(a);
  if (g === void 0 || m === void 0)
    throw new RangeError(mr);
  let v;
  if (He(m, g))
    if (u === 6)
      v = pu(g, m, u, c, f, p);
    else {
      const w = r();
      v = w.N(i, a, u), c === d && f === 1 || (v = iu(v, m, u, c, f, p, w, i, ae, uu));
    }
  else
    v = se;
  return ee(e ? Ee(v) : v);
}
function vg(e, r, i, a) {
  const [u, c, f, p] = Si(e, a, 5, 5), d = cr(yl(r, i), mo(c, f), p), g = {
    ...se,
    ...fu(d, u)
  };
  return ee(e ? Ee(g) : g);
}
function xT(e, r, i, a, u, c) {
  const f = He(a.epochNanoseconds, i.epochNanoseconds);
  return f ? u < 6 ? o0(i.epochNanoseconds, a.epochNanoseconds, u) : r0(r, e, i, a, f, u, c) : se;
}
function PT(e, r, i, a, u) {
  const c = ae(r), f = ae(i), p = He(f, c);
  return p ? a <= 6 ? o0(c, f, a) : i0(e, r, i, p, a, u) : se;
}
function r0(e, r, i, a, u, c, f) {
  const [p, d, g] = ((w, M, E, x) => {
    function B() {
      return j = {
        ...qr(D, P++ * -x),
        ...R
      }, z = wo(w, j), He(S, z) === -x;
    }
    const A = Je(M, w), R = at(ct, A), D = Je(E, w), S = E.epochNanoseconds;
    let P = 0;
    const L = yl(A, D);
    let j, z;
    if (Math.sign(L) === -x && P++, B() && (x === -1 || B()))
      throw new RangeError(xi);
    const Z = mt(vt(z, S));
    return [A, j, Z];
  })(r, i, a, u);
  var m, v;
  return {
    ...c === 6 ? (m = p, v = d, {
      ...se,
      days: a0(m, v)
    }) : e.N(p, d, c, f),
    ...fu(g)
  };
}
function i0(e, r, i, a, u, c) {
  const [f, p, d] = ((g, m, v) => {
    let w = m, M = yl(g, m);
    return Math.sign(M) === -v && (w = qr(m, -v), M += qn * v), [g, w, M];
  })(r, i, a);
  return {
    ...e.N(f, p, u, c),
    ...fu(d)
  };
}
function pu(e, r, i, a, u, c) {
  return {
    ...se,
    ...Ti(ou(vt(e, r), a, u, c), i)
  };
}
function o0(e, r, i) {
  return {
    ...se,
    ...Ti(vt(e, r), i)
  };
}
function a0(e, r) {
  return hu(we(e), we(r));
}
function hu(e, r) {
  return Math.trunc((r - e) / Le);
}
function yl(e, r) {
  return sr(r) - sr(e);
}
function du(e, r) {
  if (e !== r)
    throw new RangeError(I0);
  return e;
}
function u0(e) {
  return this.m(e)[0];
}
function s0(e) {
  return this.m(e)[1];
}
function vl(e) {
  const [r] = this.v(e);
  return hu(this.p(r), we(e)) + 1;
}
function ml(e) {
  const r = q2.exec(e);
  if (!r)
    throw new RangeError(NR(e));
  return [parseInt(r[1]), !!r[2]];
}
function bo(e, r) {
  return "M" + rt(e) + (r ? "L" : "");
}
function Ya(e, r, i) {
  return e + (r || i && e >= i ? 1 : 0);
}
function _l(e, r) {
  return e - (r && e >= r ? 1 : 0);
}
function c0(e, r) {
  return (r + e) * (Math.sign(r) || 1) || 0;
}
function mf(e) {
  return q0[l0(e)];
}
function f0(e) {
  return VR[l0(e)];
}
function l0(e) {
  return Fr(e.id || In);
}
function MT(e) {
  function r(u) {
    return ((c, f) => ({
      ...p0(c, f),
      o: c.month,
      day: parseInt(c.day)
    }))(Uf(i, u), a);
  }
  const i = Yl(e), a = Fr(e);
  return {
    id: e,
    h: CT(r),
    l: DT(r)
  };
}
function CT(e) {
  return Ze(((r) => {
    const i = we(r);
    return e(i);
  }), WeakMap);
}
function DT(e) {
  const r = e(0).year - u2;
  return Ze(((i) => {
    let a, u = bi(i - r), c = 0;
    const f = [], p = [];
    do
      u += 400 * Le;
    while ((a = e(u)).year <= i);
    do
      if (u += (1 - a.day) * Le, a.year === i && (f.push(u), p.push(a.o)), u -= Le, ++c > 100 || u < -Dl)
        throw new RangeError(xi);
    while ((a = e(u)).year >= i);
    return {
      i: f.reverse(),
      u: M0(p.reverse())
    };
  }));
}
function p0(e, r) {
  let i, a, u = h0(e);
  if (e.era) {
    const c = q0[r], f = U0[r] || {};
    c !== void 0 && (i = r === "islamic" ? "ah" : e.era.normalize("NFD").toLowerCase().replace(/[^a-z0-9]/g, ""), i === "bc" || i === "b" ? i = "bce" : i === "ad" || i === "a" ? i = "ce" : i === "beforeroc" && (i = "broc"), i = f[i] || i, a = u, u = c0(a, c[i] || 0));
  }
  return {
    era: i,
    eraYear: a,
    year: u
  };
}
function h0(e) {
  return parseInt(e.relatedYear || e.year);
}
function $a(e) {
  const { year: r, o: i, day: a } = this.h(e), { u } = this.l(r);
  return [r, u[i] + 1, a];
}
function lo(e, r = 1, i = 1) {
  return this.l(e).i[r - 1] + (i - 1) * Le;
}
function d0(e, r) {
  const i = Na.call(this, e);
  return [_l(r, i), i === r];
}
function Na(e) {
  const r = _g(this, e), i = _g(this, e - 1), a = r.length;
  if (a > i.length) {
    const u = f0(this);
    if (u < 0)
      return -u;
    for (let c = 0; c < a; c++)
      if (r[c] !== i[c])
        return c + 1;
  }
}
function Ta(e) {
  return hu(lo.call(this, e), lo.call(this, e + 1));
}
function mg(e, r) {
  const { i } = this.l(e);
  let a = r + 1, u = i;
  return a > i.length && (a = 1, u = this.l(e + 1).i), hu(i[r - 1], u[a - 1]);
}
function Ra(e) {
  return this.l(e).i.length;
}
function g0(e) {
  const r = this.h(e);
  return [r.era, r.eraYear];
}
function _g(e, r) {
  return Object.keys(e.l(r).u);
}
function Eo(e) {
  return gu(he(e));
}
function gu(e) {
  if ((e = e.toLowerCase()) !== In && e !== Pi) {
    const r = Yl(e).resolvedOptions().calendar;
    if (Fr(e) !== Fr(r))
      throw new RangeError(R0(e));
    return r;
  }
  return e;
}
function Fr(e) {
  return e === "islamicc" && (e = "islamic"), e.split("-")[0];
}
function y0(e, r) {
  return (i) => i === In ? e : i === Pi || i === lr ? Object.assign(Object.create(e), {
    id: i
  }) : Object.assign(Object.create(r), U2(i));
}
function NT(e, r, i, a) {
  const u = gr(i, a, Yt, [], L0);
  if (u.timeZone !== void 0) {
    const c = i.F(u), f = Ao(u), p = e(u.timeZone);
    return {
      epochNanoseconds: Oi(r(p), {
        ...c,
        ...f
      }, u.offset !== void 0 ? kr(u.offset) : void 0),
      timeZone: p
    };
  }
  return {
    ...i.F(u),
    ...Be
  };
}
function LT(e, r, i, a, u, c) {
  const f = gr(i, u, Yt, D0, L0), p = e(f.timeZone), [d, g, m] = nu(c), v = i.F(f, ru(d)), w = Ao(f, d);
  return ut(Oi(r(p), {
    ...v,
    ...w
  }, f.offset !== void 0 ? kr(f.offset) : void 0, g, m), p, a);
}
function FT(e, r, i) {
  const a = gr(e, r, Yt, [], Wt), u = Pn(i);
  return st(Fe({
    ...e.F(a, ru(u)),
    ...Ao(a, u)
  }));
}
function BT(e, r, i, a = []) {
  const u = gr(e, r, Yt, a);
  return e.F(u, i);
}
function jT(e, r, i, a) {
  const u = gr(e, r, Tl, a);
  return e.K(u, i);
}
function qT(e, r, i, a) {
  const u = gr(e, i, Yt, Oo);
  return r && u.month !== void 0 && u.monthCode === void 0 && u.year === void 0 && (u.year = Ft), e._(u, a);
}
function UT(e, r) {
  return Et(Ao(Ke(e, Ef, [], 1), Pn(r)));
}
function kT(e) {
  const r = Ke(e, Rl);
  return ee(Ur({
    ...se,
    ...r
  }));
}
function gr(e, r, i, a = [], u = []) {
  return Ke(r, [...e.fields(i), ...u].sort(), a);
}
function Ke(e, r, i, a = !i) {
  const u = {};
  let c, f = 0;
  for (const p of r) {
    if (p === c)
      throw new RangeError(TR(p));
    if (p === "constructor" || p === "__proto__")
      throw new RangeError(OR(p));
    let d = e[p];
    if (d !== void 0)
      f = 1, bg[p] && (d = bg[p](d, p)), u[p] = d;
    else if (i) {
      if (i.includes(p))
        throw new TypeError(bl(p));
      u[p] = j0[p];
    }
    c = p;
  }
  if (a && !f)
    throw new TypeError(S0(r));
  return u;
}
function Ao(e, r) {
  return Ai($l({
    ...j0,
    ...e
  }), r);
}
function WT(e, r, i, a, u) {
  const { calendar: c, timeZone: f } = i, p = e(c), d = r(f), g = [...p.fields(Yt), ...N0].sort(), m = ((A) => {
    const R = Je(A, _n), D = _o(R.offsetNanoseconds), S = bu(A.calendar), [P, L, j] = S.v(R), [z, Z] = S.q(P, L), J = bo(z, Z);
    return {
      ...H2(R),
      year: P,
      monthCode: J,
      day: j,
      offset: D
    };
  })(i), v = Ke(a, g), w = p.k(m, v), M = {
    ...m,
    ...v
  }, [E, x, B] = nu(u, 2);
  return ut(Oi(d, {
    ...p.F(w, ru(E)),
    ...Ai($l(M), E)
  }, kr(M.offset), x, B), f, c);
}
function YT(e, r, i, a) {
  const u = e(r.calendar), c = [...u.fields(Yt), ...Wt].sort(), f = {
    ...m0(p = r),
    hour: p.isoHour,
    minute: p.isoMinute,
    second: p.isoSecond,
    millisecond: p.isoMillisecond,
    microsecond: p.isoMicrosecond,
    nanosecond: p.isoNanosecond
  };
  var p;
  const d = Ke(i, c), g = Pn(a), m = u.k(f, d), v = {
    ...f,
    ...d
  };
  return st(Fe({
    ...u.F(m, ru(g)),
    ...Ai($l(v), g)
  }));
}
function $T(e, r, i, a) {
  const u = e(r.calendar), c = u.fields(Yt).sort(), f = m0(r), p = Ke(i, c), d = u.k(f, p);
  return u.F(d, a);
}
function zT(e, r, i, a) {
  const u = e(r.calendar), c = u.fields(Tl).sort(), f = ((g) => {
    const m = bu(g.calendar), [v, w] = m.v(g), [M, E] = m.q(v, w);
    return {
      year: v,
      monthCode: bo(M, E)
    };
  })(r), p = Ke(i, c), d = u.k(f, p);
  return u.K(d, a);
}
function GT(e, r, i, a) {
  const u = e(r.calendar), c = u.fields(Yt).sort(), f = ((g) => {
    const m = bu(g.calendar), [v, w, M] = m.v(g), [E, x] = m.q(v, w);
    return {
      monthCode: bo(E, x),
      day: M
    };
  })(r), p = Ke(i, c), d = u.k(f, p);
  return u._(d, a);
}
function ZT(e, r, i) {
  return Et(((a, u, c) => Ao({
    ...at(Ef, a),
    ...Ke(u, Ef)
  }, Pn(c)))(e, r, i));
}
function HT(e, r) {
  return ee((i = e, a = r, Ur({
    ...i,
    ...Ke(a, Rl)
  })));
  var i, a;
}
function v0(e, r, i, a, u) {
  r = at(i = e.fields(i), r), a = Ke(a, u = e.fields(u), []);
  let c = e.k(r, a);
  return c = Ke(c, [...i, ...u].sort(), []), e.F(c);
}
function Ks(e, r) {
  const i = mf(e), a = U0[e.id || ""] || {};
  let { era: u, eraYear: c, year: f } = r;
  if (u !== void 0 || c !== void 0) {
    if (u === void 0 || c === void 0)
      throw new TypeError(PR);
    if (!i)
      throw new RangeError(xR);
    const p = i[a[u] || u];
    if (p === void 0)
      throw new RangeError(CR(u));
    const d = c0(c, p);
    if (f !== void 0 && f !== d)
      throw new RangeError(MR);
    f = d;
  } else if (f === void 0)
    throw new TypeError(DR(i));
  return f;
}
function Ia(e, r, i, a) {
  let { month: u, monthCode: c } = r;
  if (c !== void 0) {
    const f = ((p, d, g, m) => {
      const v = p.L(g), [w, M] = ml(d);
      let E = Ya(w, M, v);
      if (M) {
        const x = f0(p);
        if (x === void 0)
          throw new RangeError(no);
        if (x > 0) {
          if (E > x)
            throw new RangeError(no);
          if (v === void 0) {
            if (m === 1)
              throw new RangeError(no);
            E--;
          }
        } else {
          if (E !== -x)
            throw new RangeError(no);
          if (v === void 0 && m === 1)
            throw new RangeError(no);
        }
      }
      return E;
    })(e, c, i, a);
    if (u !== void 0 && u !== f)
      throw new RangeError(LR);
    u = f, a = 1;
  } else if (u === void 0)
    throw new TypeError(T0);
  return Bt("month", u, 1, e.B(i), a);
}
function Js(e, r, i, a, u) {
  return De(r, "day", 1, e.U(a, i), u);
}
function Vs(e, r, i, a) {
  let u = 0;
  const c = [];
  for (const f of i)
    r[f] !== void 0 ? u = 1 : c.push(f);
  if (Object.assign(e, r), u)
    for (const f of a || c)
      delete e[f];
}
function m0(e) {
  const r = bu(e.calendar), [i, a, u] = r.v(e), [c, f] = r.q(i, a);
  return {
    year: i,
    monthCode: bo(c, f),
    day: u
  };
}
function KT(e) {
  return qt(wt(Ff(Df(e))));
}
function JT(e, r, i, a, u = In) {
  return ut(wt(Ff(Df(i))), r(a), e(u));
}
function VT(e, r, i, a, u = 0, c = 0, f = 0, p = 0, d = 0, g = 0, m = In) {
  return st(Fe(Qa(jt(_e, wi(_u, [r, i, a, u, c, f, p, d, g])))), e(m));
}
function XT(e, r, i, a, u = In) {
  return Ut(tt(jr(jt(_e, {
    isoYear: r,
    isoMonth: i,
    isoDay: a
  }))), e(u));
}
function QT(e, r, i, a = In, u = 1) {
  const c = _e(r), f = _e(i), p = e(a);
  return so(jf(jr({
    isoYear: c,
    isoMonth: f,
    isoDay: _e(u)
  })), p);
}
function nR(e, r, i, a = In, u = Ft) {
  const c = _e(r), f = _e(i), p = e(a);
  return Ua(tt(jr({
    isoYear: _e(u),
    isoMonth: c,
    isoDay: f
  })), p);
}
function eR(e = 0, r = 0, i = 0, a = 0, u = 0, c = 0) {
  return Et(Ai(jt(_e, wi(ct, [e, r, i, a, u, c])), 1));
}
function tR(e = 0, r = 0, i = 0, a = 0, u = 0, c = 0, f = 0, p = 0, d = 0, g = 0) {
  return ee(Ur(jt(Nf, wi(Cn, [e, r, i, a, u, c, f, p, d, g]))));
}
function rR(e, r, i = In) {
  return ut(e.epochNanoseconds, r, i);
}
function iR(e) {
  return qt(e.epochNanoseconds);
}
function _0(e, r) {
  return st(Je(r, e));
}
function w0(e, r) {
  return Ut(Je(r, e));
}
function b0(e, r) {
  return Et(Je(r, e));
}
function oR(e, r, i, a) {
  const u = ((c, f, p, d) => {
    const g = ((m) => H0(bt(m)))(d);
    return wo(c(f), p, g);
  })(e, i, r, a);
  return ut(wt(u), i, r.calendar);
}
function aR(e, r, i, a, u) {
  const c = e(u.timeZone), f = u.plainTime, p = f !== void 0 ? r(f) : void 0, d = i(c);
  let g;
  return g = p ? wo(d, {
    ...a,
    ...p
  }) : fr(d, {
    ...a,
    ...Be
  }), ut(g, c, a.calendar);
}
function uR(e, r = Be) {
  return st(Fe({
    ...e,
    ...r
  }));
}
function sR(e, r, i) {
  return ((a, u) => {
    const c = gr(a, u, F0);
    return a.K(c, void 0);
  })(e(r.calendar), i);
}
function cR(e, r, i) {
  return ((a, u) => {
    const c = gr(a, u, B0);
    return a._(c);
  })(e(r.calendar), i);
}
function fR(e, r, i, a) {
  return ((u, c, f) => v0(u, c, F0, vo(f), Oo))(e(r.calendar), i, a);
}
function lR(e, r, i, a) {
  return ((u, c, f) => v0(u, c, B0, vo(f), Al))(e(r.calendar), i, a);
}
function pR(e) {
  return qt(wt(ja(Nf(e), kt)));
}
function hR(e) {
  return qt(wt(Ff(Df(e))));
}
function Wr(e, r, i) {
  const a = new Set(i);
  return (u, c) => {
    const f = i && Yd(u, i);
    if (!Yd(u = ((p, d) => {
      const g = {};
      for (const m in d)
        p.has(m) || (g[m] = d[m]);
      return g;
    })(a, u), e)) {
      if (c && f)
        throw new TypeError("Invalid formatting options");
      u = {
        ...r,
        ...u
      };
    }
    return i && (u.timeZone = Yr, ["full", "long"].includes(u.J) && (u.J = "medium")), u;
  };
}
function yr(e, r = E0, i = 0) {
  const [a, , , u] = e;
  return (c, f = hI, ...p) => {
    const d = r(u && u(...p), c, f, a, i), g = d.resolvedOptions();
    return [d, ...dR(e, g, p)];
  };
}
function E0(e, r, i, a, u) {
  if (i = a(i, u), e) {
    if (i.timeZone !== void 0)
      throw new TypeError(ZR);
    i.timeZone = e;
  }
  return new or(r, i);
}
function dR(e, r, i) {
  const [, a, u] = e;
  return i.map(((c) => (c.calendar && ((f, p, d) => {
    if ((d || f !== In) && f !== p)
      throw new RangeError(I0);
  })(c.calendar, r.calendar, u), a(c, r))));
}
function gR(e, r, i) {
  const a = r.timeZone, u = e(a), c = {
    ...Je(r, u),
    ...i || Be
  };
  let f;
  return f = i ? Oi(u, c, c.offsetNanoseconds, 2) : fr(u, c), ut(f, a, r.calendar);
}
function yR(e, r = Be) {
  return st(Fe({
    ...e,
    ...r
  }));
}
function wl(e, r) {
  return {
    ...e,
    calendar: r
  };
}
function vR(e, r) {
  return {
    ...e,
    timeZone: r
  };
}
function Xs(e) {
  const r = _f();
  return Ei(r, e.R(r));
}
function _f() {
  return ja(Date.now(), kt);
}
function Qi() {
  return Eg || (Eg = new or().resolvedOptions().timeZone);
}
const mR = (e, r) => `Non-integer ${e}: ${r}`, _R = (e, r) => `Non-positive ${e}: ${r}`, wR = (e, r) => `Non-finite ${e}: ${r}`, bR = (e) => `Cannot convert bigint to ${e}`, ER = (e) => `Invalid bigint: ${e}`, AR = "Cannot convert Symbol to string", SR = "Invalid object", A0 = (e, r, i, a, u) => u ? A0(e, u[r], u[i], u[a]) : vr(e, r) + `; must be between ${i}-${a}`, vr = (e, r) => `Invalid ${e}: ${r}`, bl = (e) => `Missing ${e}`, OR = (e) => `Invalid field ${e}`, TR = (e) => `Duplicate field ${e}`, S0 = (e) => "No valid fields: " + e.join(), RR = "Invalid bag", O0 = (e, r, i) => vr(e, r) + "; must be " + Object.keys(i).join(), IR = "Cannot use valueOf", wf = "Invalid calling context", xR = "Forbidden era/eraYear", PR = "Mismatching era/eraYear", MR = "Mismatching year/eraYear", CR = (e) => `Invalid era: ${e}`, DR = (e) => "Missing year" + (e ? "/era/eraYear" : ""), NR = (e) => `Invalid monthCode: ${e}`, LR = "Mismatching month/monthCode", T0 = "Missing month/monthCode", no = "Invalid leap month", xi = "Invalid protocol results", R0 = (e) => vr("Calendar", e), I0 = "Mismatching Calendars", x0 = (e) => vr("TimeZone", e), P0 = "Mismatching TimeZones", FR = "Forbidden ICU TimeZone", BR = "Out-of-bounds offset", jR = "Out-of-bounds TimeZone gap", qR = "Invalid TimeZone offset", UR = "Ambiguous offset", mr = "Out-of-bounds date", kR = "Out-of-bounds duration", WR = "Cannot mix duration signs", yu = "Missing relativeTo", YR = "Cannot use large units", $R = "Required smallestUnit or largestUnit", zR = "smallestUnit > largestUnit", Ne = (e) => `Cannot parse: ${e}`, Lt = (e) => `Invalid substring: ${e}`, GR = (e) => `Cannot format ${e}`, Qs = "Mismatching types for formatting", ZR = "Cannot specify TimeZone", M0 = /* @__PURE__ */ Tn(Ha, ((e, r) => r)), mi = /* @__PURE__ */ Tn(Ha, ((e, r, i) => i)), rt = /* @__PURE__ */ Tn(Ba, 2), bf = {
  nanosecond: 0,
  microsecond: 1,
  millisecond: 2,
  second: 3,
  minute: 4,
  hour: 5,
  day: 6,
  week: 7,
  month: 8,
  year: 9
}, El = /* @__PURE__ */ Object.keys(bf), Le = 864e5, C0 = 1e3, So = 1e3, kt = 1e6, yt = 1e9, vu = 6e10, mu = 36e11, qn = 864e11, _t = [1, So, kt, yt, vu, mu, qn], Wt = /* @__PURE__ */ El.slice(0, 6), Ef = /* @__PURE__ */ yo(Wt), HR = ["offset"], D0 = ["timeZone"], N0 = /* @__PURE__ */ Wt.concat(HR), L0 = /* @__PURE__ */ N0.concat(D0), Af = ["era", "eraYear"], KR = /* @__PURE__ */ Af.concat(["year"]), Al = ["year"], Sl = ["monthCode"], Ol = /* @__PURE__ */ ["month"].concat(Sl), Oo = ["day"], Tl = /* @__PURE__ */ Ol.concat(Al), F0 = /* @__PURE__ */ Sl.concat(Al), Yt = /* @__PURE__ */ Oo.concat(Tl), JR = /* @__PURE__ */ Oo.concat(Ol), B0 = /* @__PURE__ */ Oo.concat(Sl), j0 = /* @__PURE__ */ mi(Wt, 0), In = "iso8601", Pi = "gregory", lr = "japanese", q0 = {
  [Pi]: {
    "gregory-inverse": -1,
    gregory: 0
  },
  [lr]: {
    "japanese-inverse": -1,
    japanese: 0,
    meiji: 1867,
    taisho: 1911,
    showa: 1925,
    heisei: 1988,
    reiwa: 2018
  },
  ethiopic: {
    ethioaa: 0,
    ethiopic: 5500
  },
  coptic: {
    "coptic-inverse": -1,
    coptic: 0
  },
  roc: {
    "roc-inverse": -1,
    roc: 0
  },
  buddhist: {
    be: 0
  },
  islamic: {
    ah: 0
  },
  indian: {
    saka: 0
  },
  persian: {
    ap: 0
  }
}, U0 = {
  [Pi]: {
    bce: "gregory-inverse",
    ce: "gregory"
  },
  [lr]: {
    bce: "japanese-inverse",
    ce: "japanese"
  },
  ethiopic: {
    era0: "ethioaa",
    era1: "ethiopic"
  },
  coptic: {
    era0: "coptic-inverse",
    era1: "coptic"
  },
  roc: {
    broc: "roc-inverse",
    minguo: "roc"
  }
}, VR = {
  chinese: 13,
  dangi: 13,
  hebrew: -6
}, he = /* @__PURE__ */ Tn(Mf, "string"), XR = /* @__PURE__ */ Tn(Mf, "boolean"), QR = /* @__PURE__ */ Tn(Mf, "number"), Cn = /* @__PURE__ */ El.map(((e) => e + "s")), Rl = /* @__PURE__ */ yo(Cn), n2 = /* @__PURE__ */ Cn.slice(0, 6), k0 = /* @__PURE__ */ Cn.slice(6), e2 = /* @__PURE__ */ k0.slice(1), t2 = /* @__PURE__ */ M0(Cn), se = /* @__PURE__ */ mi(Cn, 0), Il = /* @__PURE__ */ mi(n2, 0), xl = /* @__PURE__ */ Tn(pv, Cn), ct = ["isoNanosecond", "isoMicrosecond", "isoMillisecond", "isoSecond", "isoMinute", "isoHour"], Pl = ["isoDay", "isoMonth", "isoYear"], _u = /* @__PURE__ */ ct.concat(Pl), Ml = /* @__PURE__ */ yo(Pl), W0 = /* @__PURE__ */ yo(ct), r2 = /* @__PURE__ */ yo(_u), Be = /* @__PURE__ */ mi(W0, 0), i2 = /* @__PURE__ */ Tn(pv, _u), Cl = 1e8, Dl = Cl * Le, o2 = [Cl, 0], a2 = [-Cl, 0], po = 275760, ho = -271821, or = Intl.DateTimeFormat, Y0 = "en-GB", u2 = 1970, Ft = 1972, nr = 12, s2 = /* @__PURE__ */ bi(1868, 9, 8), c2 = /* @__PURE__ */ Ze($O, WeakMap), za = "smallestUnit", Sf = "unit", oo = "roundingIncrement", nc = "fractionalSecondDigits", $0 = "relativeTo", ec = "direction", z0 = {
  constrain: 0,
  reject: 1
}, f2 = /* @__PURE__ */ Object.keys(z0), l2 = {
  compatible: 0,
  reject: 1,
  earlier: 2,
  later: 3
}, p2 = {
  reject: 0,
  use: 1,
  prefer: 2,
  ignore: 3
}, h2 = {
  auto: 0,
  never: 1,
  critical: 2,
  always: 3
}, d2 = {
  auto: 0,
  never: 1,
  critical: 2
}, g2 = {
  auto: 0,
  never: 1
}, y2 = {
  floor: 0,
  halfFloor: 1,
  ceil: 2,
  halfCeil: 3,
  trunc: 4,
  halfTrunc: 5,
  expand: 6,
  halfExpand: 7,
  halfEven: 8
}, v2 = {
  previous: -1,
  next: 1
}, To = /* @__PURE__ */ Tn(Zf, za), G0 = /* @__PURE__ */ Tn(Zf, "largestUnit"), m2 = /* @__PURE__ */ Tn(Zf, Sf), Z0 = /* @__PURE__ */ Tn(pr, "overflow", z0), H0 = /* @__PURE__ */ Tn(pr, "disambiguation", l2), _2 = /* @__PURE__ */ Tn(pr, "offset", p2), Nl = /* @__PURE__ */ Tn(pr, "calendarName", h2), w2 = /* @__PURE__ */ Tn(pr, "timeZoneName", d2), b2 = /* @__PURE__ */ Tn(pr, "offset", g2), Ro = /* @__PURE__ */ Tn(pr, "roundingMode", y2), Ll = "PlainYearMonth", Fl = "PlainMonthDay", Io = "PlainDate", Mi = "PlainDateTime", Bl = "PlainTime", _r = "ZonedDateTime", jl = "Instant", ql = "Duration", E2 = [Math.floor, (e) => Oa(e) ? Math.floor(e) : Math.round(e), Math.ceil, (e) => Oa(e) ? Math.ceil(e) : Math.round(e), Math.trunc, (e) => Oa(e) ? Math.trunc(e) || 0 : Math.round(e), (e) => e < 0 ? Math.floor(e) : Math.ceil(e), (e) => Math.sign(e) * Math.round(Math.abs(e)) || 0, (e) => Oa(e) ? (e = Math.trunc(e) || 0) + e % 2 : Math.round(e)], Yr = "UTC", La = 5184e3, A2 = /* @__PURE__ */ qa(1847), S2 = /* @__PURE__ */ qa(/* @__PURE__ */ (/* @__PURE__ */ new Date()).getUTCFullYear() + 10), O2 = /0+$/, Je = /* @__PURE__ */ Ze(oT, WeakMap), wg = 2 ** 32 - 1, _n = /* @__PURE__ */ Ze(((e) => {
  const r = dl(e);
  return typeof r == "object" ? new R2(r) : new T2(r || 0);
}));
class T2 {
  constructor(r) {
    this.$ = r;
  }
  R() {
    return this.$;
  }
  I(r) {
    return ((i) => {
      const a = ae({
        ...i,
        ...Be
      });
      if (!a || Math.abs(a[0]) > 1e8)
        throw new RangeError(mr);
    })(r), [qf(r, this.$)];
  }
  O() {
  }
}
class R2 {
  constructor(r) {
    this.nn = ((i) => {
      function a(g) {
        const m = uo(g, p, d), [v, w] = fg(m), M = c(v), E = c(w);
        return M === E ? M : u(f(v, w), M, E, g);
      }
      function u(g, m, v, w) {
        let M, E;
        for (; (w === void 0 || (M = w < g[0] ? m : w >= g[1] ? v : void 0) === void 0) && (E = g[1] - g[0]); ) {
          const x = g[0] + Math.floor(E / 2);
          i(x) === v ? g[1] = x : g[0] = x + 1;
        }
        return M;
      }
      const c = Ze(i), f = Ze(cT);
      let p = A2, d = S2;
      return {
        tn(g) {
          const m = a(g - 86400), v = a(g + 86400), w = g - m, M = g - v;
          if (m === v)
            return [w];
          const E = a(w);
          return E === a(M) ? [g - E] : m > v ? [w, M] : [];
        },
        rn: a,
        O(g, m) {
          const v = uo(g, p, d);
          let [w, M] = fg(v);
          const E = La * m, x = m < 0 ? () => M > p || (p = v, 0) : () => w < d || (d = v, 0);
          for (; x(); ) {
            const B = c(w), A = c(M);
            if (B !== A) {
              const R = f(w, M);
              u(R, B, A);
              const D = R[0];
              if ((ir(D, g) || 1) === m)
                return D;
            }
            w += E, M += E;
          }
        }
      };
    })(/* @__PURE__ */ ((i) => (a) => {
      const u = Uf(i, a * C0);
      return qa(h0(u), parseInt(u.month), parseInt(u.day), parseInt(u.hour), parseInt(u.minute), parseInt(u.second)) - a;
    })(r));
  }
  R(r) {
    return this.nn.rn(((i) => Gd(i)[0])(r)) * yt;
  }
  I(r) {
    const [i, a] = [qa((u = r).isoYear, u.isoMonth, u.isoDay, u.isoHour, u.isoMinute, u.isoSecond), u.isoMillisecond * kt + u.isoMicrosecond * So + u.isoNanosecond];
    var u;
    return this.nn.tn(i).map(((c) => wt(Nr(ja(c, yt), a))));
  }
  O(r, i) {
    const [a, u] = Gd(r), c = this.nn.O(a + (i > 0 || u ? 1 : 0), i);
    if (c !== void 0)
      return ja(c, yt);
  }
}
const Ul = "([+-])", Fa = "(?:[.,](\\d{1,9}))?", K0 = `(?:(?:${Ul}(\\d{6}))|(\\d{4}))-?(\\d{2})`, kl = "(\\d{2})(?::?(\\d{2})(?::?(\\d{2})" + Fa + ")?)?", Wl = Ul + kl, I2 = K0 + "-?(\\d{2})(?:[T ]" + kl + "(Z|" + Wl + ")?)?", J0 = "\\[(!?)([^\\]]*)\\]", wu = `((?:${J0}){0,9})`, x2 = /* @__PURE__ */ Ri(K0 + wu), P2 = /* @__PURE__ */ Ri("(?:--)?(\\d{2})-?(\\d{2})" + wu), M2 = /* @__PURE__ */ Ri(I2 + wu), C2 = /* @__PURE__ */ Ri("T?" + kl + "(?:" + Wl + ")?" + wu), D2 = /* @__PURE__ */ Ri(Wl), N2 = /* @__PURE__ */ new RegExp(J0, "g"), L2 = /* @__PURE__ */ Ri(`${Ul}?P(\\d+Y)?(\\d+M)?(\\d+W)?(\\d+D)?(?:T(?:(\\d+)${Fa}H)?(?:(\\d+)${Fa}M)?(?:(\\d+)${Fa}S)?)?`), F2 = /* @__PURE__ */ Ze(((e) => new or(Y0, {
  timeZone: e,
  era: "short",
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric"
}))), B2 = /^(AC|AE|AG|AR|AS|BE|BS|CA|CN|CS|CT|EA|EC|IE|IS|JS|MI|NE|NS|PL|PN|PR|PS|SS|VS)T$/, j2 = /[^\w\/:+-]+/, q2 = /^M(\d{2})(L?)$/, U2 = /* @__PURE__ */ Ze(MT), Yl = /* @__PURE__ */ Ze(((e) => new or(Y0, {
  calendar: e,
  timeZone: Yr,
  era: "short",
  year: "numeric",
  month: "short",
  day: "numeric"
}))), V0 = {
  P(e, r, i) {
    const a = Pn(i);
    let u, { years: c, months: f, weeks: p, days: d } = r;
    if (d += ue(r, 5)[0], c || f)
      u = ((g, m, v, w, M) => {
        let [E, x, B] = g.v(m);
        if (v) {
          const [A, R] = g.q(E, x);
          E += v, x = Ya(A, R, g.L(E)), x = Bt("month", x, 1, g.B(E), M);
        }
        return w && ([E, x] = g.un(E, x, w)), B = Bt("day", B, 1, g.U(E, x), M), g.p(E, x, B);
      })(this, e, c, f, a);
    else {
      if (!p && !d)
        return e;
      u = we(e);
    }
    if (u === void 0)
      throw new RangeError(mr);
    return u += (7 * p + d) * Le, tt(Xa(u));
  },
  N(e, r, i) {
    if (i <= 7) {
      let d = 0, g = a0({
        ...e,
        ...Be
      }, {
        ...r,
        ...Be
      });
      return i === 7 && ([d, g] = ur(g, 7)), {
        ...se,
        weeks: d,
        days: g
      };
    }
    const a = this.v(e), u = this.v(r);
    let [c, f, p] = ((d, g, m, v, w, M, E) => {
      let x = w - g, B = M - m, A = E - v;
      if (x || B) {
        const R = Math.sign(x || B);
        let D = d.U(w, M), S = 0;
        if (Math.sign(A) === -R) {
          const P = D;
          [w, M] = d.un(w, M, -R), x = w - g, B = M - m, D = d.U(w, M), S = R < 0 ? -P : D;
        }
        if (A = E - Math.min(v, D) + S, x) {
          const [P, L] = d.q(g, m), [j, z] = d.q(w, M);
          if (B = j - P || Number(z) - Number(L), Math.sign(B) === -R) {
            const Z = R < 0 && -d.B(w);
            x = (w -= R) - g, B = M - Ya(P, L, d.L(w)) + (Z || d.B(w));
          }
        }
      }
      return [x, B, A];
    })(this, ...a, ...u);
    return i === 8 && (f += this.cn(c, a[0]), c = 0), {
      ...se,
      years: c,
      months: f,
      days: p
    };
  },
  F(e, r) {
    const i = Pn(r), a = Ks(this, e), u = Ia(this, e, a, i), c = Js(this, e, u, a, i);
    return Ut(tt(this.V(a, u, c)), this.id || In);
  },
  K(e, r) {
    const i = Pn(r), a = Ks(this, e), u = Ia(this, e, a, i);
    return so(jf(this.V(a, u, 1)), this.id || In);
  },
  _(e, r) {
    const i = Pn(r);
    let a, u, c, f = e.eraYear !== void 0 || e.year !== void 0 ? Ks(this, e) : void 0;
    const p = !this.id;
    if (f === void 0 && p && (f = Ft), f !== void 0) {
      const v = Ia(this, e, f, i);
      a = Js(this, e, v, f, i);
      const w = this.L(f);
      u = _l(v, w), c = v === w;
    } else {
      if (e.monthCode === void 0)
        throw new TypeError(T0);
      if ([u, c] = ml(e.monthCode), this.id && this.id !== Pi && this.id !== lr)
        if (this.id && Fr(this.id) === "coptic" && i === 0) {
          const v = c || u !== 13 ? 30 : 6;
          a = e.day, a = uo(a, 1, v);
        } else if (this.id && Fr(this.id) === "chinese" && i === 0) {
          const v = !c || u !== 1 && u !== 9 && u !== 10 && u !== 11 && u !== 12 ? 30 : 29;
          a = e.day, a = uo(a, 1, v);
        } else
          a = e.day;
      else
        a = Js(this, e, Ia(this, e, Ft, i), Ft, i);
    }
    const d = this.G(u, c, a);
    if (!d)
      throw new RangeError("Cannot guess year");
    const [g, m] = d;
    return Ua(tt(this.V(g, m, a)), this.id || In);
  },
  fields(e) {
    return mf(this) && e.includes("year") ? [...e, ...Af] : e;
  },
  k(e, r) {
    const i = Object.assign(/* @__PURE__ */ Object.create(null), e);
    return Vs(i, r, Ol), mf(this) && (Vs(i, r, KR), this.id === lr && Vs(i, r, JR, Af)), i;
  },
  inLeapYear(e) {
    const [r] = this.v(e);
    return this.sn(r);
  },
  monthsInYear(e) {
    const [r] = this.v(e);
    return this.B(r);
  },
  daysInMonth(e) {
    const [r, i] = this.v(e);
    return this.U(r, i);
  },
  daysInYear(e) {
    const [r] = this.v(e);
    return this.fn(r);
  },
  dayOfYear: vl,
  era(e) {
    return this.hn(e)[0];
  },
  eraYear(e) {
    return this.hn(e)[1];
  },
  monthCode(e) {
    const [r, i] = this.v(e), [a, u] = this.q(r, i);
    return bo(a, u);
  },
  dayOfWeek: Ov,
  daysInWeek() {
    return 7;
  }
}, k2 = {
  v: kf,
  hn: Tv,
  q: bv
}, W2 = {
  dayOfYear: vl,
  v: kf,
  p: bi
}, Y2 = /* @__PURE__ */ Object.assign({}, W2, {
  weekOfYear: u0,
  yearOfWeek: s0,
  m(e) {
    function r(M) {
      return (7 - M < a ? 7 : 0) - M;
    }
    function i(M) {
      const E = Sv(w + M), x = M || 1, B = r(io(d + E * x, 7));
      return m = (E + (B - g) * x) / 7;
    }
    const a = this.id ? 1 : 4, u = Ov(e), c = this.dayOfYear(e), f = io(u - 1, 7), p = c - 1, d = io(f - p, 7), g = r(d);
    let m, v = Math.floor((p - g) / 7) + 1, w = e.isoYear;
    return v ? v > i(0) && (v = 1, w++) : (v = i(-1), w--), [v, w, m];
  }
}), $2 = /* @__PURE__ */ Object.assign({}, V0, Y2, {
  v: kf,
  hn: Tv,
  q: bv,
  G(e, r) {
    if (!r)
      return [Ft, e];
  },
  sn: Wf,
  L() {
  },
  B: Ev,
  cn: (e) => e * nr,
  U: Av,
  fn: Sv,
  V: (e, r, i) => ({
    isoYear: e,
    isoMonth: r,
    isoDay: i
  }),
  p: bi,
  un: (e, r, i) => (e += Ka(i, nr), (r += xf(i, nr)) < 1 ? (e--, r += nr) : r > nr && (e++, r -= nr), [e, r]),
  year(e) {
    return e.isoYear;
  },
  month(e) {
    return e.isoMonth;
  },
  day: (e) => e.isoDay
}), z2 = {
  v: $a,
  hn: g0,
  q: d0
}, G2 = {
  dayOfYear: vl,
  v: $a,
  p: lo,
  weekOfYear: u0,
  yearOfWeek: s0,
  m() {
    return [];
  }
}, Z2 = /* @__PURE__ */ Object.assign({}, V0, G2, {
  v: $a,
  hn: g0,
  q: d0,
  G(e, r, i) {
    const a = this.id && Fr(this.id) === "chinese" ? ((g, m, v) => {
      if (m)
        switch (g) {
          case 1:
            return 1651;
          case 2:
            return v < 30 ? 1947 : 1765;
          case 3:
            return v < 30 ? 1966 : 1955;
          case 4:
            return v < 30 ? 1963 : 1944;
          case 5:
            return v < 30 ? 1971 : 1952;
          case 6:
            return v < 30 ? 1960 : 1941;
          case 7:
            return v < 30 ? 1968 : 1938;
          case 8:
            return v < 30 ? 1957 : 1718;
          case 9:
            return 1832;
          case 10:
            return 1870;
          case 11:
            return 1814;
          case 12:
            return 1890;
        }
      return 1972;
    })(e, r, i) : Ft;
    let [u, c, f] = $a.call(this, {
      isoYear: a,
      isoMonth: nr,
      isoDay: 31
    });
    const p = Na.call(this, u), d = c === p;
    (ir(e, _l(c, p)) || ir(Number(r), Number(d)) || ir(i, f)) === 1 && u--;
    for (let g = 0; g < 100; g++) {
      const m = u - g, v = Na.call(this, m), w = Ya(e, r, v);
      if (r === (w === v) && i <= mg.call(this, m, w))
        return [m, w];
    }
  },
  sn(e) {
    const r = Ta.call(this, e);
    return r > Ta.call(this, e - 1) && r > Ta.call(this, e + 1);
  },
  L: Na,
  B: Ra,
  cn(e, r) {
    const i = r + e, a = Math.sign(e), u = a < 0 ? -1 : 0;
    let c = 0;
    for (let f = r; f !== i; f += a)
      c += Ra.call(this, f + u);
    return c;
  },
  U: mg,
  fn: Ta,
  V(e, r, i) {
    return Xa(lo.call(this, e, r, i));
  },
  p: lo,
  un(e, r, i) {
    if (i) {
      if (r += i, !Number.isSafeInteger(r))
        throw new RangeError(mr);
      if (i < 0)
        for (; r < 1; )
          r += Ra.call(this, --e);
      else {
        let a;
        for (; r > (a = Ra.call(this, e)); )
          r -= a, e++;
      }
    }
    return [e, r];
  },
  year(e) {
    return this.h(e).year;
  },
  month(e) {
    const { year: r, o: i } = this.h(e), { u: a } = this.l(r);
    return a[i] + 1;
  },
  day(e) {
    return this.h(e).day;
  }
}), bu = /* @__PURE__ */ y0(k2, z2), dn = /* @__PURE__ */ y0($2, Z2), bg = {
  era: Da,
  eraYear: _e,
  year: _e,
  month: zd,
  monthCode(e) {
    const r = Da(e);
    return ml(r), r;
  },
  day: zd,
  .../* @__PURE__ */ mi(Wt, _e),
  .../* @__PURE__ */ mi(Cn, Nf),
  offset(e) {
    const r = Da(e);
    return kr(r), r;
  }
}, $l = /* @__PURE__ */ Tn(fv, Wt, ct), H2 = /* @__PURE__ */ Tn(fv, ct, Wt), ar = "numeric", xo = ["timeZoneName"], X0 = {
  month: ar,
  day: ar
}, zl = {
  year: ar,
  month: ar
}, Gl = /* @__PURE__ */ Object.assign({}, zl, {
  day: ar
}), Zl = {
  hour: ar,
  minute: ar,
  second: ar
}, Hl = /* @__PURE__ */ Object.assign({}, Gl, Zl), K2 = /* @__PURE__ */ Object.assign({}, Hl, {
  timeZoneName: "short"
}), J2 = /* @__PURE__ */ Object.keys(zl), V2 = /* @__PURE__ */ Object.keys(X0), X2 = /* @__PURE__ */ Object.keys(Gl), Q2 = /* @__PURE__ */ Object.keys(Zl), Kl = ["dateStyle"], nI = /* @__PURE__ */ J2.concat(Kl), eI = /* @__PURE__ */ V2.concat(Kl), Jl = /* @__PURE__ */ X2.concat(Kl, ["weekday"]), Po = /* @__PURE__ */ Q2.concat(["dayPeriod", "timeStyle", "fractionalSecondDigits"]), Vl = /* @__PURE__ */ Jl.concat(Po), tI = /* @__PURE__ */ xo.concat(Po), rI = /* @__PURE__ */ xo.concat(Jl), iI = /* @__PURE__ */ xo.concat(["day", "weekday"], Po), oI = /* @__PURE__ */ xo.concat(["year", "weekday"], Po), aI = /* @__PURE__ */ Wr(Vl, Hl), uI = /* @__PURE__ */ Wr(Vl, K2), sI = /* @__PURE__ */ Wr(Vl, Hl, xo), cI = /* @__PURE__ */ Wr(Jl, Gl, tI), fI = /* @__PURE__ */ Wr(Po, Zl, rI), lI = /* @__PURE__ */ Wr(nI, zl, iI), pI = /* @__PURE__ */ Wr(eI, X0, oI), hI = {}, Q0 = new or(void 0, {
  calendar: In
}).resolvedOptions().calendar === In, nm = [aI, Hf], dI = [uI, Hf, 0, (e, r) => {
  const i = e.timeZone;
  if (r && r.timeZone !== i)
    throw new RangeError(P0);
  return i;
}], em = [sI, we], tm = [cI, we], rm = [fI, (e) => sr(e) / kt], im = [lI, we, Q0], om = [pI, we, Q0];
let Eg;
function wr(e, r, i, a, u) {
  function c(...d) {
    if (!(this instanceof c))
      throw new TypeError(wf);
    Og(this, r(...d));
  }
  function f(d, g) {
    return Object.defineProperties((function(...m) {
      return d.call(this, p(this), ...m);
    }), ao(g));
  }
  function p(d) {
    const g = Ae(d);
    if (!g || g.branding !== e)
      throw new TypeError(wf);
    return g;
  }
  return Object.defineProperties(c.prototype, {
    ...kO(jt(f, i)),
    ...gi(jt(f, a)),
    ...If("Temporal." + e)
  }), Object.defineProperties(c, {
    ...gi(u),
    ...ao(e)
  }), [c, (d) => {
    const g = Object.create(c.prototype);
    return Og(g, d), g;
  }, p];
}
function Ci(e) {
  if (Ae(e) || e.calendar !== void 0 || e.timeZone !== void 0)
    throw new TypeError(RR);
  return e;
}
function Mo(e) {
  return am(e) || In;
}
function am(e) {
  const { calendar: r } = e;
  if (r !== void 0)
    return Eu(r);
}
function Eu(e) {
  if (be(e)) {
    const { calendar: r } = Ae(e) || {};
    if (!r)
      throw new TypeError(R0(e));
    return r;
  }
  return ((r) => gu(mT(he(r))))(e);
}
function Xl(e) {
  const r = {};
  for (const i in e)
    r[i] = (a) => {
      const { calendar: u } = a;
      return dn(u)[i](a);
    };
  return r;
}
function br() {
  throw new TypeError(IR);
}
function Ge(e) {
  if (be(e)) {
    const { timeZone: r } = Ae(e) || {};
    if (!r)
      throw new TypeError(x0(e));
    return r;
  }
  return ((r) => hl(_T(he(r))))(e);
}
function ne(e) {
  if (be(e)) {
    const r = Ae(e);
    return r && r.branding === ql ? r : kT(e);
  }
  return vT(e);
}
function eo(e) {
  if (e !== void 0) {
    if (be(e)) {
      const r = Ae(e) || {};
      switch (r.branding) {
        case _r:
        case Io:
          return r;
        case Mi:
          return Ut(r);
      }
      const i = Mo(e);
      return {
        ...NT(Ge, _n, dn(i), e),
        calendar: i
      };
    }
    return lT(e);
  }
}
function er(e, r) {
  if (be(e)) {
    const a = Ae(e) || {};
    switch (a.branding) {
      case Bl:
        return Pn(r), a;
      case Mi:
        return Pn(r), Et(a);
      case _r:
        return Pn(r), b0(_n, a);
    }
    return UT(e, r);
  }
  const i = yT(e);
  return Pn(r), i;
}
function Ql(e) {
  return e === void 0 ? void 0 : er(e);
}
function ui(e, r) {
  if (be(e)) {
    const a = Ae(e) || {};
    switch (a.branding) {
      case Mi:
        return Pn(r), a;
      case Io:
        return Pn(r), st({
          ...a,
          ...Be
        });
      case _r:
        return Pn(r), _0(_n, a);
    }
    return FT(dn(Mo(e)), e, r);
  }
  const i = hT(e);
  return Pn(r), i;
}
function Ag(e, r) {
  if (be(e)) {
    const a = Ae(e);
    if (a && a.branding === Fl)
      return Pn(r), a;
    const u = am(e);
    return qT(dn(u || In), !u, e, r);
  }
  const i = gT(dn, e);
  return Pn(r), i;
}
function si(e, r) {
  if (be(e)) {
    const a = Ae(e);
    return a && a.branding === Ll ? (Pn(r), a) : jT(dn(Mo(e)), e, r);
  }
  const i = dT(dn, e);
  return Pn(r), i;
}
function ci(e, r) {
  if (be(e)) {
    const a = Ae(e) || {};
    switch (a.branding) {
      case Io:
        return Pn(r), a;
      case Mi:
        return Pn(r), Ut(a);
      case _r:
        return Pn(r), w0(_n, a);
    }
    return BT(dn(Mo(e)), e, r);
  }
  const i = al(e);
  return Pn(r), i;
}
function fi(e, r) {
  if (be(e)) {
    const i = Ae(e);
    if (i && i.branding === _r)
      return nu(r), i;
    const a = Mo(e);
    return LT(Ge, _n, dn(a), a, e, r);
  }
  return pT(e, r);
}
function Sg(e) {
  return jt(((r) => (i) => r(Of(i))), e);
}
function Of(e) {
  return Je(e, _n);
}
function li(e) {
  if (be(e)) {
    const r = Ae(e);
    if (r)
      switch (r.branding) {
        case jl:
          return r;
        case _r:
          return qt(r.epochNanoseconds);
      }
  }
  return fT(e);
}
function gI() {
  function e(c, f) {
    return new r(c, f);
  }
  function r(c, f = /* @__PURE__ */ Object.create(null)) {
    Za.set(this, ((p, d) => {
      const g = new or(p, d), m = g.resolvedOptions(), v = m.locale, w = at(Object.keys(d), m), M = Ze(mI), E = (x, ...B) => {
        if (x) {
          if (B.length !== 2)
            throw new TypeError(Qs);
          for (const S of B)
            if (S === void 0)
              throw new TypeError(Qs);
        }
        x || B[0] !== void 0 || (B = []);
        const A = B.map(((S) => Ae(S) || Number(S)));
        let R, D = 0;
        for (const S of A) {
          const P = typeof S == "object" ? S.branding : void 0;
          if (D++ && P !== R)
            throw new TypeError(Qs);
          R = P;
        }
        return R ? M(R)(v, w, ...A) : [g, ...A];
      };
      return E.X = g, E;
    })(c, f));
  }
  const i = or.prototype, a = Object.getOwnPropertyDescriptors(i), u = Object.getOwnPropertyDescriptors(or);
  for (const c in a) {
    const f = a[c], p = c.startsWith("format") && yI(c);
    typeof f.value == "function" ? f.value = c === "constructor" ? e : p || vI(c) : p && (f.get = function() {
      if (!Za.has(this))
        throw new TypeError(wf);
      return (...d) => p.apply(this, d);
    }, Object.defineProperties(f.get, ao(`get ${c}`)));
  }
  return u.prototype.value = r.prototype = Object.create({}, a), Object.defineProperties(e, u), e;
}
function yI(e) {
  return Object.defineProperties((function(...r) {
    const i = Za.get(this), [a, ...u] = i(e.includes("Range"), ...r);
    return a[e](...u);
  }), ao(e));
}
function vI(e) {
  return Object.defineProperties((function(...r) {
    return Za.get(this).X[e](...r);
  }), ao(e));
}
function mI(e) {
  const r = SI[e];
  if (!r)
    throw new TypeError(GR(e));
  return yr(r, Ze(E0), 1);
}
const Ga = /* @__PURE__ */ new WeakMap(), Ae = /* @__PURE__ */ Ga.get.bind(Ga), Og = /* @__PURE__ */ Ga.set.bind(Ga), um = {
  era: WO,
  eraYear: dv,
  year: Pf,
  month: Dt,
  daysInMonth: Dt,
  daysInYear: Dt,
  inLeapYear: XR,
  monthsInYear: Dt
}, np = {
  monthCode: he
}, sm = {
  day: Dt
}, _I = {
  dayOfWeek: Dt,
  dayOfYear: Dt,
  weekOfYear: YO,
  yearOfWeek: dv,
  daysInWeek: Dt
}, ep = /* @__PURE__ */ Xl(/* @__PURE__ */ Object.assign({}, um, np, sm, _I)), wI = /* @__PURE__ */ Xl({
  ...um,
  ...np
}), bI = /* @__PURE__ */ Xl({
  ...np,
  ...sm
}), Co = {
  calendarId: (e) => e.calendar
}, EI = /* @__PURE__ */ Ha(((e) => (r) => r[e]), Cn.concat("sign")), tp = /* @__PURE__ */ Ha(((e, r) => (i) => i[ct[r]]), Wt), cm = {
  epochMilliseconds: Hf,
  epochNanoseconds: GO
}, [AI, Hn] = wr(ql, tR, {
  ...EI,
  blank: sT
}, {
  with: (e, r) => Hn(HT(e, r)),
  negated: (e) => Hn(ol(e)),
  abs: (e) => Hn(uT(e)),
  add: (e, r, i) => Hn(cg(eo, dn, _n, 0, e, ne(r), i)),
  subtract: (e, r, i) => Hn(cg(eo, dn, _n, 1, e, ne(r), i)),
  round: (e, r) => Hn(aT(eo, dn, _n, e, r)),
  total: (e, r) => ZO(eo, dn, _n, e, r),
  toLocaleString(e, r, i) {
    return Intl.DurationFormat ? new Intl.DurationFormat(r, i).format(this) : Hs(e);
  },
  toString: Hs,
  toJSON: (e) => Hs(e),
  valueOf: br
}, {
  from: (e) => Hn(ne(e)),
  compare: (e, r, i) => bT(eo, dn, _n, ne(e), ne(r), i)
}), SI = {
  Instant: nm,
  PlainDateTime: em,
  PlainDate: tm,
  PlainTime: rm,
  PlainYearMonth: im,
  PlainMonthDay: om
}, OI = /* @__PURE__ */ yr(nm), TI = /* @__PURE__ */ yr(dI), RI = /* @__PURE__ */ yr(em), II = /* @__PURE__ */ yr(tm), xI = /* @__PURE__ */ yr(rm), PI = /* @__PURE__ */ yr(im), MI = /* @__PURE__ */ yr(om), [CI, rr] = wr(Bl, eR, tp, {
  with(e, r, i) {
    return rr(ZT(this, Ci(r), i));
  },
  add: (e, r) => rr(sg(0, e, ne(r))),
  subtract: (e, r) => rr(sg(1, e, ne(r))),
  until: (e, r, i) => Hn(vg(0, e, er(r), i)),
  since: (e, r, i) => Hn(vg(1, e, er(r), i)),
  round: (e, r) => rr(VO(e, r)),
  equals: (e, r) => IT(e, er(r)),
  toLocaleString(e, r, i) {
    const [a, u] = xI(r, i, e);
    return a.format(u);
  },
  toString: eg,
  toJSON: (e) => eg(e),
  valueOf: br
}, {
  from: (e, r) => rr(er(e, r)),
  compare: (e, r) => gl(er(e), er(r))
}), [DI, dt] = wr(Mi, Tn(VT, Eo), {
  ...Co,
  ...ep,
  ...tp
}, {
  with: (e, r, i) => dt(YT(dn, e, Ci(r), i)),
  withCalendar: (e, r) => dt(wl(e, Eu(r))),
  withPlainTime: (e, r) => dt(yR(e, Ql(r))),
  add: (e, r, i) => dt(og(dn, 0, e, ne(r), i)),
  subtract: (e, r, i) => dt(og(dn, 1, e, ne(r), i)),
  until: (e, r, i) => Hn(dg(dn, 0, e, ui(r), i)),
  since: (e, r, i) => Hn(dg(dn, 1, e, ui(r), i)),
  round: (e, r) => dt(JO(e, r)),
  equals: (e, r) => ST(e, ui(r)),
  toZonedDateTime: (e, r, i) => me(oR(_n, e, Ge(r), i)),
  toPlainDate: (e) => gt(Ut(e)),
  toPlainTime: (e) => rr(Et(e)),
  toLocaleString(e, r, i) {
    const [a, u] = RI(r, i, e);
    return a.format(u);
  },
  toString: Vd,
  toJSON: (e) => Vd(e),
  valueOf: br
}, {
  from: (e, r) => dt(ui(e, r)),
  compare: (e, r) => n0(ui(e), ui(r))
}), [NI, Tf] = wr(Fl, Tn(nR, Eo), {
  ...Co,
  ...bI
}, {
  with: (e, r, i) => Tf(GT(dn, e, Ci(r), i)),
  equals: (e, r) => RT(e, Ag(r)),
  toPlainDate(e, r) {
    return gt(lR(dn, e, this, r));
  },
  toLocaleString(e, r, i) {
    const [a, u] = MI(r, i, e);
    return a.format(u);
  },
  toString: ng,
  toJSON: (e) => ng(e),
  valueOf: br
}, {
  from: (e, r) => Tf(Ag(e, r))
}), [LI, to] = wr(Ll, Tn(QT, Eo), {
  ...Co,
  ...wI
}, {
  with: (e, r, i) => to(zT(dn, e, Ci(r), i)),
  add: (e, r, i) => to(ug(dn, 0, e, ne(r), i)),
  subtract: (e, r, i) => to(ug(dn, 1, e, ne(r), i)),
  until: (e, r, i) => Hn(yg(dn, 0, e, si(r), i)),
  since: (e, r, i) => Hn(yg(dn, 1, e, si(r), i)),
  equals: (e, r) => TT(e, si(r)),
  toPlainDate(e, r) {
    return gt(fR(dn, e, this, r));
  },
  toLocaleString(e, r, i) {
    const [a, u] = PI(r, i, e);
    return a.format(u);
  },
  toString: Qd,
  toJSON: (e) => Qd(e),
  valueOf: br
}, {
  from: (e, r) => to(si(e, r)),
  compare: (e, r) => Ii(si(e), si(r))
}), [FI, gt] = wr(Io, Tn(XT, Eo), {
  ...Co,
  ...ep
}, {
  with: (e, r, i) => gt($T(dn, e, Ci(r), i)),
  withCalendar: (e, r) => gt(wl(e, Eu(r))),
  add: (e, r, i) => gt(ag(dn, 0, e, ne(r), i)),
  subtract: (e, r, i) => gt(ag(dn, 1, e, ne(r), i)),
  until: (e, r, i) => Hn(gg(dn, 0, e, ci(r), i)),
  since: (e, r, i) => Hn(gg(dn, 1, e, ci(r), i)),
  equals: (e, r) => OT(e, ci(r)),
  toZonedDateTime(e, r) {
    const i = be(r) ? r : {
      timeZone: r
    };
    return me(aR(Ge, er, _n, e, i));
  },
  toPlainDateTime: (e, r) => dt(uR(e, Ql(r))),
  toPlainYearMonth(e) {
    return to(sR(dn, e, this));
  },
  toPlainMonthDay(e) {
    return Tf(cR(dn, e, this));
  },
  toLocaleString(e, r, i) {
    const [a, u] = II(r, i, e);
    return a.format(u);
  },
  toString: Xd,
  toJSON: (e) => Xd(e),
  valueOf: br
}, {
  from: (e, r) => gt(ci(e, r)),
  compare: (e, r) => Ii(ci(e), ci(r))
}), [BI, me] = wr(_r, Tn(JT, Eo, wT), {
  ...cm,
  ...Co,
  ...Sg(ep),
  ...Sg(tp),
  offset: (e) => _o(Of(e).offsetNanoseconds),
  offsetNanoseconds: (e) => Of(e).offsetNanoseconds,
  timeZoneId: (e) => e.timeZone,
  hoursInDay: (e) => XO(_n, e)
}, {
  with: (e, r, i) => me(WT(dn, _n, e, Ci(r), i)),
  withCalendar: (e, r) => me(wl(e, Eu(r))),
  withTimeZone: (e, r) => me(vR(e, Ge(r))),
  withPlainTime: (e, r) => me(gR(_n, e, Ql(r))),
  add: (e, r, i) => me(ig(dn, _n, 0, e, ne(r), i)),
  subtract: (e, r, i) => me(ig(dn, _n, 1, e, ne(r), i)),
  until: (e, r, i) => Hn(ee(hg(dn, _n, 0, e, fi(r), i))),
  since: (e, r, i) => Hn(ee(hg(dn, _n, 1, e, fi(r), i))),
  round: (e, r) => me(KO(_n, e, r)),
  startOfDay: (e) => me(QO(_n, e)),
  equals: (e, r) => AT(e, fi(r)),
  toInstant: (e) => tr(iR(e)),
  toPlainDateTime: (e) => dt(_0(_n, e)),
  toPlainDate: (e) => gt(w0(_n, e)),
  toPlainTime: (e) => rr(b0(_n, e)),
  toLocaleString(e, r, i = {}) {
    const [a, u] = TI(r, i, e);
    return a.format(u);
  },
  toString: (e, r) => Jd(_n, e, r),
  toJSON: (e) => Jd(_n, e),
  valueOf: br,
  getTimeZoneTransition(e, r) {
    const { timeZone: i, epochNanoseconds: a } = e, u = zO(r), c = _n(i).O(a, u);
    return c ? me({
      ...e,
      epochNanoseconds: c
    }) : null;
  }
}, {
  from: (e, r) => me(fi(e, r)),
  compare: (e, r) => Qv(fi(e), fi(r))
}), [jI, tr] = wr(jl, KT, cm, {
  add: (e, r) => tr(rg(0, e, ne(r))),
  subtract: (e, r) => tr(rg(1, e, ne(r))),
  until: (e, r, i) => Hn(pg(0, e, li(r), i)),
  since: (e, r, i) => Hn(pg(1, e, li(r), i)),
  round: (e, r) => tr(HO(e, r)),
  equals: (e, r) => ET(e, li(r)),
  toZonedDateTimeISO: (e, r) => me(rR(e, Ge(r))),
  toLocaleString(e, r, i) {
    const [a, u] = OI(r, i, e);
    return a.format(u);
  },
  toString: (e, r) => Kd(Ge, _n, e, r),
  toJSON: (e) => Kd(Ge, _n, e),
  valueOf: br
}, {
  from: (e) => tr(li(e)),
  fromEpochMilliseconds: (e) => tr(pR(e)),
  fromEpochNanoseconds: (e) => tr(hR(e)),
  compare: (e, r) => Xv(li(e), li(r))
}), qI = /* @__PURE__ */ Object.defineProperties({}, {
  ...If("Temporal.Now"),
  ...gi({
    timeZoneId: () => Qi(),
    instant: () => tr(qt(_f())),
    zonedDateTimeISO: (e = Qi()) => me(ut(_f(), Ge(e), In)),
    plainDateTimeISO: (e = Qi()) => dt(st(Xs(_n(Ge(e))), In)),
    plainDateISO: (e = Qi()) => gt(Ut(Xs(_n(Ge(e))), In)),
    plainTimeISO: (e = Qi()) => rr(Et(Xs(_n(Ge(e)))))
  })
}), UI = /* @__PURE__ */ Object.defineProperties({}, {
  ...If("Temporal"),
  ...gi({
    PlainYearMonth: LI,
    PlainMonthDay: NI,
    PlainDate: FI,
    PlainTime: CI,
    PlainDateTime: DI,
    ZonedDateTime: BI,
    Instant: jI,
    Duration: AI,
    Now: qI
  })
}), kI = /* @__PURE__ */ gI(), Za = /* @__PURE__ */ new WeakMap();
Object.create(Intl), gi({
  DateTimeFormat: kI
});
function WI(e) {
  const r = e < 0;
  e = Math.abs(e);
  const i = Math.floor(e / 3600).toFixed(0).padStart(2, "0"), a = Math.floor(e % 3600 / 60).toFixed(0).padStart(2, "0"), u = Math.floor(e % 3600 % 60).toFixed(0).padStart(2, "0");
  let c = "";
  return i !== "00" && (c += `${i}:`), c += `${a}:${u}`, r && (c = "-" + c), c;
}
class Tg extends V.Component {
  shouldComponentUpdate(r) {
    const i = Math.floor(this.props.seconds), a = Math.floor(r.seconds);
    return i !== a;
  }
  calculateDuration(r) {
    if (!isNaN(r))
      return new UI.Duration(0, 0, 0, 0, 0, 0, Math.round(r)).round({ smallestUnit: "seconds", largestUnit: "hours" }).toString();
  }
  render() {
    const { seconds: r, role: i } = this.props;
    return /* @__PURE__ */ V.createElement(
      "time",
      {
        dateTime: this.calculateDuration(r),
        "aria-live": this.props["aria-live"],
        role: i,
        className: ot("mx_Clock", this.props.className)
      },
      WI(r)
    );
  }
}
var ro = { exports: {} };
var YI = ro.exports, Rg;
function $I() {
  return Rg || (Rg = 1, (function(e, r) {
    (function() {
      var i, a = "4.17.21", u = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", p = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", g = 500, m = "__lodash_placeholder__", v = 1, w = 2, M = 4, E = 1, x = 2, B = 1, A = 2, R = 4, D = 8, S = 16, P = 32, L = 64, j = 128, z = 256, Z = 512, J = 30, fn = "...", bn = 800, Ln = 16, Fn = 1, Se = 2, Oe = 3, Jn = 1 / 0, Dn = 9007199254740991, $n = 17976931348623157e292, te = NaN, q = 4294967295, T = q - 1, N = q >>> 1, W = [
        ["ary", j],
        ["bind", B],
        ["bindKey", A],
        ["curry", D],
        ["curryRight", S],
        ["flip", Z],
        ["partial", P],
        ["partialRight", L],
        ["rearg", z]
      ], X = "[object Arguments]", cn = "[object Array]", en = "[object AsyncFunction]", tn = "[object Boolean]", Q = "[object Date]", nn = "[object DOMException]", yn = "[object Error]", wn = "[object Function]", Bn = "[object GeneratorFunction]", Sn = "[object Map]", Vn = "[object Number]", zn = "[object Null]", re = "[object Object]", $t = "[object Promise]", Y = "[object Proxy]", Te = "[object RegExp]", Un = "[object Set]", ft = "[object String]", At = "[object Symbol]", $r = "[object Undefined]", Ni = "[object WeakMap]", Pm = "[object WeakSet]", Li = "[object ArrayBuffer]", zr = "[object DataView]", Tu = "[object Float32Array]", Ru = "[object Float64Array]", Iu = "[object Int8Array]", xu = "[object Int16Array]", Pu = "[object Int32Array]", Mu = "[object Uint8Array]", Cu = "[object Uint8ClampedArray]", Du = "[object Uint16Array]", Nu = "[object Uint32Array]", Mm = /\b__p \+= '';/g, Cm = /\b(__p \+=) '' \+/g, Dm = /(__e\(.*?\)|\b__t\)) \+\n'';/g, cp = /&(?:amp|lt|gt|quot|#39);/g, fp = /[&<>"']/g, Nm = RegExp(cp.source), Lm = RegExp(fp.source), Fm = /<%-([\s\S]+?)%>/g, Bm = /<%([\s\S]+?)%>/g, lp = /<%=([\s\S]+?)%>/g, jm = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, qm = /^\w*$/, Um = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Lu = /[\\^$.*+?()[\]{}|]/g, km = RegExp(Lu.source), Fu = /^\s+/, Wm = /\s/, Ym = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, $m = /\{\n\/\* \[wrapped with (.+)\] \*/, zm = /,? & /, Gm = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Zm = /[()=,{}\[\]\/\s]/, Hm = /\\(\\)?/g, Km = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, pp = /\w*$/, Jm = /^[-+]0x[0-9a-f]+$/i, Vm = /^0b[01]+$/i, Xm = /^\[object .+?Constructor\]$/, Qm = /^0o[0-7]+$/i, n1 = /^(?:0|[1-9]\d*)$/, e1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Fo = /($^)/, t1 = /['\n\r\u2028\u2029\\]/g, Bo = "\\ud800-\\udfff", r1 = "\\u0300-\\u036f", i1 = "\\ufe20-\\ufe2f", o1 = "\\u20d0-\\u20ff", hp = r1 + i1 + o1, dp = "\\u2700-\\u27bf", gp = "a-z\\xdf-\\xf6\\xf8-\\xff", a1 = "\\xac\\xb1\\xd7\\xf7", u1 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", s1 = "\\u2000-\\u206f", c1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", yp = "A-Z\\xc0-\\xd6\\xd8-\\xde", vp = "\\ufe0e\\ufe0f", mp = a1 + u1 + s1 + c1, Bu = "['’]", f1 = "[" + Bo + "]", _p = "[" + mp + "]", jo = "[" + hp + "]", wp = "\\d+", l1 = "[" + dp + "]", bp = "[" + gp + "]", Ep = "[^" + Bo + mp + wp + dp + gp + yp + "]", ju = "\\ud83c[\\udffb-\\udfff]", p1 = "(?:" + jo + "|" + ju + ")", Ap = "[^" + Bo + "]", qu = "(?:\\ud83c[\\udde6-\\uddff]){2}", Uu = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gr = "[" + yp + "]", Sp = "\\u200d", Op = "(?:" + bp + "|" + Ep + ")", h1 = "(?:" + Gr + "|" + Ep + ")", Tp = "(?:" + Bu + "(?:d|ll|m|re|s|t|ve))?", Rp = "(?:" + Bu + "(?:D|LL|M|RE|S|T|VE))?", Ip = p1 + "?", xp = "[" + vp + "]?", d1 = "(?:" + Sp + "(?:" + [Ap, qu, Uu].join("|") + ")" + xp + Ip + ")*", g1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", y1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Pp = xp + Ip + d1, v1 = "(?:" + [l1, qu, Uu].join("|") + ")" + Pp, m1 = "(?:" + [Ap + jo + "?", jo, qu, Uu, f1].join("|") + ")", _1 = RegExp(Bu, "g"), w1 = RegExp(jo, "g"), ku = RegExp(ju + "(?=" + ju + ")|" + m1 + Pp, "g"), b1 = RegExp([
        Gr + "?" + bp + "+" + Tp + "(?=" + [_p, Gr, "$"].join("|") + ")",
        h1 + "+" + Rp + "(?=" + [_p, Gr + Op, "$"].join("|") + ")",
        Gr + "?" + Op + "+" + Tp,
        Gr + "+" + Rp,
        y1,
        g1,
        wp,
        v1
      ].join("|"), "g"), E1 = RegExp("[" + Sp + Bo + hp + vp + "]"), A1 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, S1 = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], O1 = -1, Mn = {};
      Mn[Tu] = Mn[Ru] = Mn[Iu] = Mn[xu] = Mn[Pu] = Mn[Mu] = Mn[Cu] = Mn[Du] = Mn[Nu] = !0, Mn[X] = Mn[cn] = Mn[Li] = Mn[tn] = Mn[zr] = Mn[Q] = Mn[yn] = Mn[wn] = Mn[Sn] = Mn[Vn] = Mn[re] = Mn[Te] = Mn[Un] = Mn[ft] = Mn[Ni] = !1;
      var xn = {};
      xn[X] = xn[cn] = xn[Li] = xn[zr] = xn[tn] = xn[Q] = xn[Tu] = xn[Ru] = xn[Iu] = xn[xu] = xn[Pu] = xn[Sn] = xn[Vn] = xn[re] = xn[Te] = xn[Un] = xn[ft] = xn[At] = xn[Mu] = xn[Cu] = xn[Du] = xn[Nu] = !0, xn[yn] = xn[wn] = xn[Ni] = !1;
      var T1 = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, R1 = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, I1 = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, x1 = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, P1 = parseFloat, M1 = parseInt, Mp = typeof hi == "object" && hi && hi.Object === Object && hi, C1 = typeof self == "object" && self && self.Object === Object && self, Xn = Mp || C1 || Function("return this")(), Wu = r && !r.nodeType && r, Er = Wu && !0 && e && !e.nodeType && e, Cp = Er && Er.exports === Wu, Yu = Cp && Mp.process, je = (function() {
        try {
          var O = Er && Er.require && Er.require("util").types;
          return O || Yu && Yu.binding && Yu.binding("util");
        } catch {
        }
      })(), Dp = je && je.isArrayBuffer, Np = je && je.isDate, Lp = je && je.isMap, Fp = je && je.isRegExp, Bp = je && je.isSet, jp = je && je.isTypedArray;
      function Re(O, F, C) {
        switch (C.length) {
          case 0:
            return O.call(F);
          case 1:
            return O.call(F, C[0]);
          case 2:
            return O.call(F, C[0], C[1]);
          case 3:
            return O.call(F, C[0], C[1], C[2]);
        }
        return O.apply(F, C);
      }
      function D1(O, F, C, H) {
        for (var un = -1, En = O == null ? 0 : O.length; ++un < En; ) {
          var Gn = O[un];
          F(H, Gn, C(Gn), O);
        }
        return H;
      }
      function qe(O, F) {
        for (var C = -1, H = O == null ? 0 : O.length; ++C < H && F(O[C], C, O) !== !1; )
          ;
        return O;
      }
      function N1(O, F) {
        for (var C = O == null ? 0 : O.length; C-- && F(O[C], C, O) !== !1; )
          ;
        return O;
      }
      function qp(O, F) {
        for (var C = -1, H = O == null ? 0 : O.length; ++C < H; )
          if (!F(O[C], C, O))
            return !1;
        return !0;
      }
      function zt(O, F) {
        for (var C = -1, H = O == null ? 0 : O.length, un = 0, En = []; ++C < H; ) {
          var Gn = O[C];
          F(Gn, C, O) && (En[un++] = Gn);
        }
        return En;
      }
      function qo(O, F) {
        var C = O == null ? 0 : O.length;
        return !!C && Zr(O, F, 0) > -1;
      }
      function $u(O, F, C) {
        for (var H = -1, un = O == null ? 0 : O.length; ++H < un; )
          if (C(F, O[H]))
            return !0;
        return !1;
      }
      function Nn(O, F) {
        for (var C = -1, H = O == null ? 0 : O.length, un = Array(H); ++C < H; )
          un[C] = F(O[C], C, O);
        return un;
      }
      function Gt(O, F) {
        for (var C = -1, H = F.length, un = O.length; ++C < H; )
          O[un + C] = F[C];
        return O;
      }
      function zu(O, F, C, H) {
        var un = -1, En = O == null ? 0 : O.length;
        for (H && En && (C = O[++un]); ++un < En; )
          C = F(C, O[un], un, O);
        return C;
      }
      function L1(O, F, C, H) {
        var un = O == null ? 0 : O.length;
        for (H && un && (C = O[--un]); un--; )
          C = F(C, O[un], un, O);
        return C;
      }
      function Gu(O, F) {
        for (var C = -1, H = O == null ? 0 : O.length; ++C < H; )
          if (F(O[C], C, O))
            return !0;
        return !1;
      }
      var F1 = Zu("length");
      function B1(O) {
        return O.split("");
      }
      function j1(O) {
        return O.match(Gm) || [];
      }
      function Up(O, F, C) {
        var H;
        return C(O, function(un, En, Gn) {
          if (F(un, En, Gn))
            return H = En, !1;
        }), H;
      }
      function Uo(O, F, C, H) {
        for (var un = O.length, En = C + (H ? 1 : -1); H ? En-- : ++En < un; )
          if (F(O[En], En, O))
            return En;
        return -1;
      }
      function Zr(O, F, C) {
        return F === F ? J1(O, F, C) : Uo(O, kp, C);
      }
      function q1(O, F, C, H) {
        for (var un = C - 1, En = O.length; ++un < En; )
          if (H(O[un], F))
            return un;
        return -1;
      }
      function kp(O) {
        return O !== O;
      }
      function Wp(O, F) {
        var C = O == null ? 0 : O.length;
        return C ? Ku(O, F) / C : te;
      }
      function Zu(O) {
        return function(F) {
          return F == null ? i : F[O];
        };
      }
      function Hu(O) {
        return function(F) {
          return O == null ? i : O[F];
        };
      }
      function Yp(O, F, C, H, un) {
        return un(O, function(En, Gn, Rn) {
          C = H ? (H = !1, En) : F(C, En, Gn, Rn);
        }), C;
      }
      function U1(O, F) {
        var C = O.length;
        for (O.sort(F); C--; )
          O[C] = O[C].value;
        return O;
      }
      function Ku(O, F) {
        for (var C, H = -1, un = O.length; ++H < un; ) {
          var En = F(O[H]);
          En !== i && (C = C === i ? En : C + En);
        }
        return C;
      }
      function Ju(O, F) {
        for (var C = -1, H = Array(O); ++C < O; )
          H[C] = F(C);
        return H;
      }
      function k1(O, F) {
        return Nn(F, function(C) {
          return [C, O[C]];
        });
      }
      function $p(O) {
        return O && O.slice(0, Hp(O) + 1).replace(Fu, "");
      }
      function Ie(O) {
        return function(F) {
          return O(F);
        };
      }
      function Vu(O, F) {
        return Nn(F, function(C) {
          return O[C];
        });
      }
      function Fi(O, F) {
        return O.has(F);
      }
      function zp(O, F) {
        for (var C = -1, H = O.length; ++C < H && Zr(F, O[C], 0) > -1; )
          ;
        return C;
      }
      function Gp(O, F) {
        for (var C = O.length; C-- && Zr(F, O[C], 0) > -1; )
          ;
        return C;
      }
      function W1(O, F) {
        for (var C = O.length, H = 0; C--; )
          O[C] === F && ++H;
        return H;
      }
      var Y1 = Hu(T1), $1 = Hu(R1);
      function z1(O) {
        return "\\" + x1[O];
      }
      function G1(O, F) {
        return O == null ? i : O[F];
      }
      function Hr(O) {
        return E1.test(O);
      }
      function Z1(O) {
        return A1.test(O);
      }
      function H1(O) {
        for (var F, C = []; !(F = O.next()).done; )
          C.push(F.value);
        return C;
      }
      function Xu(O) {
        var F = -1, C = Array(O.size);
        return O.forEach(function(H, un) {
          C[++F] = [un, H];
        }), C;
      }
      function Zp(O, F) {
        return function(C) {
          return O(F(C));
        };
      }
      function Zt(O, F) {
        for (var C = -1, H = O.length, un = 0, En = []; ++C < H; ) {
          var Gn = O[C];
          (Gn === F || Gn === m) && (O[C] = m, En[un++] = C);
        }
        return En;
      }
      function ko(O) {
        var F = -1, C = Array(O.size);
        return O.forEach(function(H) {
          C[++F] = H;
        }), C;
      }
      function K1(O) {
        var F = -1, C = Array(O.size);
        return O.forEach(function(H) {
          C[++F] = [H, H];
        }), C;
      }
      function J1(O, F, C) {
        for (var H = C - 1, un = O.length; ++H < un; )
          if (O[H] === F)
            return H;
        return -1;
      }
      function V1(O, F, C) {
        for (var H = C + 1; H--; )
          if (O[H] === F)
            return H;
        return H;
      }
      function Kr(O) {
        return Hr(O) ? Q1(O) : F1(O);
      }
      function Ve(O) {
        return Hr(O) ? n_(O) : B1(O);
      }
      function Hp(O) {
        for (var F = O.length; F-- && Wm.test(O.charAt(F)); )
          ;
        return F;
      }
      var X1 = Hu(I1);
      function Q1(O) {
        for (var F = ku.lastIndex = 0; ku.test(O); )
          ++F;
        return F;
      }
      function n_(O) {
        return O.match(ku) || [];
      }
      function e_(O) {
        return O.match(b1) || [];
      }
      var t_ = (function O(F) {
        F = F == null ? Xn : Jr.defaults(Xn.Object(), F, Jr.pick(Xn, S1));
        var C = F.Array, H = F.Date, un = F.Error, En = F.Function, Gn = F.Math, Rn = F.Object, Qu = F.RegExp, r_ = F.String, Ue = F.TypeError, Wo = C.prototype, i_ = En.prototype, Vr = Rn.prototype, Yo = F["__core-js_shared__"], $o = i_.toString, On = Vr.hasOwnProperty, o_ = 0, Kp = (function() {
          var n = /[^.]+$/.exec(Yo && Yo.keys && Yo.keys.IE_PROTO || "");
          return n ? "Symbol(src)_1." + n : "";
        })(), zo = Vr.toString, a_ = $o.call(Rn), u_ = Xn._, s_ = Qu(
          "^" + $o.call(On).replace(Lu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Go = Cp ? F.Buffer : i, Ht = F.Symbol, Zo = F.Uint8Array, Jp = Go ? Go.allocUnsafe : i, Ho = Zp(Rn.getPrototypeOf, Rn), Vp = Rn.create, Xp = Vr.propertyIsEnumerable, Ko = Wo.splice, Qp = Ht ? Ht.isConcatSpreadable : i, Bi = Ht ? Ht.iterator : i, Ar = Ht ? Ht.toStringTag : i, Jo = (function() {
          try {
            var n = Ir(Rn, "defineProperty");
            return n({}, "", {}), n;
          } catch {
          }
        })(), c_ = F.clearTimeout !== Xn.clearTimeout && F.clearTimeout, f_ = H && H.now !== Xn.Date.now && H.now, l_ = F.setTimeout !== Xn.setTimeout && F.setTimeout, Vo = Gn.ceil, Xo = Gn.floor, ns = Rn.getOwnPropertySymbols, p_ = Go ? Go.isBuffer : i, nh = F.isFinite, h_ = Wo.join, d_ = Zp(Rn.keys, Rn), Zn = Gn.max, ie = Gn.min, g_ = H.now, y_ = F.parseInt, eh = Gn.random, v_ = Wo.reverse, es = Ir(F, "DataView"), ji = Ir(F, "Map"), ts = Ir(F, "Promise"), Xr = Ir(F, "Set"), qi = Ir(F, "WeakMap"), Ui = Ir(Rn, "create"), Qo = qi && new qi(), Qr = {}, m_ = xr(es), __ = xr(ji), w_ = xr(ts), b_ = xr(Xr), E_ = xr(qi), na = Ht ? Ht.prototype : i, ki = na ? na.valueOf : i, th = na ? na.toString : i;
        function h(n) {
          if (kn(n) && !sn(n) && !(n instanceof vn)) {
            if (n instanceof ke)
              return n;
            if (On.call(n, "__wrapped__"))
              return rd(n);
          }
          return new ke(n);
        }
        var ni = /* @__PURE__ */ (function() {
          function n() {
          }
          return function(t) {
            if (!jn(t))
              return {};
            if (Vp)
              return Vp(t);
            n.prototype = t;
            var o = new n();
            return n.prototype = i, o;
          };
        })();
        function ea() {
        }
        function ke(n, t) {
          this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
        }
        h.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Fm,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Bm,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: lp,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: h
          }
        }, h.prototype = ea.prototype, h.prototype.constructor = h, ke.prototype = ni(ea.prototype), ke.prototype.constructor = ke;
        function vn(n) {
          this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = q, this.__views__ = [];
        }
        function A_() {
          var n = new vn(this.__wrapped__);
          return n.__actions__ = de(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = de(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = de(this.__views__), n;
        }
        function S_() {
          if (this.__filtered__) {
            var n = new vn(this);
            n.__dir__ = -1, n.__filtered__ = !0;
          } else
            n = this.clone(), n.__dir__ *= -1;
          return n;
        }
        function O_() {
          var n = this.__wrapped__.value(), t = this.__dir__, o = sn(n), s = t < 0, l = o ? n.length : 0, y = Bw(0, l, this.__views__), _ = y.start, b = y.end, I = b - _, U = s ? b : _ - 1, k = this.__iteratees__, $ = k.length, G = 0, K = ie(I, this.__takeCount__);
          if (!o || !s && l == I && K == I)
            return Th(n, this.__actions__);
          var on = [];
          n:
            for (; I-- && G < K; ) {
              U += t;
              for (var pn = -1, an = n[U]; ++pn < $; ) {
                var gn = k[pn], mn = gn.iteratee, Me = gn.type, le = mn(an);
                if (Me == Se)
                  an = le;
                else if (!le) {
                  if (Me == Fn)
                    continue n;
                  break n;
                }
              }
              on[G++] = an;
            }
          return on;
        }
        vn.prototype = ni(ea.prototype), vn.prototype.constructor = vn;
        function Sr(n) {
          var t = -1, o = n == null ? 0 : n.length;
          for (this.clear(); ++t < o; ) {
            var s = n[t];
            this.set(s[0], s[1]);
          }
        }
        function T_() {
          this.__data__ = Ui ? Ui(null) : {}, this.size = 0;
        }
        function R_(n) {
          var t = this.has(n) && delete this.__data__[n];
          return this.size -= t ? 1 : 0, t;
        }
        function I_(n) {
          var t = this.__data__;
          if (Ui) {
            var o = t[n];
            return o === d ? i : o;
          }
          return On.call(t, n) ? t[n] : i;
        }
        function x_(n) {
          var t = this.__data__;
          return Ui ? t[n] !== i : On.call(t, n);
        }
        function P_(n, t) {
          var o = this.__data__;
          return this.size += this.has(n) ? 0 : 1, o[n] = Ui && t === i ? d : t, this;
        }
        Sr.prototype.clear = T_, Sr.prototype.delete = R_, Sr.prototype.get = I_, Sr.prototype.has = x_, Sr.prototype.set = P_;
        function St(n) {
          var t = -1, o = n == null ? 0 : n.length;
          for (this.clear(); ++t < o; ) {
            var s = n[t];
            this.set(s[0], s[1]);
          }
        }
        function M_() {
          this.__data__ = [], this.size = 0;
        }
        function C_(n) {
          var t = this.__data__, o = ta(t, n);
          if (o < 0)
            return !1;
          var s = t.length - 1;
          return o == s ? t.pop() : Ko.call(t, o, 1), --this.size, !0;
        }
        function D_(n) {
          var t = this.__data__, o = ta(t, n);
          return o < 0 ? i : t[o][1];
        }
        function N_(n) {
          return ta(this.__data__, n) > -1;
        }
        function L_(n, t) {
          var o = this.__data__, s = ta(o, n);
          return s < 0 ? (++this.size, o.push([n, t])) : o[s][1] = t, this;
        }
        St.prototype.clear = M_, St.prototype.delete = C_, St.prototype.get = D_, St.prototype.has = N_, St.prototype.set = L_;
        function Ot(n) {
          var t = -1, o = n == null ? 0 : n.length;
          for (this.clear(); ++t < o; ) {
            var s = n[t];
            this.set(s[0], s[1]);
          }
        }
        function F_() {
          this.size = 0, this.__data__ = {
            hash: new Sr(),
            map: new (ji || St)(),
            string: new Sr()
          };
        }
        function B_(n) {
          var t = da(this, n).delete(n);
          return this.size -= t ? 1 : 0, t;
        }
        function j_(n) {
          return da(this, n).get(n);
        }
        function q_(n) {
          return da(this, n).has(n);
        }
        function U_(n, t) {
          var o = da(this, n), s = o.size;
          return o.set(n, t), this.size += o.size == s ? 0 : 1, this;
        }
        Ot.prototype.clear = F_, Ot.prototype.delete = B_, Ot.prototype.get = j_, Ot.prototype.has = q_, Ot.prototype.set = U_;
        function Or(n) {
          var t = -1, o = n == null ? 0 : n.length;
          for (this.__data__ = new Ot(); ++t < o; )
            this.add(n[t]);
        }
        function k_(n) {
          return this.__data__.set(n, d), this;
        }
        function W_(n) {
          return this.__data__.has(n);
        }
        Or.prototype.add = Or.prototype.push = k_, Or.prototype.has = W_;
        function Xe(n) {
          var t = this.__data__ = new St(n);
          this.size = t.size;
        }
        function Y_() {
          this.__data__ = new St(), this.size = 0;
        }
        function $_(n) {
          var t = this.__data__, o = t.delete(n);
          return this.size = t.size, o;
        }
        function z_(n) {
          return this.__data__.get(n);
        }
        function G_(n) {
          return this.__data__.has(n);
        }
        function Z_(n, t) {
          var o = this.__data__;
          if (o instanceof St) {
            var s = o.__data__;
            if (!ji || s.length < u - 1)
              return s.push([n, t]), this.size = ++o.size, this;
            o = this.__data__ = new Ot(s);
          }
          return o.set(n, t), this.size = o.size, this;
        }
        Xe.prototype.clear = Y_, Xe.prototype.delete = $_, Xe.prototype.get = z_, Xe.prototype.has = G_, Xe.prototype.set = Z_;
        function rh(n, t) {
          var o = sn(n), s = !o && Pr(n), l = !o && !s && Qt(n), y = !o && !s && !l && ii(n), _ = o || s || l || y, b = _ ? Ju(n.length, r_) : [], I = b.length;
          for (var U in n)
            (t || On.call(n, U)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
            (U == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (U == "offset" || U == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            y && (U == "buffer" || U == "byteLength" || U == "byteOffset") || // Skip index properties.
            xt(U, I))) && b.push(U);
          return b;
        }
        function ih(n) {
          var t = n.length;
          return t ? n[hs(0, t - 1)] : i;
        }
        function H_(n, t) {
          return ga(de(n), Tr(t, 0, n.length));
        }
        function K_(n) {
          return ga(de(n));
        }
        function rs(n, t, o) {
          (o !== i && !Qe(n[t], o) || o === i && !(t in n)) && Tt(n, t, o);
        }
        function Wi(n, t, o) {
          var s = n[t];
          (!(On.call(n, t) && Qe(s, o)) || o === i && !(t in n)) && Tt(n, t, o);
        }
        function ta(n, t) {
          for (var o = n.length; o--; )
            if (Qe(n[o][0], t))
              return o;
          return -1;
        }
        function J_(n, t, o, s) {
          return Kt(n, function(l, y, _) {
            t(s, l, o(l), _);
          }), s;
        }
        function oh(n, t) {
          return n && pt(t, Kn(t), n);
        }
        function V_(n, t) {
          return n && pt(t, ye(t), n);
        }
        function Tt(n, t, o) {
          t == "__proto__" && Jo ? Jo(n, t, {
            configurable: !0,
            enumerable: !0,
            value: o,
            writable: !0
          }) : n[t] = o;
        }
        function is(n, t) {
          for (var o = -1, s = t.length, l = C(s), y = n == null; ++o < s; )
            l[o] = y ? i : js(n, t[o]);
          return l;
        }
        function Tr(n, t, o) {
          return n === n && (o !== i && (n = n <= o ? n : o), t !== i && (n = n >= t ? n : t)), n;
        }
        function We(n, t, o, s, l, y) {
          var _, b = t & v, I = t & w, U = t & M;
          if (o && (_ = l ? o(n, s, l, y) : o(n)), _ !== i)
            return _;
          if (!jn(n))
            return n;
          var k = sn(n);
          if (k) {
            if (_ = qw(n), !b)
              return de(n, _);
          } else {
            var $ = oe(n), G = $ == wn || $ == Bn;
            if (Qt(n))
              return xh(n, b);
            if ($ == re || $ == X || G && !l) {
              if (_ = I || G ? {} : Hh(n), !b)
                return I ? Iw(n, V_(_, n)) : Rw(n, oh(_, n));
            } else {
              if (!xn[$])
                return l ? n : {};
              _ = Uw(n, $, b);
            }
          }
          y || (y = new Xe());
          var K = y.get(n);
          if (K)
            return K;
          y.set(n, _), Ad(n) ? n.forEach(function(an) {
            _.add(We(an, t, o, an, n, y));
          }) : bd(n) && n.forEach(function(an, gn) {
            _.set(gn, We(an, t, o, gn, n, y));
          });
          var on = U ? I ? Ss : As : I ? ye : Kn, pn = k ? i : on(n);
          return qe(pn || n, function(an, gn) {
            pn && (gn = an, an = n[gn]), Wi(_, gn, We(an, t, o, gn, n, y));
          }), _;
        }
        function X_(n) {
          var t = Kn(n);
          return function(o) {
            return ah(o, n, t);
          };
        }
        function ah(n, t, o) {
          var s = o.length;
          if (n == null)
            return !s;
          for (n = Rn(n); s--; ) {
            var l = o[s], y = t[l], _ = n[l];
            if (_ === i && !(l in n) || !y(_))
              return !1;
          }
          return !0;
        }
        function uh(n, t, o) {
          if (typeof n != "function")
            throw new Ue(f);
          return Ki(function() {
            n.apply(i, o);
          }, t);
        }
        function Yi(n, t, o, s) {
          var l = -1, y = qo, _ = !0, b = n.length, I = [], U = t.length;
          if (!b)
            return I;
          o && (t = Nn(t, Ie(o))), s ? (y = $u, _ = !1) : t.length >= u && (y = Fi, _ = !1, t = new Or(t));
          n:
            for (; ++l < b; ) {
              var k = n[l], $ = o == null ? k : o(k);
              if (k = s || k !== 0 ? k : 0, _ && $ === $) {
                for (var G = U; G--; )
                  if (t[G] === $)
                    continue n;
                I.push(k);
              } else y(t, $, s) || I.push(k);
            }
          return I;
        }
        var Kt = Nh(lt), sh = Nh(as, !0);
        function Q_(n, t) {
          var o = !0;
          return Kt(n, function(s, l, y) {
            return o = !!t(s, l, y), o;
          }), o;
        }
        function ra(n, t, o) {
          for (var s = -1, l = n.length; ++s < l; ) {
            var y = n[s], _ = t(y);
            if (_ != null && (b === i ? _ === _ && !Pe(_) : o(_, b)))
              var b = _, I = y;
          }
          return I;
        }
        function nw(n, t, o, s) {
          var l = n.length;
          for (o = ln(o), o < 0 && (o = -o > l ? 0 : l + o), s = s === i || s > l ? l : ln(s), s < 0 && (s += l), s = o > s ? 0 : Od(s); o < s; )
            n[o++] = t;
          return n;
        }
        function ch(n, t) {
          var o = [];
          return Kt(n, function(s, l, y) {
            t(s, l, y) && o.push(s);
          }), o;
        }
        function Qn(n, t, o, s, l) {
          var y = -1, _ = n.length;
          for (o || (o = Ww), l || (l = []); ++y < _; ) {
            var b = n[y];
            t > 0 && o(b) ? t > 1 ? Qn(b, t - 1, o, s, l) : Gt(l, b) : s || (l[l.length] = b);
          }
          return l;
        }
        var os = Lh(), fh = Lh(!0);
        function lt(n, t) {
          return n && os(n, t, Kn);
        }
        function as(n, t) {
          return n && fh(n, t, Kn);
        }
        function ia(n, t) {
          return zt(t, function(o) {
            return Pt(n[o]);
          });
        }
        function Rr(n, t) {
          t = Vt(t, n);
          for (var o = 0, s = t.length; n != null && o < s; )
            n = n[ht(t[o++])];
          return o && o == s ? n : i;
        }
        function lh(n, t, o) {
          var s = t(n);
          return sn(n) ? s : Gt(s, o(n));
        }
        function ce(n) {
          return n == null ? n === i ? $r : zn : Ar && Ar in Rn(n) ? Fw(n) : Kw(n);
        }
        function us(n, t) {
          return n > t;
        }
        function ew(n, t) {
          return n != null && On.call(n, t);
        }
        function tw(n, t) {
          return n != null && t in Rn(n);
        }
        function rw(n, t, o) {
          return n >= ie(t, o) && n < Zn(t, o);
        }
        function ss(n, t, o) {
          for (var s = o ? $u : qo, l = n[0].length, y = n.length, _ = y, b = C(y), I = 1 / 0, U = []; _--; ) {
            var k = n[_];
            _ && t && (k = Nn(k, Ie(t))), I = ie(k.length, I), b[_] = !o && (t || l >= 120 && k.length >= 120) ? new Or(_ && k) : i;
          }
          k = n[0];
          var $ = -1, G = b[0];
          n:
            for (; ++$ < l && U.length < I; ) {
              var K = k[$], on = t ? t(K) : K;
              if (K = o || K !== 0 ? K : 0, !(G ? Fi(G, on) : s(U, on, o))) {
                for (_ = y; --_; ) {
                  var pn = b[_];
                  if (!(pn ? Fi(pn, on) : s(n[_], on, o)))
                    continue n;
                }
                G && G.push(on), U.push(K);
              }
            }
          return U;
        }
        function iw(n, t, o, s) {
          return lt(n, function(l, y, _) {
            t(s, o(l), y, _);
          }), s;
        }
        function $i(n, t, o) {
          t = Vt(t, n), n = Xh(n, t);
          var s = n == null ? n : n[ht($e(t))];
          return s == null ? i : Re(s, n, o);
        }
        function ph(n) {
          return kn(n) && ce(n) == X;
        }
        function ow(n) {
          return kn(n) && ce(n) == Li;
        }
        function aw(n) {
          return kn(n) && ce(n) == Q;
        }
        function zi(n, t, o, s, l) {
          return n === t ? !0 : n == null || t == null || !kn(n) && !kn(t) ? n !== n && t !== t : uw(n, t, o, s, zi, l);
        }
        function uw(n, t, o, s, l, y) {
          var _ = sn(n), b = sn(t), I = _ ? cn : oe(n), U = b ? cn : oe(t);
          I = I == X ? re : I, U = U == X ? re : U;
          var k = I == re, $ = U == re, G = I == U;
          if (G && Qt(n)) {
            if (!Qt(t))
              return !1;
            _ = !0, k = !1;
          }
          if (G && !k)
            return y || (y = new Xe()), _ || ii(n) ? zh(n, t, o, s, l, y) : Nw(n, t, I, o, s, l, y);
          if (!(o & E)) {
            var K = k && On.call(n, "__wrapped__"), on = $ && On.call(t, "__wrapped__");
            if (K || on) {
              var pn = K ? n.value() : n, an = on ? t.value() : t;
              return y || (y = new Xe()), l(pn, an, o, s, y);
            }
          }
          return G ? (y || (y = new Xe()), Lw(n, t, o, s, l, y)) : !1;
        }
        function sw(n) {
          return kn(n) && oe(n) == Sn;
        }
        function cs(n, t, o, s) {
          var l = o.length, y = l, _ = !s;
          if (n == null)
            return !y;
          for (n = Rn(n); l--; ) {
            var b = o[l];
            if (_ && b[2] ? b[1] !== n[b[0]] : !(b[0] in n))
              return !1;
          }
          for (; ++l < y; ) {
            b = o[l];
            var I = b[0], U = n[I], k = b[1];
            if (_ && b[2]) {
              if (U === i && !(I in n))
                return !1;
            } else {
              var $ = new Xe();
              if (s)
                var G = s(U, k, I, n, t, $);
              if (!(G === i ? zi(k, U, E | x, s, $) : G))
                return !1;
            }
          }
          return !0;
        }
        function hh(n) {
          if (!jn(n) || $w(n))
            return !1;
          var t = Pt(n) ? s_ : Xm;
          return t.test(xr(n));
        }
        function cw(n) {
          return kn(n) && ce(n) == Te;
        }
        function fw(n) {
          return kn(n) && oe(n) == Un;
        }
        function lw(n) {
          return kn(n) && ba(n.length) && !!Mn[ce(n)];
        }
        function dh(n) {
          return typeof n == "function" ? n : n == null ? ve : typeof n == "object" ? sn(n) ? vh(n[0], n[1]) : yh(n) : Fd(n);
        }
        function fs(n) {
          if (!Hi(n))
            return d_(n);
          var t = [];
          for (var o in Rn(n))
            On.call(n, o) && o != "constructor" && t.push(o);
          return t;
        }
        function pw(n) {
          if (!jn(n))
            return Hw(n);
          var t = Hi(n), o = [];
          for (var s in n)
            s == "constructor" && (t || !On.call(n, s)) || o.push(s);
          return o;
        }
        function ls(n, t) {
          return n < t;
        }
        function gh(n, t) {
          var o = -1, s = ge(n) ? C(n.length) : [];
          return Kt(n, function(l, y, _) {
            s[++o] = t(l, y, _);
          }), s;
        }
        function yh(n) {
          var t = Ts(n);
          return t.length == 1 && t[0][2] ? Jh(t[0][0], t[0][1]) : function(o) {
            return o === n || cs(o, n, t);
          };
        }
        function vh(n, t) {
          return Is(n) && Kh(t) ? Jh(ht(n), t) : function(o) {
            var s = js(o, n);
            return s === i && s === t ? qs(o, n) : zi(t, s, E | x);
          };
        }
        function oa(n, t, o, s, l) {
          n !== t && os(t, function(y, _) {
            if (l || (l = new Xe()), jn(y))
              hw(n, t, _, o, oa, s, l);
            else {
              var b = s ? s(Ps(n, _), y, _ + "", n, t, l) : i;
              b === i && (b = y), rs(n, _, b);
            }
          }, ye);
        }
        function hw(n, t, o, s, l, y, _) {
          var b = Ps(n, o), I = Ps(t, o), U = _.get(I);
          if (U) {
            rs(n, o, U);
            return;
          }
          var k = y ? y(b, I, o + "", n, t, _) : i, $ = k === i;
          if ($) {
            var G = sn(I), K = !G && Qt(I), on = !G && !K && ii(I);
            k = I, G || K || on ? sn(b) ? k = b : Wn(b) ? k = de(b) : K ? ($ = !1, k = xh(I, !0)) : on ? ($ = !1, k = Ph(I, !0)) : k = [] : Ji(I) || Pr(I) ? (k = b, Pr(b) ? k = Td(b) : (!jn(b) || Pt(b)) && (k = Hh(I))) : $ = !1;
          }
          $ && (_.set(I, k), l(k, I, s, y, _), _.delete(I)), rs(n, o, k);
        }
        function mh(n, t) {
          var o = n.length;
          if (o)
            return t += t < 0 ? o : 0, xt(t, o) ? n[t] : i;
        }
        function _h(n, t, o) {
          t.length ? t = Nn(t, function(y) {
            return sn(y) ? function(_) {
              return Rr(_, y.length === 1 ? y[0] : y);
            } : y;
          }) : t = [ve];
          var s = -1;
          t = Nn(t, Ie(rn()));
          var l = gh(n, function(y, _, b) {
            var I = Nn(t, function(U) {
              return U(y);
            });
            return { criteria: I, index: ++s, value: y };
          });
          return U1(l, function(y, _) {
            return Tw(y, _, o);
          });
        }
        function dw(n, t) {
          return wh(n, t, function(o, s) {
            return qs(n, s);
          });
        }
        function wh(n, t, o) {
          for (var s = -1, l = t.length, y = {}; ++s < l; ) {
            var _ = t[s], b = Rr(n, _);
            o(b, _) && Gi(y, Vt(_, n), b);
          }
          return y;
        }
        function gw(n) {
          return function(t) {
            return Rr(t, n);
          };
        }
        function ps(n, t, o, s) {
          var l = s ? q1 : Zr, y = -1, _ = t.length, b = n;
          for (n === t && (t = de(t)), o && (b = Nn(n, Ie(o))); ++y < _; )
            for (var I = 0, U = t[y], k = o ? o(U) : U; (I = l(b, k, I, s)) > -1; )
              b !== n && Ko.call(b, I, 1), Ko.call(n, I, 1);
          return n;
        }
        function bh(n, t) {
          for (var o = n ? t.length : 0, s = o - 1; o--; ) {
            var l = t[o];
            if (o == s || l !== y) {
              var y = l;
              xt(l) ? Ko.call(n, l, 1) : ys(n, l);
            }
          }
          return n;
        }
        function hs(n, t) {
          return n + Xo(eh() * (t - n + 1));
        }
        function yw(n, t, o, s) {
          for (var l = -1, y = Zn(Vo((t - n) / (o || 1)), 0), _ = C(y); y--; )
            _[s ? y : ++l] = n, n += o;
          return _;
        }
        function ds(n, t) {
          var o = "";
          if (!n || t < 1 || t > Dn)
            return o;
          do
            t % 2 && (o += n), t = Xo(t / 2), t && (n += n);
          while (t);
          return o;
        }
        function hn(n, t) {
          return Ms(Vh(n, t, ve), n + "");
        }
        function vw(n) {
          return ih(oi(n));
        }
        function mw(n, t) {
          var o = oi(n);
          return ga(o, Tr(t, 0, o.length));
        }
        function Gi(n, t, o, s) {
          if (!jn(n))
            return n;
          t = Vt(t, n);
          for (var l = -1, y = t.length, _ = y - 1, b = n; b != null && ++l < y; ) {
            var I = ht(t[l]), U = o;
            if (I === "__proto__" || I === "constructor" || I === "prototype")
              return n;
            if (l != _) {
              var k = b[I];
              U = s ? s(k, I, b) : i, U === i && (U = jn(k) ? k : xt(t[l + 1]) ? [] : {});
            }
            Wi(b, I, U), b = b[I];
          }
          return n;
        }
        var Eh = Qo ? function(n, t) {
          return Qo.set(n, t), n;
        } : ve, _w = Jo ? function(n, t) {
          return Jo(n, "toString", {
            configurable: !0,
            enumerable: !1,
            value: ks(t),
            writable: !0
          });
        } : ve;
        function ww(n) {
          return ga(oi(n));
        }
        function Ye(n, t, o) {
          var s = -1, l = n.length;
          t < 0 && (t = -t > l ? 0 : l + t), o = o > l ? l : o, o < 0 && (o += l), l = t > o ? 0 : o - t >>> 0, t >>>= 0;
          for (var y = C(l); ++s < l; )
            y[s] = n[s + t];
          return y;
        }
        function bw(n, t) {
          var o;
          return Kt(n, function(s, l, y) {
            return o = t(s, l, y), !o;
          }), !!o;
        }
        function aa(n, t, o) {
          var s = 0, l = n == null ? s : n.length;
          if (typeof t == "number" && t === t && l <= N) {
            for (; s < l; ) {
              var y = s + l >>> 1, _ = n[y];
              _ !== null && !Pe(_) && (o ? _ <= t : _ < t) ? s = y + 1 : l = y;
            }
            return l;
          }
          return gs(n, t, ve, o);
        }
        function gs(n, t, o, s) {
          var l = 0, y = n == null ? 0 : n.length;
          if (y === 0)
            return 0;
          t = o(t);
          for (var _ = t !== t, b = t === null, I = Pe(t), U = t === i; l < y; ) {
            var k = Xo((l + y) / 2), $ = o(n[k]), G = $ !== i, K = $ === null, on = $ === $, pn = Pe($);
            if (_)
              var an = s || on;
            else U ? an = on && (s || G) : b ? an = on && G && (s || !K) : I ? an = on && G && !K && (s || !pn) : K || pn ? an = !1 : an = s ? $ <= t : $ < t;
            an ? l = k + 1 : y = k;
          }
          return ie(y, T);
        }
        function Ah(n, t) {
          for (var o = -1, s = n.length, l = 0, y = []; ++o < s; ) {
            var _ = n[o], b = t ? t(_) : _;
            if (!o || !Qe(b, I)) {
              var I = b;
              y[l++] = _ === 0 ? 0 : _;
            }
          }
          return y;
        }
        function Sh(n) {
          return typeof n == "number" ? n : Pe(n) ? te : +n;
        }
        function xe(n) {
          if (typeof n == "string")
            return n;
          if (sn(n))
            return Nn(n, xe) + "";
          if (Pe(n))
            return th ? th.call(n) : "";
          var t = n + "";
          return t == "0" && 1 / n == -Jn ? "-0" : t;
        }
        function Jt(n, t, o) {
          var s = -1, l = qo, y = n.length, _ = !0, b = [], I = b;
          if (o)
            _ = !1, l = $u;
          else if (y >= u) {
            var U = t ? null : Cw(n);
            if (U)
              return ko(U);
            _ = !1, l = Fi, I = new Or();
          } else
            I = t ? [] : b;
          n:
            for (; ++s < y; ) {
              var k = n[s], $ = t ? t(k) : k;
              if (k = o || k !== 0 ? k : 0, _ && $ === $) {
                for (var G = I.length; G--; )
                  if (I[G] === $)
                    continue n;
                t && I.push($), b.push(k);
              } else l(I, $, o) || (I !== b && I.push($), b.push(k));
            }
          return b;
        }
        function ys(n, t) {
          return t = Vt(t, n), n = Xh(n, t), n == null || delete n[ht($e(t))];
        }
        function Oh(n, t, o, s) {
          return Gi(n, t, o(Rr(n, t)), s);
        }
        function ua(n, t, o, s) {
          for (var l = n.length, y = s ? l : -1; (s ? y-- : ++y < l) && t(n[y], y, n); )
            ;
          return o ? Ye(n, s ? 0 : y, s ? y + 1 : l) : Ye(n, s ? y + 1 : 0, s ? l : y);
        }
        function Th(n, t) {
          var o = n;
          return o instanceof vn && (o = o.value()), zu(t, function(s, l) {
            return l.func.apply(l.thisArg, Gt([s], l.args));
          }, o);
        }
        function vs(n, t, o) {
          var s = n.length;
          if (s < 2)
            return s ? Jt(n[0]) : [];
          for (var l = -1, y = C(s); ++l < s; )
            for (var _ = n[l], b = -1; ++b < s; )
              b != l && (y[l] = Yi(y[l] || _, n[b], t, o));
          return Jt(Qn(y, 1), t, o);
        }
        function Rh(n, t, o) {
          for (var s = -1, l = n.length, y = t.length, _ = {}; ++s < l; ) {
            var b = s < y ? t[s] : i;
            o(_, n[s], b);
          }
          return _;
        }
        function ms(n) {
          return Wn(n) ? n : [];
        }
        function _s(n) {
          return typeof n == "function" ? n : ve;
        }
        function Vt(n, t) {
          return sn(n) ? n : Is(n, t) ? [n] : td(An(n));
        }
        var Ew = hn;
        function Xt(n, t, o) {
          var s = n.length;
          return o = o === i ? s : o, !t && o >= s ? n : Ye(n, t, o);
        }
        var Ih = c_ || function(n) {
          return Xn.clearTimeout(n);
        };
        function xh(n, t) {
          if (t)
            return n.slice();
          var o = n.length, s = Jp ? Jp(o) : new n.constructor(o);
          return n.copy(s), s;
        }
        function ws(n) {
          var t = new n.constructor(n.byteLength);
          return new Zo(t).set(new Zo(n)), t;
        }
        function Aw(n, t) {
          var o = t ? ws(n.buffer) : n.buffer;
          return new n.constructor(o, n.byteOffset, n.byteLength);
        }
        function Sw(n) {
          var t = new n.constructor(n.source, pp.exec(n));
          return t.lastIndex = n.lastIndex, t;
        }
        function Ow(n) {
          return ki ? Rn(ki.call(n)) : {};
        }
        function Ph(n, t) {
          var o = t ? ws(n.buffer) : n.buffer;
          return new n.constructor(o, n.byteOffset, n.length);
        }
        function Mh(n, t) {
          if (n !== t) {
            var o = n !== i, s = n === null, l = n === n, y = Pe(n), _ = t !== i, b = t === null, I = t === t, U = Pe(t);
            if (!b && !U && !y && n > t || y && _ && I && !b && !U || s && _ && I || !o && I || !l)
              return 1;
            if (!s && !y && !U && n < t || U && o && l && !s && !y || b && o && l || !_ && l || !I)
              return -1;
          }
          return 0;
        }
        function Tw(n, t, o) {
          for (var s = -1, l = n.criteria, y = t.criteria, _ = l.length, b = o.length; ++s < _; ) {
            var I = Mh(l[s], y[s]);
            if (I) {
              if (s >= b)
                return I;
              var U = o[s];
              return I * (U == "desc" ? -1 : 1);
            }
          }
          return n.index - t.index;
        }
        function Ch(n, t, o, s) {
          for (var l = -1, y = n.length, _ = o.length, b = -1, I = t.length, U = Zn(y - _, 0), k = C(I + U), $ = !s; ++b < I; )
            k[b] = t[b];
          for (; ++l < _; )
            ($ || l < y) && (k[o[l]] = n[l]);
          for (; U--; )
            k[b++] = n[l++];
          return k;
        }
        function Dh(n, t, o, s) {
          for (var l = -1, y = n.length, _ = -1, b = o.length, I = -1, U = t.length, k = Zn(y - b, 0), $ = C(k + U), G = !s; ++l < k; )
            $[l] = n[l];
          for (var K = l; ++I < U; )
            $[K + I] = t[I];
          for (; ++_ < b; )
            (G || l < y) && ($[K + o[_]] = n[l++]);
          return $;
        }
        function de(n, t) {
          var o = -1, s = n.length;
          for (t || (t = C(s)); ++o < s; )
            t[o] = n[o];
          return t;
        }
        function pt(n, t, o, s) {
          var l = !o;
          o || (o = {});
          for (var y = -1, _ = t.length; ++y < _; ) {
            var b = t[y], I = s ? s(o[b], n[b], b, o, n) : i;
            I === i && (I = n[b]), l ? Tt(o, b, I) : Wi(o, b, I);
          }
          return o;
        }
        function Rw(n, t) {
          return pt(n, Rs(n), t);
        }
        function Iw(n, t) {
          return pt(n, Gh(n), t);
        }
        function sa(n, t) {
          return function(o, s) {
            var l = sn(o) ? D1 : J_, y = t ? t() : {};
            return l(o, n, rn(s, 2), y);
          };
        }
        function ei(n) {
          return hn(function(t, o) {
            var s = -1, l = o.length, y = l > 1 ? o[l - 1] : i, _ = l > 2 ? o[2] : i;
            for (y = n.length > 3 && typeof y == "function" ? (l--, y) : i, _ && fe(o[0], o[1], _) && (y = l < 3 ? i : y, l = 1), t = Rn(t); ++s < l; ) {
              var b = o[s];
              b && n(t, b, s, y);
            }
            return t;
          });
        }
        function Nh(n, t) {
          return function(o, s) {
            if (o == null)
              return o;
            if (!ge(o))
              return n(o, s);
            for (var l = o.length, y = t ? l : -1, _ = Rn(o); (t ? y-- : ++y < l) && s(_[y], y, _) !== !1; )
              ;
            return o;
          };
        }
        function Lh(n) {
          return function(t, o, s) {
            for (var l = -1, y = Rn(t), _ = s(t), b = _.length; b--; ) {
              var I = _[n ? b : ++l];
              if (o(y[I], I, y) === !1)
                break;
            }
            return t;
          };
        }
        function xw(n, t, o) {
          var s = t & B, l = Zi(n);
          function y() {
            var _ = this && this !== Xn && this instanceof y ? l : n;
            return _.apply(s ? o : this, arguments);
          }
          return y;
        }
        function Fh(n) {
          return function(t) {
            t = An(t);
            var o = Hr(t) ? Ve(t) : i, s = o ? o[0] : t.charAt(0), l = o ? Xt(o, 1).join("") : t.slice(1);
            return s[n]() + l;
          };
        }
        function ti(n) {
          return function(t) {
            return zu(Nd(Dd(t).replace(_1, "")), n, "");
          };
        }
        function Zi(n) {
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new n();
              case 1:
                return new n(t[0]);
              case 2:
                return new n(t[0], t[1]);
              case 3:
                return new n(t[0], t[1], t[2]);
              case 4:
                return new n(t[0], t[1], t[2], t[3]);
              case 5:
                return new n(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var o = ni(n.prototype), s = n.apply(o, t);
            return jn(s) ? s : o;
          };
        }
        function Pw(n, t, o) {
          var s = Zi(n);
          function l() {
            for (var y = arguments.length, _ = C(y), b = y, I = ri(l); b--; )
              _[b] = arguments[b];
            var U = y < 3 && _[0] !== I && _[y - 1] !== I ? [] : Zt(_, I);
            if (y -= U.length, y < o)
              return kh(
                n,
                t,
                ca,
                l.placeholder,
                i,
                _,
                U,
                i,
                i,
                o - y
              );
            var k = this && this !== Xn && this instanceof l ? s : n;
            return Re(k, this, _);
          }
          return l;
        }
        function Bh(n) {
          return function(t, o, s) {
            var l = Rn(t);
            if (!ge(t)) {
              var y = rn(o, 3);
              t = Kn(t), o = function(b) {
                return y(l[b], b, l);
              };
            }
            var _ = n(t, o, s);
            return _ > -1 ? l[y ? t[_] : _] : i;
          };
        }
        function jh(n) {
          return It(function(t) {
            var o = t.length, s = o, l = ke.prototype.thru;
            for (n && t.reverse(); s--; ) {
              var y = t[s];
              if (typeof y != "function")
                throw new Ue(f);
              if (l && !_ && ha(y) == "wrapper")
                var _ = new ke([], !0);
            }
            for (s = _ ? s : o; ++s < o; ) {
              y = t[s];
              var b = ha(y), I = b == "wrapper" ? Os(y) : i;
              I && xs(I[0]) && I[1] == (j | D | P | z) && !I[4].length && I[9] == 1 ? _ = _[ha(I[0])].apply(_, I[3]) : _ = y.length == 1 && xs(y) ? _[b]() : _.thru(y);
            }
            return function() {
              var U = arguments, k = U[0];
              if (_ && U.length == 1 && sn(k))
                return _.plant(k).value();
              for (var $ = 0, G = o ? t[$].apply(this, U) : k; ++$ < o; )
                G = t[$].call(this, G);
              return G;
            };
          });
        }
        function ca(n, t, o, s, l, y, _, b, I, U) {
          var k = t & j, $ = t & B, G = t & A, K = t & (D | S), on = t & Z, pn = G ? i : Zi(n);
          function an() {
            for (var gn = arguments.length, mn = C(gn), Me = gn; Me--; )
              mn[Me] = arguments[Me];
            if (K)
              var le = ri(an), Ce = W1(mn, le);
            if (s && (mn = Ch(mn, s, l, K)), y && (mn = Dh(mn, y, _, K)), gn -= Ce, K && gn < U) {
              var Yn = Zt(mn, le);
              return kh(
                n,
                t,
                ca,
                an.placeholder,
                o,
                mn,
                Yn,
                b,
                I,
                U - gn
              );
            }
            var nt = $ ? o : this, Ct = G ? nt[n] : n;
            return gn = mn.length, b ? mn = Jw(mn, b) : on && gn > 1 && mn.reverse(), k && I < gn && (mn.length = I), this && this !== Xn && this instanceof an && (Ct = pn || Zi(Ct)), Ct.apply(nt, mn);
          }
          return an;
        }
        function qh(n, t) {
          return function(o, s) {
            return iw(o, n, t(s), {});
          };
        }
        function fa(n, t) {
          return function(o, s) {
            var l;
            if (o === i && s === i)
              return t;
            if (o !== i && (l = o), s !== i) {
              if (l === i)
                return s;
              typeof o == "string" || typeof s == "string" ? (o = xe(o), s = xe(s)) : (o = Sh(o), s = Sh(s)), l = n(o, s);
            }
            return l;
          };
        }
        function bs(n) {
          return It(function(t) {
            return t = Nn(t, Ie(rn())), hn(function(o) {
              var s = this;
              return n(t, function(l) {
                return Re(l, s, o);
              });
            });
          });
        }
        function la(n, t) {
          t = t === i ? " " : xe(t);
          var o = t.length;
          if (o < 2)
            return o ? ds(t, n) : t;
          var s = ds(t, Vo(n / Kr(t)));
          return Hr(t) ? Xt(Ve(s), 0, n).join("") : s.slice(0, n);
        }
        function Mw(n, t, o, s) {
          var l = t & B, y = Zi(n);
          function _() {
            for (var b = -1, I = arguments.length, U = -1, k = s.length, $ = C(k + I), G = this && this !== Xn && this instanceof _ ? y : n; ++U < k; )
              $[U] = s[U];
            for (; I--; )
              $[U++] = arguments[++b];
            return Re(G, l ? o : this, $);
          }
          return _;
        }
        function Uh(n) {
          return function(t, o, s) {
            return s && typeof s != "number" && fe(t, o, s) && (o = s = i), t = Mt(t), o === i ? (o = t, t = 0) : o = Mt(o), s = s === i ? t < o ? 1 : -1 : Mt(s), yw(t, o, s, n);
          };
        }
        function pa(n) {
          return function(t, o) {
            return typeof t == "string" && typeof o == "string" || (t = ze(t), o = ze(o)), n(t, o);
          };
        }
        function kh(n, t, o, s, l, y, _, b, I, U) {
          var k = t & D, $ = k ? _ : i, G = k ? i : _, K = k ? y : i, on = k ? i : y;
          t |= k ? P : L, t &= ~(k ? L : P), t & R || (t &= -4);
          var pn = [
            n,
            t,
            l,
            K,
            $,
            on,
            G,
            b,
            I,
            U
          ], an = o.apply(i, pn);
          return xs(n) && Qh(an, pn), an.placeholder = s, nd(an, n, t);
        }
        function Es(n) {
          var t = Gn[n];
          return function(o, s) {
            if (o = ze(o), s = s == null ? 0 : ie(ln(s), 292), s && nh(o)) {
              var l = (An(o) + "e").split("e"), y = t(l[0] + "e" + (+l[1] + s));
              return l = (An(y) + "e").split("e"), +(l[0] + "e" + (+l[1] - s));
            }
            return t(o);
          };
        }
        var Cw = Xr && 1 / ko(new Xr([, -0]))[1] == Jn ? function(n) {
          return new Xr(n);
        } : $s;
        function Wh(n) {
          return function(t) {
            var o = oe(t);
            return o == Sn ? Xu(t) : o == Un ? K1(t) : k1(t, n(t));
          };
        }
        function Rt(n, t, o, s, l, y, _, b) {
          var I = t & A;
          if (!I && typeof n != "function")
            throw new Ue(f);
          var U = s ? s.length : 0;
          if (U || (t &= -97, s = l = i), _ = _ === i ? _ : Zn(ln(_), 0), b = b === i ? b : ln(b), U -= l ? l.length : 0, t & L) {
            var k = s, $ = l;
            s = l = i;
          }
          var G = I ? i : Os(n), K = [
            n,
            t,
            o,
            s,
            l,
            k,
            $,
            y,
            _,
            b
          ];
          if (G && Zw(K, G), n = K[0], t = K[1], o = K[2], s = K[3], l = K[4], b = K[9] = K[9] === i ? I ? 0 : n.length : Zn(K[9] - U, 0), !b && t & (D | S) && (t &= -25), !t || t == B)
            var on = xw(n, t, o);
          else t == D || t == S ? on = Pw(n, t, b) : (t == P || t == (B | P)) && !l.length ? on = Mw(n, t, o, s) : on = ca.apply(i, K);
          var pn = G ? Eh : Qh;
          return nd(pn(on, K), n, t);
        }
        function Yh(n, t, o, s) {
          return n === i || Qe(n, Vr[o]) && !On.call(s, o) ? t : n;
        }
        function $h(n, t, o, s, l, y) {
          return jn(n) && jn(t) && (y.set(t, n), oa(n, t, i, $h, y), y.delete(t)), n;
        }
        function Dw(n) {
          return Ji(n) ? i : n;
        }
        function zh(n, t, o, s, l, y) {
          var _ = o & E, b = n.length, I = t.length;
          if (b != I && !(_ && I > b))
            return !1;
          var U = y.get(n), k = y.get(t);
          if (U && k)
            return U == t && k == n;
          var $ = -1, G = !0, K = o & x ? new Or() : i;
          for (y.set(n, t), y.set(t, n); ++$ < b; ) {
            var on = n[$], pn = t[$];
            if (s)
              var an = _ ? s(pn, on, $, t, n, y) : s(on, pn, $, n, t, y);
            if (an !== i) {
              if (an)
                continue;
              G = !1;
              break;
            }
            if (K) {
              if (!Gu(t, function(gn, mn) {
                if (!Fi(K, mn) && (on === gn || l(on, gn, o, s, y)))
                  return K.push(mn);
              })) {
                G = !1;
                break;
              }
            } else if (!(on === pn || l(on, pn, o, s, y))) {
              G = !1;
              break;
            }
          }
          return y.delete(n), y.delete(t), G;
        }
        function Nw(n, t, o, s, l, y, _) {
          switch (o) {
            case zr:
              if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset)
                return !1;
              n = n.buffer, t = t.buffer;
            case Li:
              return !(n.byteLength != t.byteLength || !y(new Zo(n), new Zo(t)));
            case tn:
            case Q:
            case Vn:
              return Qe(+n, +t);
            case yn:
              return n.name == t.name && n.message == t.message;
            case Te:
            case ft:
              return n == t + "";
            case Sn:
              var b = Xu;
            case Un:
              var I = s & E;
              if (b || (b = ko), n.size != t.size && !I)
                return !1;
              var U = _.get(n);
              if (U)
                return U == t;
              s |= x, _.set(n, t);
              var k = zh(b(n), b(t), s, l, y, _);
              return _.delete(n), k;
            case At:
              if (ki)
                return ki.call(n) == ki.call(t);
          }
          return !1;
        }
        function Lw(n, t, o, s, l, y) {
          var _ = o & E, b = As(n), I = b.length, U = As(t), k = U.length;
          if (I != k && !_)
            return !1;
          for (var $ = I; $--; ) {
            var G = b[$];
            if (!(_ ? G in t : On.call(t, G)))
              return !1;
          }
          var K = y.get(n), on = y.get(t);
          if (K && on)
            return K == t && on == n;
          var pn = !0;
          y.set(n, t), y.set(t, n);
          for (var an = _; ++$ < I; ) {
            G = b[$];
            var gn = n[G], mn = t[G];
            if (s)
              var Me = _ ? s(mn, gn, G, t, n, y) : s(gn, mn, G, n, t, y);
            if (!(Me === i ? gn === mn || l(gn, mn, o, s, y) : Me)) {
              pn = !1;
              break;
            }
            an || (an = G == "constructor");
          }
          if (pn && !an) {
            var le = n.constructor, Ce = t.constructor;
            le != Ce && "constructor" in n && "constructor" in t && !(typeof le == "function" && le instanceof le && typeof Ce == "function" && Ce instanceof Ce) && (pn = !1);
          }
          return y.delete(n), y.delete(t), pn;
        }
        function It(n) {
          return Ms(Vh(n, i, ad), n + "");
        }
        function As(n) {
          return lh(n, Kn, Rs);
        }
        function Ss(n) {
          return lh(n, ye, Gh);
        }
        var Os = Qo ? function(n) {
          return Qo.get(n);
        } : $s;
        function ha(n) {
          for (var t = n.name + "", o = Qr[t], s = On.call(Qr, t) ? o.length : 0; s--; ) {
            var l = o[s], y = l.func;
            if (y == null || y == n)
              return l.name;
          }
          return t;
        }
        function ri(n) {
          var t = On.call(h, "placeholder") ? h : n;
          return t.placeholder;
        }
        function rn() {
          var n = h.iteratee || Ws;
          return n = n === Ws ? dh : n, arguments.length ? n(arguments[0], arguments[1]) : n;
        }
        function da(n, t) {
          var o = n.__data__;
          return Yw(t) ? o[typeof t == "string" ? "string" : "hash"] : o.map;
        }
        function Ts(n) {
          for (var t = Kn(n), o = t.length; o--; ) {
            var s = t[o], l = n[s];
            t[o] = [s, l, Kh(l)];
          }
          return t;
        }
        function Ir(n, t) {
          var o = G1(n, t);
          return hh(o) ? o : i;
        }
        function Fw(n) {
          var t = On.call(n, Ar), o = n[Ar];
          try {
            n[Ar] = i;
            var s = !0;
          } catch {
          }
          var l = zo.call(n);
          return s && (t ? n[Ar] = o : delete n[Ar]), l;
        }
        var Rs = ns ? function(n) {
          return n == null ? [] : (n = Rn(n), zt(ns(n), function(t) {
            return Xp.call(n, t);
          }));
        } : zs, Gh = ns ? function(n) {
          for (var t = []; n; )
            Gt(t, Rs(n)), n = Ho(n);
          return t;
        } : zs, oe = ce;
        (es && oe(new es(new ArrayBuffer(1))) != zr || ji && oe(new ji()) != Sn || ts && oe(ts.resolve()) != $t || Xr && oe(new Xr()) != Un || qi && oe(new qi()) != Ni) && (oe = function(n) {
          var t = ce(n), o = t == re ? n.constructor : i, s = o ? xr(o) : "";
          if (s)
            switch (s) {
              case m_:
                return zr;
              case __:
                return Sn;
              case w_:
                return $t;
              case b_:
                return Un;
              case E_:
                return Ni;
            }
          return t;
        });
        function Bw(n, t, o) {
          for (var s = -1, l = o.length; ++s < l; ) {
            var y = o[s], _ = y.size;
            switch (y.type) {
              case "drop":
                n += _;
                break;
              case "dropRight":
                t -= _;
                break;
              case "take":
                t = ie(t, n + _);
                break;
              case "takeRight":
                n = Zn(n, t - _);
                break;
            }
          }
          return { start: n, end: t };
        }
        function jw(n) {
          var t = n.match($m);
          return t ? t[1].split(zm) : [];
        }
        function Zh(n, t, o) {
          t = Vt(t, n);
          for (var s = -1, l = t.length, y = !1; ++s < l; ) {
            var _ = ht(t[s]);
            if (!(y = n != null && o(n, _)))
              break;
            n = n[_];
          }
          return y || ++s != l ? y : (l = n == null ? 0 : n.length, !!l && ba(l) && xt(_, l) && (sn(n) || Pr(n)));
        }
        function qw(n) {
          var t = n.length, o = new n.constructor(t);
          return t && typeof n[0] == "string" && On.call(n, "index") && (o.index = n.index, o.input = n.input), o;
        }
        function Hh(n) {
          return typeof n.constructor == "function" && !Hi(n) ? ni(Ho(n)) : {};
        }
        function Uw(n, t, o) {
          var s = n.constructor;
          switch (t) {
            case Li:
              return ws(n);
            case tn:
            case Q:
              return new s(+n);
            case zr:
              return Aw(n, o);
            case Tu:
            case Ru:
            case Iu:
            case xu:
            case Pu:
            case Mu:
            case Cu:
            case Du:
            case Nu:
              return Ph(n, o);
            case Sn:
              return new s();
            case Vn:
            case ft:
              return new s(n);
            case Te:
              return Sw(n);
            case Un:
              return new s();
            case At:
              return Ow(n);
          }
        }
        function kw(n, t) {
          var o = t.length;
          if (!o)
            return n;
          var s = o - 1;
          return t[s] = (o > 1 ? "& " : "") + t[s], t = t.join(o > 2 ? ", " : " "), n.replace(Ym, `{
/* [wrapped with ` + t + `] */
`);
        }
        function Ww(n) {
          return sn(n) || Pr(n) || !!(Qp && n && n[Qp]);
        }
        function xt(n, t) {
          var o = typeof n;
          return t = t ?? Dn, !!t && (o == "number" || o != "symbol" && n1.test(n)) && n > -1 && n % 1 == 0 && n < t;
        }
        function fe(n, t, o) {
          if (!jn(o))
            return !1;
          var s = typeof t;
          return (s == "number" ? ge(o) && xt(t, o.length) : s == "string" && t in o) ? Qe(o[t], n) : !1;
        }
        function Is(n, t) {
          if (sn(n))
            return !1;
          var o = typeof n;
          return o == "number" || o == "symbol" || o == "boolean" || n == null || Pe(n) ? !0 : qm.test(n) || !jm.test(n) || t != null && n in Rn(t);
        }
        function Yw(n) {
          var t = typeof n;
          return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
        }
        function xs(n) {
          var t = ha(n), o = h[t];
          if (typeof o != "function" || !(t in vn.prototype))
            return !1;
          if (n === o)
            return !0;
          var s = Os(o);
          return !!s && n === s[0];
        }
        function $w(n) {
          return !!Kp && Kp in n;
        }
        var zw = Yo ? Pt : Gs;
        function Hi(n) {
          var t = n && n.constructor, o = typeof t == "function" && t.prototype || Vr;
          return n === o;
        }
        function Kh(n) {
          return n === n && !jn(n);
        }
        function Jh(n, t) {
          return function(o) {
            return o == null ? !1 : o[n] === t && (t !== i || n in Rn(o));
          };
        }
        function Gw(n) {
          var t = _a(n, function(s) {
            return o.size === g && o.clear(), s;
          }), o = t.cache;
          return t;
        }
        function Zw(n, t) {
          var o = n[1], s = t[1], l = o | s, y = l < (B | A | j), _ = s == j && o == D || s == j && o == z && n[7].length <= t[8] || s == (j | z) && t[7].length <= t[8] && o == D;
          if (!(y || _))
            return n;
          s & B && (n[2] = t[2], l |= o & B ? 0 : R);
          var b = t[3];
          if (b) {
            var I = n[3];
            n[3] = I ? Ch(I, b, t[4]) : b, n[4] = I ? Zt(n[3], m) : t[4];
          }
          return b = t[5], b && (I = n[5], n[5] = I ? Dh(I, b, t[6]) : b, n[6] = I ? Zt(n[5], m) : t[6]), b = t[7], b && (n[7] = b), s & j && (n[8] = n[8] == null ? t[8] : ie(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = l, n;
        }
        function Hw(n) {
          var t = [];
          if (n != null)
            for (var o in Rn(n))
              t.push(o);
          return t;
        }
        function Kw(n) {
          return zo.call(n);
        }
        function Vh(n, t, o) {
          return t = Zn(t === i ? n.length - 1 : t, 0), function() {
            for (var s = arguments, l = -1, y = Zn(s.length - t, 0), _ = C(y); ++l < y; )
              _[l] = s[t + l];
            l = -1;
            for (var b = C(t + 1); ++l < t; )
              b[l] = s[l];
            return b[t] = o(_), Re(n, this, b);
          };
        }
        function Xh(n, t) {
          return t.length < 2 ? n : Rr(n, Ye(t, 0, -1));
        }
        function Jw(n, t) {
          for (var o = n.length, s = ie(t.length, o), l = de(n); s--; ) {
            var y = t[s];
            n[s] = xt(y, o) ? l[y] : i;
          }
          return n;
        }
        function Ps(n, t) {
          if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__")
            return n[t];
        }
        var Qh = ed(Eh), Ki = l_ || function(n, t) {
          return Xn.setTimeout(n, t);
        }, Ms = ed(_w);
        function nd(n, t, o) {
          var s = t + "";
          return Ms(n, kw(s, Vw(jw(s), o)));
        }
        function ed(n) {
          var t = 0, o = 0;
          return function() {
            var s = g_(), l = Ln - (s - o);
            if (o = s, l > 0) {
              if (++t >= bn)
                return arguments[0];
            } else
              t = 0;
            return n.apply(i, arguments);
          };
        }
        function ga(n, t) {
          var o = -1, s = n.length, l = s - 1;
          for (t = t === i ? s : t; ++o < t; ) {
            var y = hs(o, l), _ = n[y];
            n[y] = n[o], n[o] = _;
          }
          return n.length = t, n;
        }
        var td = Gw(function(n) {
          var t = [];
          return n.charCodeAt(0) === 46 && t.push(""), n.replace(Um, function(o, s, l, y) {
            t.push(l ? y.replace(Hm, "$1") : s || o);
          }), t;
        });
        function ht(n) {
          if (typeof n == "string" || Pe(n))
            return n;
          var t = n + "";
          return t == "0" && 1 / n == -Jn ? "-0" : t;
        }
        function xr(n) {
          if (n != null) {
            try {
              return $o.call(n);
            } catch {
            }
            try {
              return n + "";
            } catch {
            }
          }
          return "";
        }
        function Vw(n, t) {
          return qe(W, function(o) {
            var s = "_." + o[0];
            t & o[1] && !qo(n, s) && n.push(s);
          }), n.sort();
        }
        function rd(n) {
          if (n instanceof vn)
            return n.clone();
          var t = new ke(n.__wrapped__, n.__chain__);
          return t.__actions__ = de(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
        }
        function Xw(n, t, o) {
          (o ? fe(n, t, o) : t === i) ? t = 1 : t = Zn(ln(t), 0);
          var s = n == null ? 0 : n.length;
          if (!s || t < 1)
            return [];
          for (var l = 0, y = 0, _ = C(Vo(s / t)); l < s; )
            _[y++] = Ye(n, l, l += t);
          return _;
        }
        function Qw(n) {
          for (var t = -1, o = n == null ? 0 : n.length, s = 0, l = []; ++t < o; ) {
            var y = n[t];
            y && (l[s++] = y);
          }
          return l;
        }
        function nb() {
          var n = arguments.length;
          if (!n)
            return [];
          for (var t = C(n - 1), o = arguments[0], s = n; s--; )
            t[s - 1] = arguments[s];
          return Gt(sn(o) ? de(o) : [o], Qn(t, 1));
        }
        var eb = hn(function(n, t) {
          return Wn(n) ? Yi(n, Qn(t, 1, Wn, !0)) : [];
        }), tb = hn(function(n, t) {
          var o = $e(t);
          return Wn(o) && (o = i), Wn(n) ? Yi(n, Qn(t, 1, Wn, !0), rn(o, 2)) : [];
        }), rb = hn(function(n, t) {
          var o = $e(t);
          return Wn(o) && (o = i), Wn(n) ? Yi(n, Qn(t, 1, Wn, !0), i, o) : [];
        });
        function ib(n, t, o) {
          var s = n == null ? 0 : n.length;
          return s ? (t = o || t === i ? 1 : ln(t), Ye(n, t < 0 ? 0 : t, s)) : [];
        }
        function ob(n, t, o) {
          var s = n == null ? 0 : n.length;
          return s ? (t = o || t === i ? 1 : ln(t), t = s - t, Ye(n, 0, t < 0 ? 0 : t)) : [];
        }
        function ab(n, t) {
          return n && n.length ? ua(n, rn(t, 3), !0, !0) : [];
        }
        function ub(n, t) {
          return n && n.length ? ua(n, rn(t, 3), !0) : [];
        }
        function sb(n, t, o, s) {
          var l = n == null ? 0 : n.length;
          return l ? (o && typeof o != "number" && fe(n, t, o) && (o = 0, s = l), nw(n, t, o, s)) : [];
        }
        function id(n, t, o) {
          var s = n == null ? 0 : n.length;
          if (!s)
            return -1;
          var l = o == null ? 0 : ln(o);
          return l < 0 && (l = Zn(s + l, 0)), Uo(n, rn(t, 3), l);
        }
        function od(n, t, o) {
          var s = n == null ? 0 : n.length;
          if (!s)
            return -1;
          var l = s - 1;
          return o !== i && (l = ln(o), l = o < 0 ? Zn(s + l, 0) : ie(l, s - 1)), Uo(n, rn(t, 3), l, !0);
        }
        function ad(n) {
          var t = n == null ? 0 : n.length;
          return t ? Qn(n, 1) : [];
        }
        function cb(n) {
          var t = n == null ? 0 : n.length;
          return t ? Qn(n, Jn) : [];
        }
        function fb(n, t) {
          var o = n == null ? 0 : n.length;
          return o ? (t = t === i ? 1 : ln(t), Qn(n, t)) : [];
        }
        function lb(n) {
          for (var t = -1, o = n == null ? 0 : n.length, s = {}; ++t < o; ) {
            var l = n[t];
            s[l[0]] = l[1];
          }
          return s;
        }
        function ud(n) {
          return n && n.length ? n[0] : i;
        }
        function pb(n, t, o) {
          var s = n == null ? 0 : n.length;
          if (!s)
            return -1;
          var l = o == null ? 0 : ln(o);
          return l < 0 && (l = Zn(s + l, 0)), Zr(n, t, l);
        }
        function hb(n) {
          var t = n == null ? 0 : n.length;
          return t ? Ye(n, 0, -1) : [];
        }
        var db = hn(function(n) {
          var t = Nn(n, ms);
          return t.length && t[0] === n[0] ? ss(t) : [];
        }), gb = hn(function(n) {
          var t = $e(n), o = Nn(n, ms);
          return t === $e(o) ? t = i : o.pop(), o.length && o[0] === n[0] ? ss(o, rn(t, 2)) : [];
        }), yb = hn(function(n) {
          var t = $e(n), o = Nn(n, ms);
          return t = typeof t == "function" ? t : i, t && o.pop(), o.length && o[0] === n[0] ? ss(o, i, t) : [];
        });
        function vb(n, t) {
          return n == null ? "" : h_.call(n, t);
        }
        function $e(n) {
          var t = n == null ? 0 : n.length;
          return t ? n[t - 1] : i;
        }
        function mb(n, t, o) {
          var s = n == null ? 0 : n.length;
          if (!s)
            return -1;
          var l = s;
          return o !== i && (l = ln(o), l = l < 0 ? Zn(s + l, 0) : ie(l, s - 1)), t === t ? V1(n, t, l) : Uo(n, kp, l, !0);
        }
        function _b(n, t) {
          return n && n.length ? mh(n, ln(t)) : i;
        }
        var wb = hn(sd);
        function sd(n, t) {
          return n && n.length && t && t.length ? ps(n, t) : n;
        }
        function bb(n, t, o) {
          return n && n.length && t && t.length ? ps(n, t, rn(o, 2)) : n;
        }
        function Eb(n, t, o) {
          return n && n.length && t && t.length ? ps(n, t, i, o) : n;
        }
        var Ab = It(function(n, t) {
          var o = n == null ? 0 : n.length, s = is(n, t);
          return bh(n, Nn(t, function(l) {
            return xt(l, o) ? +l : l;
          }).sort(Mh)), s;
        });
        function Sb(n, t) {
          var o = [];
          if (!(n && n.length))
            return o;
          var s = -1, l = [], y = n.length;
          for (t = rn(t, 3); ++s < y; ) {
            var _ = n[s];
            t(_, s, n) && (o.push(_), l.push(s));
          }
          return bh(n, l), o;
        }
        function Cs(n) {
          return n == null ? n : v_.call(n);
        }
        function Ob(n, t, o) {
          var s = n == null ? 0 : n.length;
          return s ? (o && typeof o != "number" && fe(n, t, o) ? (t = 0, o = s) : (t = t == null ? 0 : ln(t), o = o === i ? s : ln(o)), Ye(n, t, o)) : [];
        }
        function Tb(n, t) {
          return aa(n, t);
        }
        function Rb(n, t, o) {
          return gs(n, t, rn(o, 2));
        }
        function Ib(n, t) {
          var o = n == null ? 0 : n.length;
          if (o) {
            var s = aa(n, t);
            if (s < o && Qe(n[s], t))
              return s;
          }
          return -1;
        }
        function xb(n, t) {
          return aa(n, t, !0);
        }
        function Pb(n, t, o) {
          return gs(n, t, rn(o, 2), !0);
        }
        function Mb(n, t) {
          var o = n == null ? 0 : n.length;
          if (o) {
            var s = aa(n, t, !0) - 1;
            if (Qe(n[s], t))
              return s;
          }
          return -1;
        }
        function Cb(n) {
          return n && n.length ? Ah(n) : [];
        }
        function Db(n, t) {
          return n && n.length ? Ah(n, rn(t, 2)) : [];
        }
        function Nb(n) {
          var t = n == null ? 0 : n.length;
          return t ? Ye(n, 1, t) : [];
        }
        function Lb(n, t, o) {
          return n && n.length ? (t = o || t === i ? 1 : ln(t), Ye(n, 0, t < 0 ? 0 : t)) : [];
        }
        function Fb(n, t, o) {
          var s = n == null ? 0 : n.length;
          return s ? (t = o || t === i ? 1 : ln(t), t = s - t, Ye(n, t < 0 ? 0 : t, s)) : [];
        }
        function Bb(n, t) {
          return n && n.length ? ua(n, rn(t, 3), !1, !0) : [];
        }
        function jb(n, t) {
          return n && n.length ? ua(n, rn(t, 3)) : [];
        }
        var qb = hn(function(n) {
          return Jt(Qn(n, 1, Wn, !0));
        }), Ub = hn(function(n) {
          var t = $e(n);
          return Wn(t) && (t = i), Jt(Qn(n, 1, Wn, !0), rn(t, 2));
        }), kb = hn(function(n) {
          var t = $e(n);
          return t = typeof t == "function" ? t : i, Jt(Qn(n, 1, Wn, !0), i, t);
        });
        function Wb(n) {
          return n && n.length ? Jt(n) : [];
        }
        function Yb(n, t) {
          return n && n.length ? Jt(n, rn(t, 2)) : [];
        }
        function $b(n, t) {
          return t = typeof t == "function" ? t : i, n && n.length ? Jt(n, i, t) : [];
        }
        function Ds(n) {
          if (!(n && n.length))
            return [];
          var t = 0;
          return n = zt(n, function(o) {
            if (Wn(o))
              return t = Zn(o.length, t), !0;
          }), Ju(t, function(o) {
            return Nn(n, Zu(o));
          });
        }
        function cd(n, t) {
          if (!(n && n.length))
            return [];
          var o = Ds(n);
          return t == null ? o : Nn(o, function(s) {
            return Re(t, i, s);
          });
        }
        var zb = hn(function(n, t) {
          return Wn(n) ? Yi(n, t) : [];
        }), Gb = hn(function(n) {
          return vs(zt(n, Wn));
        }), Zb = hn(function(n) {
          var t = $e(n);
          return Wn(t) && (t = i), vs(zt(n, Wn), rn(t, 2));
        }), Hb = hn(function(n) {
          var t = $e(n);
          return t = typeof t == "function" ? t : i, vs(zt(n, Wn), i, t);
        }), Kb = hn(Ds);
        function Jb(n, t) {
          return Rh(n || [], t || [], Wi);
        }
        function Vb(n, t) {
          return Rh(n || [], t || [], Gi);
        }
        var Xb = hn(function(n) {
          var t = n.length, o = t > 1 ? n[t - 1] : i;
          return o = typeof o == "function" ? (n.pop(), o) : i, cd(n, o);
        });
        function fd(n) {
          var t = h(n);
          return t.__chain__ = !0, t;
        }
        function Qb(n, t) {
          return t(n), n;
        }
        function ya(n, t) {
          return t(n);
        }
        var nE = It(function(n) {
          var t = n.length, o = t ? n[0] : 0, s = this.__wrapped__, l = function(y) {
            return is(y, n);
          };
          return t > 1 || this.__actions__.length || !(s instanceof vn) || !xt(o) ? this.thru(l) : (s = s.slice(o, +o + (t ? 1 : 0)), s.__actions__.push({
            func: ya,
            args: [l],
            thisArg: i
          }), new ke(s, this.__chain__).thru(function(y) {
            return t && !y.length && y.push(i), y;
          }));
        });
        function eE() {
          return fd(this);
        }
        function tE() {
          return new ke(this.value(), this.__chain__);
        }
        function rE() {
          this.__values__ === i && (this.__values__ = Sd(this.value()));
          var n = this.__index__ >= this.__values__.length, t = n ? i : this.__values__[this.__index__++];
          return { done: n, value: t };
        }
        function iE() {
          return this;
        }
        function oE(n) {
          for (var t, o = this; o instanceof ea; ) {
            var s = rd(o);
            s.__index__ = 0, s.__values__ = i, t ? l.__wrapped__ = s : t = s;
            var l = s;
            o = o.__wrapped__;
          }
          return l.__wrapped__ = n, t;
        }
        function aE() {
          var n = this.__wrapped__;
          if (n instanceof vn) {
            var t = n;
            return this.__actions__.length && (t = new vn(this)), t = t.reverse(), t.__actions__.push({
              func: ya,
              args: [Cs],
              thisArg: i
            }), new ke(t, this.__chain__);
          }
          return this.thru(Cs);
        }
        function uE() {
          return Th(this.__wrapped__, this.__actions__);
        }
        var sE = sa(function(n, t, o) {
          On.call(n, o) ? ++n[o] : Tt(n, o, 1);
        });
        function cE(n, t, o) {
          var s = sn(n) ? qp : Q_;
          return o && fe(n, t, o) && (t = i), s(n, rn(t, 3));
        }
        function fE(n, t) {
          var o = sn(n) ? zt : ch;
          return o(n, rn(t, 3));
        }
        var lE = Bh(id), pE = Bh(od);
        function hE(n, t) {
          return Qn(va(n, t), 1);
        }
        function dE(n, t) {
          return Qn(va(n, t), Jn);
        }
        function gE(n, t, o) {
          return o = o === i ? 1 : ln(o), Qn(va(n, t), o);
        }
        function ld(n, t) {
          var o = sn(n) ? qe : Kt;
          return o(n, rn(t, 3));
        }
        function pd(n, t) {
          var o = sn(n) ? N1 : sh;
          return o(n, rn(t, 3));
        }
        var yE = sa(function(n, t, o) {
          On.call(n, o) ? n[o].push(t) : Tt(n, o, [t]);
        });
        function vE(n, t, o, s) {
          n = ge(n) ? n : oi(n), o = o && !s ? ln(o) : 0;
          var l = n.length;
          return o < 0 && (o = Zn(l + o, 0)), Ea(n) ? o <= l && n.indexOf(t, o) > -1 : !!l && Zr(n, t, o) > -1;
        }
        var mE = hn(function(n, t, o) {
          var s = -1, l = typeof t == "function", y = ge(n) ? C(n.length) : [];
          return Kt(n, function(_) {
            y[++s] = l ? Re(t, _, o) : $i(_, t, o);
          }), y;
        }), _E = sa(function(n, t, o) {
          Tt(n, o, t);
        });
        function va(n, t) {
          var o = sn(n) ? Nn : gh;
          return o(n, rn(t, 3));
        }
        function wE(n, t, o, s) {
          return n == null ? [] : (sn(t) || (t = t == null ? [] : [t]), o = s ? i : o, sn(o) || (o = o == null ? [] : [o]), _h(n, t, o));
        }
        var bE = sa(function(n, t, o) {
          n[o ? 0 : 1].push(t);
        }, function() {
          return [[], []];
        });
        function EE(n, t, o) {
          var s = sn(n) ? zu : Yp, l = arguments.length < 3;
          return s(n, rn(t, 4), o, l, Kt);
        }
        function AE(n, t, o) {
          var s = sn(n) ? L1 : Yp, l = arguments.length < 3;
          return s(n, rn(t, 4), o, l, sh);
        }
        function SE(n, t) {
          var o = sn(n) ? zt : ch;
          return o(n, wa(rn(t, 3)));
        }
        function OE(n) {
          var t = sn(n) ? ih : vw;
          return t(n);
        }
        function TE(n, t, o) {
          (o ? fe(n, t, o) : t === i) ? t = 1 : t = ln(t);
          var s = sn(n) ? H_ : mw;
          return s(n, t);
        }
        function RE(n) {
          var t = sn(n) ? K_ : ww;
          return t(n);
        }
        function IE(n) {
          if (n == null)
            return 0;
          if (ge(n))
            return Ea(n) ? Kr(n) : n.length;
          var t = oe(n);
          return t == Sn || t == Un ? n.size : fs(n).length;
        }
        function xE(n, t, o) {
          var s = sn(n) ? Gu : bw;
          return o && fe(n, t, o) && (t = i), s(n, rn(t, 3));
        }
        var PE = hn(function(n, t) {
          if (n == null)
            return [];
          var o = t.length;
          return o > 1 && fe(n, t[0], t[1]) ? t = [] : o > 2 && fe(t[0], t[1], t[2]) && (t = [t[0]]), _h(n, Qn(t, 1), []);
        }), ma = f_ || function() {
          return Xn.Date.now();
        };
        function ME(n, t) {
          if (typeof t != "function")
            throw new Ue(f);
          return n = ln(n), function() {
            if (--n < 1)
              return t.apply(this, arguments);
          };
        }
        function hd(n, t, o) {
          return t = o ? i : t, t = n && t == null ? n.length : t, Rt(n, j, i, i, i, i, t);
        }
        function dd(n, t) {
          var o;
          if (typeof t != "function")
            throw new Ue(f);
          return n = ln(n), function() {
            return --n > 0 && (o = t.apply(this, arguments)), n <= 1 && (t = i), o;
          };
        }
        var Ns = hn(function(n, t, o) {
          var s = B;
          if (o.length) {
            var l = Zt(o, ri(Ns));
            s |= P;
          }
          return Rt(n, s, t, o, l);
        }), gd = hn(function(n, t, o) {
          var s = B | A;
          if (o.length) {
            var l = Zt(o, ri(gd));
            s |= P;
          }
          return Rt(t, s, n, o, l);
        });
        function yd(n, t, o) {
          t = o ? i : t;
          var s = Rt(n, D, i, i, i, i, i, t);
          return s.placeholder = yd.placeholder, s;
        }
        function vd(n, t, o) {
          t = o ? i : t;
          var s = Rt(n, S, i, i, i, i, i, t);
          return s.placeholder = vd.placeholder, s;
        }
        function md(n, t, o) {
          var s, l, y, _, b, I, U = 0, k = !1, $ = !1, G = !0;
          if (typeof n != "function")
            throw new Ue(f);
          t = ze(t) || 0, jn(o) && (k = !!o.leading, $ = "maxWait" in o, y = $ ? Zn(ze(o.maxWait) || 0, t) : y, G = "trailing" in o ? !!o.trailing : G);
          function K(Yn) {
            var nt = s, Ct = l;
            return s = l = i, U = Yn, _ = n.apply(Ct, nt), _;
          }
          function on(Yn) {
            return U = Yn, b = Ki(gn, t), k ? K(Yn) : _;
          }
          function pn(Yn) {
            var nt = Yn - I, Ct = Yn - U, Bd = t - nt;
            return $ ? ie(Bd, y - Ct) : Bd;
          }
          function an(Yn) {
            var nt = Yn - I, Ct = Yn - U;
            return I === i || nt >= t || nt < 0 || $ && Ct >= y;
          }
          function gn() {
            var Yn = ma();
            if (an(Yn))
              return mn(Yn);
            b = Ki(gn, pn(Yn));
          }
          function mn(Yn) {
            return b = i, G && s ? K(Yn) : (s = l = i, _);
          }
          function Me() {
            b !== i && Ih(b), U = 0, s = I = l = b = i;
          }
          function le() {
            return b === i ? _ : mn(ma());
          }
          function Ce() {
            var Yn = ma(), nt = an(Yn);
            if (s = arguments, l = this, I = Yn, nt) {
              if (b === i)
                return on(I);
              if ($)
                return Ih(b), b = Ki(gn, t), K(I);
            }
            return b === i && (b = Ki(gn, t)), _;
          }
          return Ce.cancel = Me, Ce.flush = le, Ce;
        }
        var CE = hn(function(n, t) {
          return uh(n, 1, t);
        }), DE = hn(function(n, t, o) {
          return uh(n, ze(t) || 0, o);
        });
        function NE(n) {
          return Rt(n, Z);
        }
        function _a(n, t) {
          if (typeof n != "function" || t != null && typeof t != "function")
            throw new Ue(f);
          var o = function() {
            var s = arguments, l = t ? t.apply(this, s) : s[0], y = o.cache;
            if (y.has(l))
              return y.get(l);
            var _ = n.apply(this, s);
            return o.cache = y.set(l, _) || y, _;
          };
          return o.cache = new (_a.Cache || Ot)(), o;
        }
        _a.Cache = Ot;
        function wa(n) {
          if (typeof n != "function")
            throw new Ue(f);
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !n.call(this);
              case 1:
                return !n.call(this, t[0]);
              case 2:
                return !n.call(this, t[0], t[1]);
              case 3:
                return !n.call(this, t[0], t[1], t[2]);
            }
            return !n.apply(this, t);
          };
        }
        function LE(n) {
          return dd(2, n);
        }
        var FE = Ew(function(n, t) {
          t = t.length == 1 && sn(t[0]) ? Nn(t[0], Ie(rn())) : Nn(Qn(t, 1), Ie(rn()));
          var o = t.length;
          return hn(function(s) {
            for (var l = -1, y = ie(s.length, o); ++l < y; )
              s[l] = t[l].call(this, s[l]);
            return Re(n, this, s);
          });
        }), Ls = hn(function(n, t) {
          var o = Zt(t, ri(Ls));
          return Rt(n, P, i, t, o);
        }), _d = hn(function(n, t) {
          var o = Zt(t, ri(_d));
          return Rt(n, L, i, t, o);
        }), BE = It(function(n, t) {
          return Rt(n, z, i, i, i, t);
        });
        function jE(n, t) {
          if (typeof n != "function")
            throw new Ue(f);
          return t = t === i ? t : ln(t), hn(n, t);
        }
        function qE(n, t) {
          if (typeof n != "function")
            throw new Ue(f);
          return t = t == null ? 0 : Zn(ln(t), 0), hn(function(o) {
            var s = o[t], l = Xt(o, 0, t);
            return s && Gt(l, s), Re(n, this, l);
          });
        }
        function UE(n, t, o) {
          var s = !0, l = !0;
          if (typeof n != "function")
            throw new Ue(f);
          return jn(o) && (s = "leading" in o ? !!o.leading : s, l = "trailing" in o ? !!o.trailing : l), md(n, t, {
            leading: s,
            maxWait: t,
            trailing: l
          });
        }
        function kE(n) {
          return hd(n, 1);
        }
        function WE(n, t) {
          return Ls(_s(t), n);
        }
        function YE() {
          if (!arguments.length)
            return [];
          var n = arguments[0];
          return sn(n) ? n : [n];
        }
        function $E(n) {
          return We(n, M);
        }
        function zE(n, t) {
          return t = typeof t == "function" ? t : i, We(n, M, t);
        }
        function GE(n) {
          return We(n, v | M);
        }
        function ZE(n, t) {
          return t = typeof t == "function" ? t : i, We(n, v | M, t);
        }
        function HE(n, t) {
          return t == null || ah(n, t, Kn(t));
        }
        function Qe(n, t) {
          return n === t || n !== n && t !== t;
        }
        var KE = pa(us), JE = pa(function(n, t) {
          return n >= t;
        }), Pr = ph(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? ph : function(n) {
          return kn(n) && On.call(n, "callee") && !Xp.call(n, "callee");
        }, sn = C.isArray, VE = Dp ? Ie(Dp) : ow;
        function ge(n) {
          return n != null && ba(n.length) && !Pt(n);
        }
        function Wn(n) {
          return kn(n) && ge(n);
        }
        function XE(n) {
          return n === !0 || n === !1 || kn(n) && ce(n) == tn;
        }
        var Qt = p_ || Gs, QE = Np ? Ie(Np) : aw;
        function nA(n) {
          return kn(n) && n.nodeType === 1 && !Ji(n);
        }
        function eA(n) {
          if (n == null)
            return !0;
          if (ge(n) && (sn(n) || typeof n == "string" || typeof n.splice == "function" || Qt(n) || ii(n) || Pr(n)))
            return !n.length;
          var t = oe(n);
          if (t == Sn || t == Un)
            return !n.size;
          if (Hi(n))
            return !fs(n).length;
          for (var o in n)
            if (On.call(n, o))
              return !1;
          return !0;
        }
        function tA(n, t) {
          return zi(n, t);
        }
        function rA(n, t, o) {
          o = typeof o == "function" ? o : i;
          var s = o ? o(n, t) : i;
          return s === i ? zi(n, t, i, o) : !!s;
        }
        function Fs(n) {
          if (!kn(n))
            return !1;
          var t = ce(n);
          return t == yn || t == nn || typeof n.message == "string" && typeof n.name == "string" && !Ji(n);
        }
        function iA(n) {
          return typeof n == "number" && nh(n);
        }
        function Pt(n) {
          if (!jn(n))
            return !1;
          var t = ce(n);
          return t == wn || t == Bn || t == en || t == Y;
        }
        function wd(n) {
          return typeof n == "number" && n == ln(n);
        }
        function ba(n) {
          return typeof n == "number" && n > -1 && n % 1 == 0 && n <= Dn;
        }
        function jn(n) {
          var t = typeof n;
          return n != null && (t == "object" || t == "function");
        }
        function kn(n) {
          return n != null && typeof n == "object";
        }
        var bd = Lp ? Ie(Lp) : sw;
        function oA(n, t) {
          return n === t || cs(n, t, Ts(t));
        }
        function aA(n, t, o) {
          return o = typeof o == "function" ? o : i, cs(n, t, Ts(t), o);
        }
        function uA(n) {
          return Ed(n) && n != +n;
        }
        function sA(n) {
          if (zw(n))
            throw new un(c);
          return hh(n);
        }
        function cA(n) {
          return n === null;
        }
        function fA(n) {
          return n == null;
        }
        function Ed(n) {
          return typeof n == "number" || kn(n) && ce(n) == Vn;
        }
        function Ji(n) {
          if (!kn(n) || ce(n) != re)
            return !1;
          var t = Ho(n);
          if (t === null)
            return !0;
          var o = On.call(t, "constructor") && t.constructor;
          return typeof o == "function" && o instanceof o && $o.call(o) == a_;
        }
        var Bs = Fp ? Ie(Fp) : cw;
        function lA(n) {
          return wd(n) && n >= -Dn && n <= Dn;
        }
        var Ad = Bp ? Ie(Bp) : fw;
        function Ea(n) {
          return typeof n == "string" || !sn(n) && kn(n) && ce(n) == ft;
        }
        function Pe(n) {
          return typeof n == "symbol" || kn(n) && ce(n) == At;
        }
        var ii = jp ? Ie(jp) : lw;
        function pA(n) {
          return n === i;
        }
        function hA(n) {
          return kn(n) && oe(n) == Ni;
        }
        function dA(n) {
          return kn(n) && ce(n) == Pm;
        }
        var gA = pa(ls), yA = pa(function(n, t) {
          return n <= t;
        });
        function Sd(n) {
          if (!n)
            return [];
          if (ge(n))
            return Ea(n) ? Ve(n) : de(n);
          if (Bi && n[Bi])
            return H1(n[Bi]());
          var t = oe(n), o = t == Sn ? Xu : t == Un ? ko : oi;
          return o(n);
        }
        function Mt(n) {
          if (!n)
            return n === 0 ? n : 0;
          if (n = ze(n), n === Jn || n === -Jn) {
            var t = n < 0 ? -1 : 1;
            return t * $n;
          }
          return n === n ? n : 0;
        }
        function ln(n) {
          var t = Mt(n), o = t % 1;
          return t === t ? o ? t - o : t : 0;
        }
        function Od(n) {
          return n ? Tr(ln(n), 0, q) : 0;
        }
        function ze(n) {
          if (typeof n == "number")
            return n;
          if (Pe(n))
            return te;
          if (jn(n)) {
            var t = typeof n.valueOf == "function" ? n.valueOf() : n;
            n = jn(t) ? t + "" : t;
          }
          if (typeof n != "string")
            return n === 0 ? n : +n;
          n = $p(n);
          var o = Vm.test(n);
          return o || Qm.test(n) ? M1(n.slice(2), o ? 2 : 8) : Jm.test(n) ? te : +n;
        }
        function Td(n) {
          return pt(n, ye(n));
        }
        function vA(n) {
          return n ? Tr(ln(n), -Dn, Dn) : n === 0 ? n : 0;
        }
        function An(n) {
          return n == null ? "" : xe(n);
        }
        var mA = ei(function(n, t) {
          if (Hi(t) || ge(t)) {
            pt(t, Kn(t), n);
            return;
          }
          for (var o in t)
            On.call(t, o) && Wi(n, o, t[o]);
        }), Rd = ei(function(n, t) {
          pt(t, ye(t), n);
        }), Aa = ei(function(n, t, o, s) {
          pt(t, ye(t), n, s);
        }), _A = ei(function(n, t, o, s) {
          pt(t, Kn(t), n, s);
        }), wA = It(is);
        function bA(n, t) {
          var o = ni(n);
          return t == null ? o : oh(o, t);
        }
        var EA = hn(function(n, t) {
          n = Rn(n);
          var o = -1, s = t.length, l = s > 2 ? t[2] : i;
          for (l && fe(t[0], t[1], l) && (s = 1); ++o < s; )
            for (var y = t[o], _ = ye(y), b = -1, I = _.length; ++b < I; ) {
              var U = _[b], k = n[U];
              (k === i || Qe(k, Vr[U]) && !On.call(n, U)) && (n[U] = y[U]);
            }
          return n;
        }), AA = hn(function(n) {
          return n.push(i, $h), Re(Id, i, n);
        });
        function SA(n, t) {
          return Up(n, rn(t, 3), lt);
        }
        function OA(n, t) {
          return Up(n, rn(t, 3), as);
        }
        function TA(n, t) {
          return n == null ? n : os(n, rn(t, 3), ye);
        }
        function RA(n, t) {
          return n == null ? n : fh(n, rn(t, 3), ye);
        }
        function IA(n, t) {
          return n && lt(n, rn(t, 3));
        }
        function xA(n, t) {
          return n && as(n, rn(t, 3));
        }
        function PA(n) {
          return n == null ? [] : ia(n, Kn(n));
        }
        function MA(n) {
          return n == null ? [] : ia(n, ye(n));
        }
        function js(n, t, o) {
          var s = n == null ? i : Rr(n, t);
          return s === i ? o : s;
        }
        function CA(n, t) {
          return n != null && Zh(n, t, ew);
        }
        function qs(n, t) {
          return n != null && Zh(n, t, tw);
        }
        var DA = qh(function(n, t, o) {
          t != null && typeof t.toString != "function" && (t = zo.call(t)), n[t] = o;
        }, ks(ve)), NA = qh(function(n, t, o) {
          t != null && typeof t.toString != "function" && (t = zo.call(t)), On.call(n, t) ? n[t].push(o) : n[t] = [o];
        }, rn), LA = hn($i);
        function Kn(n) {
          return ge(n) ? rh(n) : fs(n);
        }
        function ye(n) {
          return ge(n) ? rh(n, !0) : pw(n);
        }
        function FA(n, t) {
          var o = {};
          return t = rn(t, 3), lt(n, function(s, l, y) {
            Tt(o, t(s, l, y), s);
          }), o;
        }
        function BA(n, t) {
          var o = {};
          return t = rn(t, 3), lt(n, function(s, l, y) {
            Tt(o, l, t(s, l, y));
          }), o;
        }
        var jA = ei(function(n, t, o) {
          oa(n, t, o);
        }), Id = ei(function(n, t, o, s) {
          oa(n, t, o, s);
        }), qA = It(function(n, t) {
          var o = {};
          if (n == null)
            return o;
          var s = !1;
          t = Nn(t, function(y) {
            return y = Vt(y, n), s || (s = y.length > 1), y;
          }), pt(n, Ss(n), o), s && (o = We(o, v | w | M, Dw));
          for (var l = t.length; l--; )
            ys(o, t[l]);
          return o;
        });
        function UA(n, t) {
          return xd(n, wa(rn(t)));
        }
        var kA = It(function(n, t) {
          return n == null ? {} : dw(n, t);
        });
        function xd(n, t) {
          if (n == null)
            return {};
          var o = Nn(Ss(n), function(s) {
            return [s];
          });
          return t = rn(t), wh(n, o, function(s, l) {
            return t(s, l[0]);
          });
        }
        function WA(n, t, o) {
          t = Vt(t, n);
          var s = -1, l = t.length;
          for (l || (l = 1, n = i); ++s < l; ) {
            var y = n == null ? i : n[ht(t[s])];
            y === i && (s = l, y = o), n = Pt(y) ? y.call(n) : y;
          }
          return n;
        }
        function YA(n, t, o) {
          return n == null ? n : Gi(n, t, o);
        }
        function $A(n, t, o, s) {
          return s = typeof s == "function" ? s : i, n == null ? n : Gi(n, t, o, s);
        }
        var Pd = Wh(Kn), Md = Wh(ye);
        function zA(n, t, o) {
          var s = sn(n), l = s || Qt(n) || ii(n);
          if (t = rn(t, 4), o == null) {
            var y = n && n.constructor;
            l ? o = s ? new y() : [] : jn(n) ? o = Pt(y) ? ni(Ho(n)) : {} : o = {};
          }
          return (l ? qe : lt)(n, function(_, b, I) {
            return t(o, _, b, I);
          }), o;
        }
        function GA(n, t) {
          return n == null ? !0 : ys(n, t);
        }
        function ZA(n, t, o) {
          return n == null ? n : Oh(n, t, _s(o));
        }
        function HA(n, t, o, s) {
          return s = typeof s == "function" ? s : i, n == null ? n : Oh(n, t, _s(o), s);
        }
        function oi(n) {
          return n == null ? [] : Vu(n, Kn(n));
        }
        function KA(n) {
          return n == null ? [] : Vu(n, ye(n));
        }
        function JA(n, t, o) {
          return o === i && (o = t, t = i), o !== i && (o = ze(o), o = o === o ? o : 0), t !== i && (t = ze(t), t = t === t ? t : 0), Tr(ze(n), t, o);
        }
        function VA(n, t, o) {
          return t = Mt(t), o === i ? (o = t, t = 0) : o = Mt(o), n = ze(n), rw(n, t, o);
        }
        function XA(n, t, o) {
          if (o && typeof o != "boolean" && fe(n, t, o) && (t = o = i), o === i && (typeof t == "boolean" ? (o = t, t = i) : typeof n == "boolean" && (o = n, n = i)), n === i && t === i ? (n = 0, t = 1) : (n = Mt(n), t === i ? (t = n, n = 0) : t = Mt(t)), n > t) {
            var s = n;
            n = t, t = s;
          }
          if (o || n % 1 || t % 1) {
            var l = eh();
            return ie(n + l * (t - n + P1("1e-" + ((l + "").length - 1))), t);
          }
          return hs(n, t);
        }
        var QA = ti(function(n, t, o) {
          return t = t.toLowerCase(), n + (o ? Cd(t) : t);
        });
        function Cd(n) {
          return Us(An(n).toLowerCase());
        }
        function Dd(n) {
          return n = An(n), n && n.replace(e1, Y1).replace(w1, "");
        }
        function nS(n, t, o) {
          n = An(n), t = xe(t);
          var s = n.length;
          o = o === i ? s : Tr(ln(o), 0, s);
          var l = o;
          return o -= t.length, o >= 0 && n.slice(o, l) == t;
        }
        function eS(n) {
          return n = An(n), n && Lm.test(n) ? n.replace(fp, $1) : n;
        }
        function tS(n) {
          return n = An(n), n && km.test(n) ? n.replace(Lu, "\\$&") : n;
        }
        var rS = ti(function(n, t, o) {
          return n + (o ? "-" : "") + t.toLowerCase();
        }), iS = ti(function(n, t, o) {
          return n + (o ? " " : "") + t.toLowerCase();
        }), oS = Fh("toLowerCase");
        function aS(n, t, o) {
          n = An(n), t = ln(t);
          var s = t ? Kr(n) : 0;
          if (!t || s >= t)
            return n;
          var l = (t - s) / 2;
          return la(Xo(l), o) + n + la(Vo(l), o);
        }
        function uS(n, t, o) {
          n = An(n), t = ln(t);
          var s = t ? Kr(n) : 0;
          return t && s < t ? n + la(t - s, o) : n;
        }
        function sS(n, t, o) {
          n = An(n), t = ln(t);
          var s = t ? Kr(n) : 0;
          return t && s < t ? la(t - s, o) + n : n;
        }
        function cS(n, t, o) {
          return o || t == null ? t = 0 : t && (t = +t), y_(An(n).replace(Fu, ""), t || 0);
        }
        function fS(n, t, o) {
          return (o ? fe(n, t, o) : t === i) ? t = 1 : t = ln(t), ds(An(n), t);
        }
        function lS() {
          var n = arguments, t = An(n[0]);
          return n.length < 3 ? t : t.replace(n[1], n[2]);
        }
        var pS = ti(function(n, t, o) {
          return n + (o ? "_" : "") + t.toLowerCase();
        });
        function hS(n, t, o) {
          return o && typeof o != "number" && fe(n, t, o) && (t = o = i), o = o === i ? q : o >>> 0, o ? (n = An(n), n && (typeof t == "string" || t != null && !Bs(t)) && (t = xe(t), !t && Hr(n)) ? Xt(Ve(n), 0, o) : n.split(t, o)) : [];
        }
        var dS = ti(function(n, t, o) {
          return n + (o ? " " : "") + Us(t);
        });
        function gS(n, t, o) {
          return n = An(n), o = o == null ? 0 : Tr(ln(o), 0, n.length), t = xe(t), n.slice(o, o + t.length) == t;
        }
        function yS(n, t, o) {
          var s = h.templateSettings;
          o && fe(n, t, o) && (t = i), n = An(n), t = Aa({}, t, s, Yh);
          var l = Aa({}, t.imports, s.imports, Yh), y = Kn(l), _ = Vu(l, y), b, I, U = 0, k = t.interpolate || Fo, $ = "__p += '", G = Qu(
            (t.escape || Fo).source + "|" + k.source + "|" + (k === lp ? Km : Fo).source + "|" + (t.evaluate || Fo).source + "|$",
            "g"
          ), K = "//# sourceURL=" + (On.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++O1 + "]") + `
`;
          n.replace(G, function(an, gn, mn, Me, le, Ce) {
            return mn || (mn = Me), $ += n.slice(U, Ce).replace(t1, z1), gn && (b = !0, $ += `' +
__e(` + gn + `) +
'`), le && (I = !0, $ += `';
` + le + `;
__p += '`), mn && ($ += `' +
((__t = (` + mn + `)) == null ? '' : __t) +
'`), U = Ce + an.length, an;
          }), $ += `';
`;
          var on = On.call(t, "variable") && t.variable;
          if (!on)
            $ = `with (obj) {
` + $ + `
}
`;
          else if (Zm.test(on))
            throw new un(p);
          $ = (I ? $.replace(Mm, "") : $).replace(Cm, "$1").replace(Dm, "$1;"), $ = "function(" + (on || "obj") + `) {
` + (on ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (b ? ", __e = _.escape" : "") + (I ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + $ + `return __p
}`;
          var pn = Ld(function() {
            return En(y, K + "return " + $).apply(i, _);
          });
          if (pn.source = $, Fs(pn))
            throw pn;
          return pn;
        }
        function vS(n) {
          return An(n).toLowerCase();
        }
        function mS(n) {
          return An(n).toUpperCase();
        }
        function _S(n, t, o) {
          if (n = An(n), n && (o || t === i))
            return $p(n);
          if (!n || !(t = xe(t)))
            return n;
          var s = Ve(n), l = Ve(t), y = zp(s, l), _ = Gp(s, l) + 1;
          return Xt(s, y, _).join("");
        }
        function wS(n, t, o) {
          if (n = An(n), n && (o || t === i))
            return n.slice(0, Hp(n) + 1);
          if (!n || !(t = xe(t)))
            return n;
          var s = Ve(n), l = Gp(s, Ve(t)) + 1;
          return Xt(s, 0, l).join("");
        }
        function bS(n, t, o) {
          if (n = An(n), n && (o || t === i))
            return n.replace(Fu, "");
          if (!n || !(t = xe(t)))
            return n;
          var s = Ve(n), l = zp(s, Ve(t));
          return Xt(s, l).join("");
        }
        function ES(n, t) {
          var o = J, s = fn;
          if (jn(t)) {
            var l = "separator" in t ? t.separator : l;
            o = "length" in t ? ln(t.length) : o, s = "omission" in t ? xe(t.omission) : s;
          }
          n = An(n);
          var y = n.length;
          if (Hr(n)) {
            var _ = Ve(n);
            y = _.length;
          }
          if (o >= y)
            return n;
          var b = o - Kr(s);
          if (b < 1)
            return s;
          var I = _ ? Xt(_, 0, b).join("") : n.slice(0, b);
          if (l === i)
            return I + s;
          if (_ && (b += I.length - b), Bs(l)) {
            if (n.slice(b).search(l)) {
              var U, k = I;
              for (l.global || (l = Qu(l.source, An(pp.exec(l)) + "g")), l.lastIndex = 0; U = l.exec(k); )
                var $ = U.index;
              I = I.slice(0, $ === i ? b : $);
            }
          } else if (n.indexOf(xe(l), b) != b) {
            var G = I.lastIndexOf(l);
            G > -1 && (I = I.slice(0, G));
          }
          return I + s;
        }
        function AS(n) {
          return n = An(n), n && Nm.test(n) ? n.replace(cp, X1) : n;
        }
        var SS = ti(function(n, t, o) {
          return n + (o ? " " : "") + t.toUpperCase();
        }), Us = Fh("toUpperCase");
        function Nd(n, t, o) {
          return n = An(n), t = o ? i : t, t === i ? Z1(n) ? e_(n) : j1(n) : n.match(t) || [];
        }
        var Ld = hn(function(n, t) {
          try {
            return Re(n, i, t);
          } catch (o) {
            return Fs(o) ? o : new un(o);
          }
        }), OS = It(function(n, t) {
          return qe(t, function(o) {
            o = ht(o), Tt(n, o, Ns(n[o], n));
          }), n;
        });
        function TS(n) {
          var t = n == null ? 0 : n.length, o = rn();
          return n = t ? Nn(n, function(s) {
            if (typeof s[1] != "function")
              throw new Ue(f);
            return [o(s[0]), s[1]];
          }) : [], hn(function(s) {
            for (var l = -1; ++l < t; ) {
              var y = n[l];
              if (Re(y[0], this, s))
                return Re(y[1], this, s);
            }
          });
        }
        function RS(n) {
          return X_(We(n, v));
        }
        function ks(n) {
          return function() {
            return n;
          };
        }
        function IS(n, t) {
          return n == null || n !== n ? t : n;
        }
        var xS = jh(), PS = jh(!0);
        function ve(n) {
          return n;
        }
        function Ws(n) {
          return dh(typeof n == "function" ? n : We(n, v));
        }
        function MS(n) {
          return yh(We(n, v));
        }
        function CS(n, t) {
          return vh(n, We(t, v));
        }
        var DS = hn(function(n, t) {
          return function(o) {
            return $i(o, n, t);
          };
        }), NS = hn(function(n, t) {
          return function(o) {
            return $i(n, o, t);
          };
        });
        function Ys(n, t, o) {
          var s = Kn(t), l = ia(t, s);
          o == null && !(jn(t) && (l.length || !s.length)) && (o = t, t = n, n = this, l = ia(t, Kn(t)));
          var y = !(jn(o) && "chain" in o) || !!o.chain, _ = Pt(n);
          return qe(l, function(b) {
            var I = t[b];
            n[b] = I, _ && (n.prototype[b] = function() {
              var U = this.__chain__;
              if (y || U) {
                var k = n(this.__wrapped__), $ = k.__actions__ = de(this.__actions__);
                return $.push({ func: I, args: arguments, thisArg: n }), k.__chain__ = U, k;
              }
              return I.apply(n, Gt([this.value()], arguments));
            });
          }), n;
        }
        function LS() {
          return Xn._ === this && (Xn._ = u_), this;
        }
        function $s() {
        }
        function FS(n) {
          return n = ln(n), hn(function(t) {
            return mh(t, n);
          });
        }
        var BS = bs(Nn), jS = bs(qp), qS = bs(Gu);
        function Fd(n) {
          return Is(n) ? Zu(ht(n)) : gw(n);
        }
        function US(n) {
          return function(t) {
            return n == null ? i : Rr(n, t);
          };
        }
        var kS = Uh(), WS = Uh(!0);
        function zs() {
          return [];
        }
        function Gs() {
          return !1;
        }
        function YS() {
          return {};
        }
        function $S() {
          return "";
        }
        function zS() {
          return !0;
        }
        function GS(n, t) {
          if (n = ln(n), n < 1 || n > Dn)
            return [];
          var o = q, s = ie(n, q);
          t = rn(t), n -= q;
          for (var l = Ju(s, t); ++o < n; )
            t(o);
          return l;
        }
        function ZS(n) {
          return sn(n) ? Nn(n, ht) : Pe(n) ? [n] : de(td(An(n)));
        }
        function HS(n) {
          var t = ++o_;
          return An(n) + t;
        }
        var KS = fa(function(n, t) {
          return n + t;
        }, 0), JS = Es("ceil"), VS = fa(function(n, t) {
          return n / t;
        }, 1), XS = Es("floor");
        function QS(n) {
          return n && n.length ? ra(n, ve, us) : i;
        }
        function nO(n, t) {
          return n && n.length ? ra(n, rn(t, 2), us) : i;
        }
        function eO(n) {
          return Wp(n, ve);
        }
        function tO(n, t) {
          return Wp(n, rn(t, 2));
        }
        function rO(n) {
          return n && n.length ? ra(n, ve, ls) : i;
        }
        function iO(n, t) {
          return n && n.length ? ra(n, rn(t, 2), ls) : i;
        }
        var oO = fa(function(n, t) {
          return n * t;
        }, 1), aO = Es("round"), uO = fa(function(n, t) {
          return n - t;
        }, 0);
        function sO(n) {
          return n && n.length ? Ku(n, ve) : 0;
        }
        function cO(n, t) {
          return n && n.length ? Ku(n, rn(t, 2)) : 0;
        }
        return h.after = ME, h.ary = hd, h.assign = mA, h.assignIn = Rd, h.assignInWith = Aa, h.assignWith = _A, h.at = wA, h.before = dd, h.bind = Ns, h.bindAll = OS, h.bindKey = gd, h.castArray = YE, h.chain = fd, h.chunk = Xw, h.compact = Qw, h.concat = nb, h.cond = TS, h.conforms = RS, h.constant = ks, h.countBy = sE, h.create = bA, h.curry = yd, h.curryRight = vd, h.debounce = md, h.defaults = EA, h.defaultsDeep = AA, h.defer = CE, h.delay = DE, h.difference = eb, h.differenceBy = tb, h.differenceWith = rb, h.drop = ib, h.dropRight = ob, h.dropRightWhile = ab, h.dropWhile = ub, h.fill = sb, h.filter = fE, h.flatMap = hE, h.flatMapDeep = dE, h.flatMapDepth = gE, h.flatten = ad, h.flattenDeep = cb, h.flattenDepth = fb, h.flip = NE, h.flow = xS, h.flowRight = PS, h.fromPairs = lb, h.functions = PA, h.functionsIn = MA, h.groupBy = yE, h.initial = hb, h.intersection = db, h.intersectionBy = gb, h.intersectionWith = yb, h.invert = DA, h.invertBy = NA, h.invokeMap = mE, h.iteratee = Ws, h.keyBy = _E, h.keys = Kn, h.keysIn = ye, h.map = va, h.mapKeys = FA, h.mapValues = BA, h.matches = MS, h.matchesProperty = CS, h.memoize = _a, h.merge = jA, h.mergeWith = Id, h.method = DS, h.methodOf = NS, h.mixin = Ys, h.negate = wa, h.nthArg = FS, h.omit = qA, h.omitBy = UA, h.once = LE, h.orderBy = wE, h.over = BS, h.overArgs = FE, h.overEvery = jS, h.overSome = qS, h.partial = Ls, h.partialRight = _d, h.partition = bE, h.pick = kA, h.pickBy = xd, h.property = Fd, h.propertyOf = US, h.pull = wb, h.pullAll = sd, h.pullAllBy = bb, h.pullAllWith = Eb, h.pullAt = Ab, h.range = kS, h.rangeRight = WS, h.rearg = BE, h.reject = SE, h.remove = Sb, h.rest = jE, h.reverse = Cs, h.sampleSize = TE, h.set = YA, h.setWith = $A, h.shuffle = RE, h.slice = Ob, h.sortBy = PE, h.sortedUniq = Cb, h.sortedUniqBy = Db, h.split = hS, h.spread = qE, h.tail = Nb, h.take = Lb, h.takeRight = Fb, h.takeRightWhile = Bb, h.takeWhile = jb, h.tap = Qb, h.throttle = UE, h.thru = ya, h.toArray = Sd, h.toPairs = Pd, h.toPairsIn = Md, h.toPath = ZS, h.toPlainObject = Td, h.transform = zA, h.unary = kE, h.union = qb, h.unionBy = Ub, h.unionWith = kb, h.uniq = Wb, h.uniqBy = Yb, h.uniqWith = $b, h.unset = GA, h.unzip = Ds, h.unzipWith = cd, h.update = ZA, h.updateWith = HA, h.values = oi, h.valuesIn = KA, h.without = zb, h.words = Nd, h.wrap = WE, h.xor = Gb, h.xorBy = Zb, h.xorWith = Hb, h.zip = Kb, h.zipObject = Jb, h.zipObjectDeep = Vb, h.zipWith = Xb, h.entries = Pd, h.entriesIn = Md, h.extend = Rd, h.extendWith = Aa, Ys(h, h), h.add = KS, h.attempt = Ld, h.camelCase = QA, h.capitalize = Cd, h.ceil = JS, h.clamp = JA, h.clone = $E, h.cloneDeep = GE, h.cloneDeepWith = ZE, h.cloneWith = zE, h.conformsTo = HE, h.deburr = Dd, h.defaultTo = IS, h.divide = VS, h.endsWith = nS, h.eq = Qe, h.escape = eS, h.escapeRegExp = tS, h.every = cE, h.find = lE, h.findIndex = id, h.findKey = SA, h.findLast = pE, h.findLastIndex = od, h.findLastKey = OA, h.floor = XS, h.forEach = ld, h.forEachRight = pd, h.forIn = TA, h.forInRight = RA, h.forOwn = IA, h.forOwnRight = xA, h.get = js, h.gt = KE, h.gte = JE, h.has = CA, h.hasIn = qs, h.head = ud, h.identity = ve, h.includes = vE, h.indexOf = pb, h.inRange = VA, h.invoke = LA, h.isArguments = Pr, h.isArray = sn, h.isArrayBuffer = VE, h.isArrayLike = ge, h.isArrayLikeObject = Wn, h.isBoolean = XE, h.isBuffer = Qt, h.isDate = QE, h.isElement = nA, h.isEmpty = eA, h.isEqual = tA, h.isEqualWith = rA, h.isError = Fs, h.isFinite = iA, h.isFunction = Pt, h.isInteger = wd, h.isLength = ba, h.isMap = bd, h.isMatch = oA, h.isMatchWith = aA, h.isNaN = uA, h.isNative = sA, h.isNil = fA, h.isNull = cA, h.isNumber = Ed, h.isObject = jn, h.isObjectLike = kn, h.isPlainObject = Ji, h.isRegExp = Bs, h.isSafeInteger = lA, h.isSet = Ad, h.isString = Ea, h.isSymbol = Pe, h.isTypedArray = ii, h.isUndefined = pA, h.isWeakMap = hA, h.isWeakSet = dA, h.join = vb, h.kebabCase = rS, h.last = $e, h.lastIndexOf = mb, h.lowerCase = iS, h.lowerFirst = oS, h.lt = gA, h.lte = yA, h.max = QS, h.maxBy = nO, h.mean = eO, h.meanBy = tO, h.min = rO, h.minBy = iO, h.stubArray = zs, h.stubFalse = Gs, h.stubObject = YS, h.stubString = $S, h.stubTrue = zS, h.multiply = oO, h.nth = _b, h.noConflict = LS, h.noop = $s, h.now = ma, h.pad = aS, h.padEnd = uS, h.padStart = sS, h.parseInt = cS, h.random = XA, h.reduce = EE, h.reduceRight = AE, h.repeat = fS, h.replace = lS, h.result = WA, h.round = aO, h.runInContext = O, h.sample = OE, h.size = IE, h.snakeCase = pS, h.some = xE, h.sortedIndex = Tb, h.sortedIndexBy = Rb, h.sortedIndexOf = Ib, h.sortedLastIndex = xb, h.sortedLastIndexBy = Pb, h.sortedLastIndexOf = Mb, h.startCase = dS, h.startsWith = gS, h.subtract = uO, h.sum = sO, h.sumBy = cO, h.template = yS, h.times = GS, h.toFinite = Mt, h.toInteger = ln, h.toLength = Od, h.toLower = vS, h.toNumber = ze, h.toSafeInteger = vA, h.toString = An, h.toUpper = mS, h.trim = _S, h.trimEnd = wS, h.trimStart = bS, h.truncate = ES, h.unescape = AS, h.uniqueId = HS, h.upperCase = SS, h.upperFirst = Us, h.each = ld, h.eachRight = pd, h.first = ud, Ys(h, (function() {
          var n = {};
          return lt(h, function(t, o) {
            On.call(h.prototype, o) || (n[o] = t);
          }), n;
        })(), { chain: !1 }), h.VERSION = a, qe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
          h[n].placeholder = h;
        }), qe(["drop", "take"], function(n, t) {
          vn.prototype[n] = function(o) {
            o = o === i ? 1 : Zn(ln(o), 0);
            var s = this.__filtered__ && !t ? new vn(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = ie(o, s.__takeCount__) : s.__views__.push({
              size: ie(o, q),
              type: n + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, vn.prototype[n + "Right"] = function(o) {
            return this.reverse()[n](o).reverse();
          };
        }), qe(["filter", "map", "takeWhile"], function(n, t) {
          var o = t + 1, s = o == Fn || o == Oe;
          vn.prototype[n] = function(l) {
            var y = this.clone();
            return y.__iteratees__.push({
              iteratee: rn(l, 3),
              type: o
            }), y.__filtered__ = y.__filtered__ || s, y;
          };
        }), qe(["head", "last"], function(n, t) {
          var o = "take" + (t ? "Right" : "");
          vn.prototype[n] = function() {
            return this[o](1).value()[0];
          };
        }), qe(["initial", "tail"], function(n, t) {
          var o = "drop" + (t ? "" : "Right");
          vn.prototype[n] = function() {
            return this.__filtered__ ? new vn(this) : this[o](1);
          };
        }), vn.prototype.compact = function() {
          return this.filter(ve);
        }, vn.prototype.find = function(n) {
          return this.filter(n).head();
        }, vn.prototype.findLast = function(n) {
          return this.reverse().find(n);
        }, vn.prototype.invokeMap = hn(function(n, t) {
          return typeof n == "function" ? new vn(this) : this.map(function(o) {
            return $i(o, n, t);
          });
        }), vn.prototype.reject = function(n) {
          return this.filter(wa(rn(n)));
        }, vn.prototype.slice = function(n, t) {
          n = ln(n);
          var o = this;
          return o.__filtered__ && (n > 0 || t < 0) ? new vn(o) : (n < 0 ? o = o.takeRight(-n) : n && (o = o.drop(n)), t !== i && (t = ln(t), o = t < 0 ? o.dropRight(-t) : o.take(t - n)), o);
        }, vn.prototype.takeRightWhile = function(n) {
          return this.reverse().takeWhile(n).reverse();
        }, vn.prototype.toArray = function() {
          return this.take(q);
        }, lt(vn.prototype, function(n, t) {
          var o = /^(?:filter|find|map|reject)|While$/.test(t), s = /^(?:head|last)$/.test(t), l = h[s ? "take" + (t == "last" ? "Right" : "") : t], y = s || /^find/.test(t);
          l && (h.prototype[t] = function() {
            var _ = this.__wrapped__, b = s ? [1] : arguments, I = _ instanceof vn, U = b[0], k = I || sn(_), $ = function(gn) {
              var mn = l.apply(h, Gt([gn], b));
              return s && G ? mn[0] : mn;
            };
            k && o && typeof U == "function" && U.length != 1 && (I = k = !1);
            var G = this.__chain__, K = !!this.__actions__.length, on = y && !G, pn = I && !K;
            if (!y && k) {
              _ = pn ? _ : new vn(this);
              var an = n.apply(_, b);
              return an.__actions__.push({ func: ya, args: [$], thisArg: i }), new ke(an, G);
            }
            return on && pn ? n.apply(this, b) : (an = this.thru($), on ? s ? an.value()[0] : an.value() : an);
          });
        }), qe(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
          var t = Wo[n], o = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(n);
          h.prototype[n] = function() {
            var l = arguments;
            if (s && !this.__chain__) {
              var y = this.value();
              return t.apply(sn(y) ? y : [], l);
            }
            return this[o](function(_) {
              return t.apply(sn(_) ? _ : [], l);
            });
          };
        }), lt(vn.prototype, function(n, t) {
          var o = h[t];
          if (o) {
            var s = o.name + "";
            On.call(Qr, s) || (Qr[s] = []), Qr[s].push({ name: t, func: o });
          }
        }), Qr[ca(i, A).name] = [{
          name: "wrapper",
          func: i
        }], vn.prototype.clone = A_, vn.prototype.reverse = S_, vn.prototype.value = O_, h.prototype.at = nE, h.prototype.chain = eE, h.prototype.commit = tE, h.prototype.next = rE, h.prototype.plant = oE, h.prototype.reverse = aE, h.prototype.toJSON = h.prototype.valueOf = h.prototype.value = uE, h.prototype.first = h.prototype.head, Bi && (h.prototype[Bi] = iE), h;
      }), Jr = t_();
      Er ? ((Er.exports = Jr)._ = Jr, Wu._ = Jr) : Xn._ = Jr;
    }).call(YI);
  })(ro, ro.exports)), ro.exports;
}
var fm = $I();
const zI = "_seekBar_16dv7_14", GI = {
  seekBar: zI
};
function ZI({ value: e = 0, className: r, ...i }) {
  const { translate: a } = go(), [u, c] = hO(e), f = _i(() => fm.throttle(c, 10), []);
  return dO(() => {
    f(e);
  }, [e, f]), /* @__PURE__ */ V.createElement(
    "input",
    {
      type: "range",
      className: ot(GI.seekBar, r),
      onMouseDown: (p) => p.stopPropagation(),
      min: 0,
      max: 100,
      value: u,
      step: 1,
      style: { "--fillTo": u / 100 },
      "aria-label": a("a11y|seek_bar_label"),
      ...i
    }
  );
}
function dM({ vm: e }) {
  const { translate: r } = go(), {
    playbackState: i,
    mediaName: a = r("timeline|m.audio|unnamed_audio"),
    sizeBytes: u,
    durationSeconds: c,
    playedSeconds: f,
    percentComplete: p,
    error: d
  } = ov(e), g = u ? `(${UO(u)})` : null, m = i === "decoding";
  return /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement(
    AO,
    {
      className: ai.audioPlayer,
      tabIndex: 0,
      onKeyDown: e.onKeyDown,
      "aria-label": r("timeline|m.audio|audio_player"),
      role: "region"
    },
    /* @__PURE__ */ V.createElement(et, { gap: "var(--cpd-space-2x)", align: "center" }, /* @__PURE__ */ V.createElement(
      qO,
      {
        tabIndex: -1,
        disabled: m,
        playing: i === "playing",
        togglePlay: e.togglePlay
      }
    ), /* @__PURE__ */ V.createElement(et, { direction: "column", className: ai.mediaInfo }, /* @__PURE__ */ V.createElement("span", { className: ai.mediaName, "data-testid": "audio-player-name" }, a), /* @__PURE__ */ V.createElement(et, { className: ai.byline, gap: "var(--cpd-space-1-5x)" }, /* @__PURE__ */ V.createElement(Tg, { seconds: c }), g))),
    /* @__PURE__ */ V.createElement(et, { align: "center", gap: "var(--cpd-space-1x)", "data-testid": "audio-player-seek" }, /* @__PURE__ */ V.createElement(ZI, { tabIndex: -1, disabled: m, value: p, onChange: e.onSeekbarChange }), /* @__PURE__ */ V.createElement(Tg, { className: ai.clock, seconds: f, role: "timer" }))
  ), d && /* @__PURE__ */ V.createElement("span", { className: ai.error }, r("timeline|m.audio|error_downloading_audio")));
}
const HI = "_avatarWithDetails_7ga8t_8", KI = "_title_7ga8t_17", JI = "_details_7ga8t_28", tc = {
  avatarWithDetails: HI,
  title: KI,
  details: JI
};
function gM({
  as: e,
  className: r,
  details: i,
  avatar: a,
  title: u,
  ...c
}) {
  const f = e || "div";
  return /* @__PURE__ */ V.createElement(f, { className: ot(tc.avatarWithDetails, r), ...c }, a, /* @__PURE__ */ V.createElement(et, { direction: "column" }, /* @__PURE__ */ V.createElement("span", { className: tc.title }, u), /* @__PURE__ */ V.createElement("span", { className: tc.details }, i)));
}
function lm(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "m10.6 13.8-2.15-2.15a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275zM12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    })
  });
}
lm.displayName = "CheckCircleIcon";
const VI = Br(lm);
function pm(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "M12 17q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m0 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22"
    })
  });
}
pm.displayName = "ErrorSolidIcon";
const XI = Br(pm);
function hm(e, r) {
  return /* @__PURE__ */ pe.jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: [/* @__PURE__ */ pe.jsx("path", {
      d: "M11.288 7.288A.97.97 0 0 1 12 7q.424 0 .713.287Q13 7.576 13 8t-.287.713A.97.97 0 0 1 12 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 8q0-.424.287-.713m.001 4.001A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713v4q0 .424-.287.712A.97.97 0 0 1 12 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 16v-4q0-.424.287-.713"
    }), /* @__PURE__ */ pe.jsx("path", {
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
      clipRule: "evenodd"
    })]
  });
}
hm.displayName = "InfoIcon";
const Ig = Br(hm), QI = "_banner_15kcv_20", nx = "_content_15kcv_53", ex = "_icon_15kcv_65", tx = "_actions_15kcv_85", xa = {
  banner: QI,
  content: nx,
  icon: ex,
  actions: tx
};
var Cr = {}, Dr = {}, xg;
function rx() {
  if (xg) return Dr;
  xg = 1, Object.defineProperty(Dr, "__esModule", { value: !0 }), Dr.getNormalizedLanguageKeys = Dr.normalizeLanguageKey = void 0;
  function e(i) {
    return i.toLowerCase().replace("_", "-");
  }
  Dr.normalizeLanguageKey = e;
  function r(i) {
    const a = [], u = e(i), c = u.split("-");
    return c.length === 2 && c[0] === c[1] ? a.push(c[0]) : (a.push(u), c.length === 2 && a.push(c[0])), a;
  }
  return Dr.getNormalizedLanguageKeys = r, Dr;
}
var rc = {}, Pg;
function ix() {
  return Pg || (Pg = 1, Object.defineProperty(rc, "__esModule", { value: !0 })), rc;
}
var Mg;
function ox() {
  return Mg || (Mg = 1, (function(e) {
    var r = Cr && Cr.__createBinding || (Object.create ? (function(a, u, c, f) {
      f === void 0 && (f = c);
      var p = Object.getOwnPropertyDescriptor(u, c);
      (!p || ("get" in p ? !u.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return u[c];
      } }), Object.defineProperty(a, f, p);
    }) : (function(a, u, c, f) {
      f === void 0 && (f = c), a[f] = u[c];
    })), i = Cr && Cr.__exportStar || function(a, u) {
      for (var c in a) c !== "default" && !Object.prototype.hasOwnProperty.call(u, c) && r(u, a, c);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.KEY_SEPARATOR = void 0, e.KEY_SEPARATOR = "|", i(rx(), e), i(ix(), e);
  })(Cr)), Cr;
}
var Au = ox(), ic, Cg;
function ax() {
  if (Cg) return ic;
  Cg = 1;
  var e = Object.prototype.hasOwnProperty, r = Object.prototype.toString, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, u = function(g) {
    return typeof Array.isArray == "function" ? Array.isArray(g) : r.call(g) === "[object Array]";
  }, c = function(g) {
    if (!g || r.call(g) !== "[object Object]")
      return !1;
    var m = e.call(g, "constructor"), v = g.constructor && g.constructor.prototype && e.call(g.constructor.prototype, "isPrototypeOf");
    if (g.constructor && !m && !v)
      return !1;
    var w;
    for (w in g)
      ;
    return typeof w > "u" || e.call(g, w);
  }, f = function(g, m) {
    i && m.name === "__proto__" ? i(g, m.name, {
      enumerable: !0,
      configurable: !0,
      value: m.newValue,
      writable: !0
    }) : g[m.name] = m.newValue;
  }, p = function(g, m) {
    if (m === "__proto__")
      if (e.call(g, m)) {
        if (a)
          return a(g, m).value;
      } else return;
    return g[m];
  };
  return ic = function d() {
    var g, m, v, w, M, E, x = arguments[0], B = 1, A = arguments.length, R = !1;
    for (typeof x == "boolean" && (R = x, x = arguments[1] || {}, B = 2), (x == null || typeof x != "object" && typeof x != "function") && (x = {}); B < A; ++B)
      if (g = arguments[B], g != null)
        for (m in g)
          v = p(x, m), w = p(g, m), x !== w && (R && w && (c(w) || (M = u(w))) ? (M ? (M = !1, E = v && u(v) ? v : []) : E = v && c(v) ? v : {}, f(x, { name: m, newValue: d(R, E, w) })) : typeof w < "u" && f(x, { name: m, newValue: w }));
    return x;
  }, ic;
}
var oc = {}, ac = {}, uc, Dg;
function dm() {
  return Dg || (Dg = 1, uc = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var r = {}, i = Symbol("test"), a = Object(i);
    if (typeof i == "string" || Object.prototype.toString.call(i) !== "[object Symbol]" || Object.prototype.toString.call(a) !== "[object Symbol]")
      return !1;
    var u = 42;
    r[i] = u;
    for (var c in r)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
      return !1;
    var f = Object.getOwnPropertySymbols(r);
    if (f.length !== 1 || f[0] !== i || !Object.prototype.propertyIsEnumerable.call(r, i))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var p = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(r, i)
      );
      if (p.value !== u || p.enumerable !== !0)
        return !1;
    }
    return !0;
  }), uc;
}
var sc, Ng;
function Su() {
  if (Ng) return sc;
  Ng = 1;
  var e = dm();
  return sc = function() {
    return e() && !!Symbol.toStringTag;
  }, sc;
}
var cc, Lg;
function gm() {
  return Lg || (Lg = 1, cc = Object), cc;
}
var fc, Fg;
function ux() {
  return Fg || (Fg = 1, fc = Error), fc;
}
var lc, Bg;
function sx() {
  return Bg || (Bg = 1, lc = EvalError), lc;
}
var pc, jg;
function cx() {
  return jg || (jg = 1, pc = RangeError), pc;
}
var hc, qg;
function fx() {
  return qg || (qg = 1, hc = ReferenceError), hc;
}
var dc, Ug;
function ym() {
  return Ug || (Ug = 1, dc = SyntaxError), dc;
}
var gc, kg;
function Do() {
  return kg || (kg = 1, gc = TypeError), gc;
}
var yc, Wg;
function lx() {
  return Wg || (Wg = 1, yc = URIError), yc;
}
var vc, Yg;
function px() {
  return Yg || (Yg = 1, vc = Math.abs), vc;
}
var mc, $g;
function hx() {
  return $g || ($g = 1, mc = Math.floor), mc;
}
var _c, zg;
function dx() {
  return zg || (zg = 1, _c = Math.max), _c;
}
var wc, Gg;
function gx() {
  return Gg || (Gg = 1, wc = Math.min), wc;
}
var bc, Zg;
function yx() {
  return Zg || (Zg = 1, bc = Math.pow), bc;
}
var Ec, Hg;
function vx() {
  return Hg || (Hg = 1, Ec = Math.round), Ec;
}
var Ac, Kg;
function mx() {
  return Kg || (Kg = 1, Ac = Number.isNaN || function(r) {
    return r !== r;
  }), Ac;
}
var Sc, Jg;
function _x() {
  if (Jg) return Sc;
  Jg = 1;
  var e = /* @__PURE__ */ mx();
  return Sc = function(i) {
    return e(i) || i === 0 ? i : i < 0 ? -1 : 1;
  }, Sc;
}
var Oc, Vg;
function wx() {
  return Vg || (Vg = 1, Oc = Object.getOwnPropertyDescriptor), Oc;
}
var Tc, Xg;
function Di() {
  if (Xg) return Tc;
  Xg = 1;
  var e = /* @__PURE__ */ wx();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Tc = e, Tc;
}
var Rc, Qg;
function Ou() {
  if (Qg) return Rc;
  Qg = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Rc = e, Rc;
}
var Ic, ny;
function bx() {
  if (ny) return Ic;
  ny = 1;
  var e = typeof Symbol < "u" && Symbol, r = dm();
  return Ic = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : r();
  }, Ic;
}
var xc, ey;
function vm() {
  return ey || (ey = 1, xc = typeof Reflect < "u" && Reflect.getPrototypeOf || null), xc;
}
var Pc, ty;
function mm() {
  if (ty) return Pc;
  ty = 1;
  var e = /* @__PURE__ */ gm();
  return Pc = e.getPrototypeOf || null, Pc;
}
var Mc, ry;
function Ex() {
  if (ry) return Mc;
  ry = 1;
  var e = "Function.prototype.bind called on incompatible ", r = Object.prototype.toString, i = Math.max, a = "[object Function]", u = function(d, g) {
    for (var m = [], v = 0; v < d.length; v += 1)
      m[v] = d[v];
    for (var w = 0; w < g.length; w += 1)
      m[w + d.length] = g[w];
    return m;
  }, c = function(d, g) {
    for (var m = [], v = g, w = 0; v < d.length; v += 1, w += 1)
      m[w] = d[v];
    return m;
  }, f = function(p, d) {
    for (var g = "", m = 0; m < p.length; m += 1)
      g += p[m], m + 1 < p.length && (g += d);
    return g;
  };
  return Mc = function(d) {
    var g = this;
    if (typeof g != "function" || r.apply(g) !== a)
      throw new TypeError(e + g);
    for (var m = c(arguments, 1), v, w = function() {
      if (this instanceof v) {
        var A = g.apply(
          this,
          u(m, arguments)
        );
        return Object(A) === A ? A : this;
      }
      return g.apply(
        d,
        u(m, arguments)
      );
    }, M = i(0, g.length - m.length), E = [], x = 0; x < M; x++)
      E[x] = "$" + x;
    if (v = Function("binder", "return function (" + f(E, ",") + "){ return binder.apply(this,arguments); }")(w), g.prototype) {
      var B = function() {
      };
      B.prototype = g.prototype, v.prototype = new B(), B.prototype = null;
    }
    return v;
  }, Mc;
}
var Cc, iy;
function No() {
  if (iy) return Cc;
  iy = 1;
  var e = Ex();
  return Cc = Function.prototype.bind || e, Cc;
}
var Dc, oy;
function rp() {
  return oy || (oy = 1, Dc = Function.prototype.call), Dc;
}
var Nc, ay;
function ip() {
  return ay || (ay = 1, Nc = Function.prototype.apply), Nc;
}
var Lc, uy;
function Ax() {
  return uy || (uy = 1, Lc = typeof Reflect < "u" && Reflect && Reflect.apply), Lc;
}
var Fc, sy;
function _m() {
  if (sy) return Fc;
  sy = 1;
  var e = No(), r = ip(), i = rp(), a = Ax();
  return Fc = a || e.call(i, r), Fc;
}
var Bc, cy;
function op() {
  if (cy) return Bc;
  cy = 1;
  var e = No(), r = /* @__PURE__ */ Do(), i = rp(), a = _m();
  return Bc = function(c) {
    if (c.length < 1 || typeof c[0] != "function")
      throw new r("a function is required");
    return a(e, i, c);
  }, Bc;
}
var jc, fy;
function Sx() {
  if (fy) return jc;
  fy = 1;
  var e = op(), r = /* @__PURE__ */ Di(), i;
  try {
    i = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (f) {
    if (!f || typeof f != "object" || !("code" in f) || f.code !== "ERR_PROTO_ACCESS")
      throw f;
  }
  var a = !!i && r && r(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), u = Object, c = u.getPrototypeOf;
  return jc = a && typeof a.get == "function" ? e([a.get]) : typeof c == "function" ? (
    /** @type {import('./get')} */
    function(p) {
      return c(p == null ? p : u(p));
    }
  ) : !1, jc;
}
var qc, ly;
function ap() {
  if (ly) return qc;
  ly = 1;
  var e = vm(), r = mm(), i = /* @__PURE__ */ Sx();
  return qc = e ? function(u) {
    return e(u);
  } : r ? function(u) {
    if (!u || typeof u != "object" && typeof u != "function")
      throw new TypeError("getProto: not an object");
    return r(u);
  } : i ? function(u) {
    return i(u);
  } : null, qc;
}
var Uc, py;
function wm() {
  if (py) return Uc;
  py = 1;
  var e = Function.prototype.call, r = Object.prototype.hasOwnProperty, i = No();
  return Uc = i.call(e, r), Uc;
}
var kc, hy;
function bm() {
  if (hy) return kc;
  hy = 1;
  var e, r = /* @__PURE__ */ gm(), i = /* @__PURE__ */ ux(), a = /* @__PURE__ */ sx(), u = /* @__PURE__ */ cx(), c = /* @__PURE__ */ fx(), f = /* @__PURE__ */ ym(), p = /* @__PURE__ */ Do(), d = /* @__PURE__ */ lx(), g = /* @__PURE__ */ px(), m = /* @__PURE__ */ hx(), v = /* @__PURE__ */ dx(), w = /* @__PURE__ */ gx(), M = /* @__PURE__ */ yx(), E = /* @__PURE__ */ vx(), x = /* @__PURE__ */ _x(), B = Function, A = function(Q) {
    try {
      return B('"use strict"; return (' + Q + ").constructor;")();
    } catch {
    }
  }, R = /* @__PURE__ */ Di(), D = /* @__PURE__ */ Ou(), S = function() {
    throw new p();
  }, P = R ? (function() {
    try {
      return arguments.callee, S;
    } catch {
      try {
        return R(arguments, "callee").get;
      } catch {
        return S;
      }
    }
  })() : S, L = bx()(), j = ap(), z = mm(), Z = vm(), J = ip(), fn = rp(), bn = {}, Ln = typeof Uint8Array > "u" || !j ? e : j(Uint8Array), Fn = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": L && j ? j([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": bn,
    "%AsyncGenerator%": bn,
    "%AsyncGeneratorFunction%": bn,
    "%AsyncIteratorPrototype%": bn,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": i,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": a,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": B,
    "%GeneratorFunction%": bn,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": L && j ? j(j([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !L || !j ? e : j((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": r,
    "%Object.getOwnPropertyDescriptor%": R,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": u,
    "%ReferenceError%": c,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !L || !j ? e : j((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": L && j ? j(""[Symbol.iterator]()) : e,
    "%Symbol%": L ? Symbol : e,
    "%SyntaxError%": f,
    "%ThrowTypeError%": P,
    "%TypedArray%": Ln,
    "%TypeError%": p,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": d,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": fn,
    "%Function.prototype.apply%": J,
    "%Object.defineProperty%": D,
    "%Object.getPrototypeOf%": z,
    "%Math.abs%": g,
    "%Math.floor%": m,
    "%Math.max%": v,
    "%Math.min%": w,
    "%Math.pow%": M,
    "%Math.round%": E,
    "%Math.sign%": x,
    "%Reflect.getPrototypeOf%": Z
  };
  if (j)
    try {
      null.error;
    } catch (Q) {
      var Se = j(j(Q));
      Fn["%Error.prototype%"] = Se;
    }
  var Oe = function Q(nn) {
    var yn;
    if (nn === "%AsyncFunction%")
      yn = A("async function () {}");
    else if (nn === "%GeneratorFunction%")
      yn = A("function* () {}");
    else if (nn === "%AsyncGeneratorFunction%")
      yn = A("async function* () {}");
    else if (nn === "%AsyncGenerator%") {
      var wn = Q("%AsyncGeneratorFunction%");
      wn && (yn = wn.prototype);
    } else if (nn === "%AsyncIteratorPrototype%") {
      var Bn = Q("%AsyncGenerator%");
      Bn && j && (yn = j(Bn.prototype));
    }
    return Fn[nn] = yn, yn;
  }, Jn = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Dn = No(), $n = /* @__PURE__ */ wm(), te = Dn.call(fn, Array.prototype.concat), q = Dn.call(J, Array.prototype.splice), T = Dn.call(fn, String.prototype.replace), N = Dn.call(fn, String.prototype.slice), W = Dn.call(fn, RegExp.prototype.exec), X = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, cn = /\\(\\)?/g, en = function(nn) {
    var yn = N(nn, 0, 1), wn = N(nn, -1);
    if (yn === "%" && wn !== "%")
      throw new f("invalid intrinsic syntax, expected closing `%`");
    if (wn === "%" && yn !== "%")
      throw new f("invalid intrinsic syntax, expected opening `%`");
    var Bn = [];
    return T(nn, X, function(Sn, Vn, zn, re) {
      Bn[Bn.length] = zn ? T(re, cn, "$1") : Vn || Sn;
    }), Bn;
  }, tn = function(nn, yn) {
    var wn = nn, Bn;
    if ($n(Jn, wn) && (Bn = Jn[wn], wn = "%" + Bn[0] + "%"), $n(Fn, wn)) {
      var Sn = Fn[wn];
      if (Sn === bn && (Sn = Oe(wn)), typeof Sn > "u" && !yn)
        throw new p("intrinsic " + nn + " exists, but is not available. Please file an issue!");
      return {
        alias: Bn,
        name: wn,
        value: Sn
      };
    }
    throw new f("intrinsic " + nn + " does not exist!");
  };
  return kc = function(nn, yn) {
    if (typeof nn != "string" || nn.length === 0)
      throw new p("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof yn != "boolean")
      throw new p('"allowMissing" argument must be a boolean');
    if (W(/^%?[^%]*%?$/, nn) === null)
      throw new f("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var wn = en(nn), Bn = wn.length > 0 ? wn[0] : "", Sn = tn("%" + Bn + "%", yn), Vn = Sn.name, zn = Sn.value, re = !1, $t = Sn.alias;
    $t && (Bn = $t[0], q(wn, te([0, 1], $t)));
    for (var Y = 1, Te = !0; Y < wn.length; Y += 1) {
      var Un = wn[Y], ft = N(Un, 0, 1), At = N(Un, -1);
      if ((ft === '"' || ft === "'" || ft === "`" || At === '"' || At === "'" || At === "`") && ft !== At)
        throw new f("property names with quotes must have matching quotes");
      if ((Un === "constructor" || !Te) && (re = !0), Bn += "." + Un, Vn = "%" + Bn + "%", $n(Fn, Vn))
        zn = Fn[Vn];
      else if (zn != null) {
        if (!(Un in zn)) {
          if (!yn)
            throw new p("base intrinsic for " + nn + " exists, but the property is not available.");
          return;
        }
        if (R && Y + 1 >= wn.length) {
          var $r = R(zn, Un);
          Te = !!$r, Te && "get" in $r && !("originalValue" in $r.get) ? zn = $r.get : zn = zn[Un];
        } else
          Te = $n(zn, Un), zn = zn[Un];
        Te && !re && (Fn[Vn] = zn);
      }
    }
    return zn;
  }, kc;
}
var Wc, dy;
function Lo() {
  if (dy) return Wc;
  dy = 1;
  var e = /* @__PURE__ */ bm(), r = op(), i = r([e("%String.prototype.indexOf%")]);
  return Wc = function(u, c) {
    var f = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(u, !!c)
    );
    return typeof f == "function" && i(u, ".prototype.") > -1 ? r(
      /** @type {const} */
      [f]
    ) : f;
  }, Wc;
}
var Yc, gy;
function Ox() {
  if (gy) return Yc;
  gy = 1;
  var e = Su()(), r = /* @__PURE__ */ Lo(), i = r("Object.prototype.toString"), a = function(p) {
    return e && p && typeof p == "object" && Symbol.toStringTag in p ? !1 : i(p) === "[object Arguments]";
  }, u = function(p) {
    return a(p) ? !0 : p !== null && typeof p == "object" && "length" in p && typeof p.length == "number" && p.length >= 0 && i(p) !== "[object Array]" && "callee" in p && i(p.callee) === "[object Function]";
  }, c = (function() {
    return a(arguments);
  })();
  return a.isLegacyArguments = u, Yc = c ? a : u, Yc;
}
var $c, yy;
function Tx() {
  if (yy) return $c;
  yy = 1;
  var e = /* @__PURE__ */ Lo(), r = Su()(), i = /* @__PURE__ */ wm(), a = /* @__PURE__ */ Di(), u;
  if (r) {
    var c = e("RegExp.prototype.exec"), f = {}, p = function() {
      throw f;
    }, d = {
      toString: p,
      valueOf: p
    };
    typeof Symbol.toPrimitive == "symbol" && (d[Symbol.toPrimitive] = p), u = function(w) {
      if (!w || typeof w != "object")
        return !1;
      var M = (
        /** @type {NonNullable<typeof gOPD>} */
        a(
          /** @type {{ lastIndex?: unknown }} */
          w,
          "lastIndex"
        )
      ), E = M && i(M, "value");
      if (!E)
        return !1;
      try {
        c(
          w,
          /** @type {string} */
          /** @type {unknown} */
          d
        );
      } catch (x) {
        return x === f;
      }
    };
  } else {
    var g = e("Object.prototype.toString"), m = "[object RegExp]";
    u = function(w) {
      return !w || typeof w != "object" && typeof w != "function" ? !1 : g(w) === m;
    };
  }
  return $c = u, $c;
}
var zc, vy;
function Rx() {
  if (vy) return zc;
  vy = 1;
  var e = /* @__PURE__ */ Lo(), r = Tx(), i = e("RegExp.prototype.exec"), a = /* @__PURE__ */ Do();
  return zc = function(c) {
    if (!r(c))
      throw new a("`regex` must be a RegExp");
    return function(p) {
      return i(c, p) !== null;
    };
  }, zc;
}
var Gc, my;
function Ix() {
  if (my) return Gc;
  my = 1;
  const e = (
    /** @type {GeneratorFunctionConstructor} */
    (function* () {
    }).constructor
  );
  return Gc = () => e, Gc;
}
var Zc, _y;
function xx() {
  if (_y) return Zc;
  _y = 1;
  var e = /* @__PURE__ */ Lo(), r = /* @__PURE__ */ Rx(), i = r(/^\s*(?:function)?\*/), a = Su()(), u = ap(), c = e("Object.prototype.toString"), f = e("Function.prototype.toString"), p = /* @__PURE__ */ Ix();
  return Zc = function(g) {
    if (typeof g != "function")
      return !1;
    if (i(f(g)))
      return !0;
    if (!a) {
      var m = c(g);
      return m === "[object GeneratorFunction]";
    }
    if (!u)
      return !1;
    var v = p();
    return v && u(g) === v.prototype;
  }, Zc;
}
var Hc, wy;
function Px() {
  if (wy) return Hc;
  wy = 1;
  var e = Function.prototype.toString, r = typeof Reflect == "object" && Reflect !== null && Reflect.apply, i, a;
  if (typeof r == "function" && typeof Object.defineProperty == "function")
    try {
      i = Object.defineProperty({}, "length", {
        get: function() {
          throw a;
        }
      }), a = {}, r(function() {
        throw 42;
      }, null, i);
    } catch (R) {
      R !== a && (r = null);
    }
  else
    r = null;
  var u = /^\s*class\b/, c = function(D) {
    try {
      var S = e.call(D);
      return u.test(S);
    } catch {
      return !1;
    }
  }, f = function(D) {
    try {
      return c(D) ? !1 : (e.call(D), !0);
    } catch {
      return !1;
    }
  }, p = Object.prototype.toString, d = "[object Object]", g = "[object Function]", m = "[object GeneratorFunction]", v = "[object HTMLAllCollection]", w = "[object HTML document.all class]", M = "[object HTMLCollection]", E = typeof Symbol == "function" && !!Symbol.toStringTag, x = !(0 in [,]), B = function() {
    return !1;
  };
  if (typeof document == "object") {
    var A = document.all;
    p.call(A) === p.call(document.all) && (B = function(D) {
      if ((x || !D) && (typeof D > "u" || typeof D == "object"))
        try {
          var S = p.call(D);
          return (S === v || S === w || S === M || S === d) && D("") == null;
        } catch {
        }
      return !1;
    });
  }
  return Hc = r ? function(D) {
    if (B(D))
      return !0;
    if (!D || typeof D != "function" && typeof D != "object")
      return !1;
    try {
      r(D, null, i);
    } catch (S) {
      if (S !== a)
        return !1;
    }
    return !c(D) && f(D);
  } : function(D) {
    if (B(D))
      return !0;
    if (!D || typeof D != "function" && typeof D != "object")
      return !1;
    if (E)
      return f(D);
    if (c(D))
      return !1;
    var S = p.call(D);
    return S !== g && S !== m && !/^\[object HTML/.test(S) ? !1 : f(D);
  }, Hc;
}
var Kc, by;
function Mx() {
  if (by) return Kc;
  by = 1;
  var e = Px(), r = Object.prototype.toString, i = Object.prototype.hasOwnProperty, a = function(d, g, m) {
    for (var v = 0, w = d.length; v < w; v++)
      i.call(d, v) && (m == null ? g(d[v], v, d) : g.call(m, d[v], v, d));
  }, u = function(d, g, m) {
    for (var v = 0, w = d.length; v < w; v++)
      m == null ? g(d.charAt(v), v, d) : g.call(m, d.charAt(v), v, d);
  }, c = function(d, g, m) {
    for (var v in d)
      i.call(d, v) && (m == null ? g(d[v], v, d) : g.call(m, d[v], v, d));
  };
  function f(p) {
    return r.call(p) === "[object Array]";
  }
  return Kc = function(d, g, m) {
    if (!e(g))
      throw new TypeError("iterator must be a function");
    var v;
    arguments.length >= 3 && (v = m), f(d) ? a(d, g, v) : typeof d == "string" ? u(d, g, v) : c(d, g, v);
  }, Kc;
}
var Jc, Ey;
function Cx() {
  return Ey || (Ey = 1, Jc = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), Jc;
}
var Vc, Ay;
function Dx() {
  if (Ay) return Vc;
  Ay = 1;
  var e = /* @__PURE__ */ Cx(), r = typeof globalThis > "u" ? hi : globalThis;
  return Vc = function() {
    for (var a = [], u = 0; u < e.length; u++)
      typeof r[e[u]] == "function" && (a[a.length] = e[u]);
    return a;
  }, Vc;
}
var Xc = { exports: {} }, Qc, Sy;
function Nx() {
  if (Sy) return Qc;
  Sy = 1;
  var e = /* @__PURE__ */ Ou(), r = /* @__PURE__ */ ym(), i = /* @__PURE__ */ Do(), a = /* @__PURE__ */ Di();
  return Qc = function(c, f, p) {
    if (!c || typeof c != "object" && typeof c != "function")
      throw new i("`obj` must be an object or a function`");
    if (typeof f != "string" && typeof f != "symbol")
      throw new i("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new i("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new i("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new i("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new i("`loose`, if provided, must be a boolean");
    var d = arguments.length > 3 ? arguments[3] : null, g = arguments.length > 4 ? arguments[4] : null, m = arguments.length > 5 ? arguments[5] : null, v = arguments.length > 6 ? arguments[6] : !1, w = !!a && a(c, f);
    if (e)
      e(c, f, {
        configurable: m === null && w ? w.configurable : !m,
        enumerable: d === null && w ? w.enumerable : !d,
        value: p,
        writable: g === null && w ? w.writable : !g
      });
    else if (v || !d && !g && !m)
      c[f] = p;
    else
      throw new r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Qc;
}
var nf, Oy;
function Lx() {
  if (Oy) return nf;
  Oy = 1;
  var e = /* @__PURE__ */ Ou(), r = function() {
    return !!e;
  };
  return r.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, nf = r, nf;
}
var ef, Ty;
function Fx() {
  if (Ty) return ef;
  Ty = 1;
  var e = /* @__PURE__ */ bm(), r = /* @__PURE__ */ Nx(), i = /* @__PURE__ */ Lx()(), a = /* @__PURE__ */ Di(), u = /* @__PURE__ */ Do(), c = e("%Math.floor%");
  return ef = function(p, d) {
    if (typeof p != "function")
      throw new u("`fn` is not a function");
    if (typeof d != "number" || d < 0 || d > 4294967295 || c(d) !== d)
      throw new u("`length` must be a positive 32-bit integer");
    var g = arguments.length > 2 && !!arguments[2], m = !0, v = !0;
    if ("length" in p && a) {
      var w = a(p, "length");
      w && !w.configurable && (m = !1), w && !w.writable && (v = !1);
    }
    return (m || v || !g) && (i ? r(
      /** @type {Parameters<define>[0]} */
      p,
      "length",
      d,
      !0,
      !0
    ) : r(
      /** @type {Parameters<define>[0]} */
      p,
      "length",
      d
    )), p;
  }, ef;
}
var tf, Ry;
function Bx() {
  if (Ry) return tf;
  Ry = 1;
  var e = No(), r = ip(), i = _m();
  return tf = function() {
    return i(e, r, arguments);
  }, tf;
}
var Iy;
function jx() {
  return Iy || (Iy = 1, (function(e) {
    var r = /* @__PURE__ */ Fx(), i = /* @__PURE__ */ Ou(), a = op(), u = Bx();
    e.exports = function(f) {
      var p = a(arguments), d = f.length - (arguments.length - 1);
      return r(
        p,
        1 + (d > 0 ? d : 0),
        !0
      );
    }, i ? i(e.exports, "apply", { value: u }) : e.exports.apply = u;
  })(Xc)), Xc.exports;
}
var rf, xy;
function Em() {
  if (xy) return rf;
  xy = 1;
  var e = Mx(), r = /* @__PURE__ */ Dx(), i = jx(), a = /* @__PURE__ */ Lo(), u = /* @__PURE__ */ Di(), c = ap(), f = a("Object.prototype.toString"), p = Su()(), d = typeof globalThis > "u" ? hi : globalThis, g = r(), m = a("String.prototype.slice"), v = a("Array.prototype.indexOf", !0) || function(B, A) {
    for (var R = 0; R < B.length; R += 1)
      if (B[R] === A)
        return R;
    return -1;
  }, w = { __proto__: null };
  p && u && c ? e(g, function(x) {
    var B = new d[x]();
    if (Symbol.toStringTag in B && c) {
      var A = c(B), R = u(A, Symbol.toStringTag);
      if (!R && A) {
        var D = c(A);
        R = u(D, Symbol.toStringTag);
      }
      w["$" + x] = i(R.get);
    }
  }) : e(g, function(x) {
    var B = new d[x](), A = B.slice || B.set;
    A && (w[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + x
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    i(A));
  });
  var M = function(B) {
    var A = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      w,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(R, D) {
        if (!A)
          try {
            "$" + R(B) === D && (A = /** @type {import('.').TypedArrayName} */
            m(D, 1));
          } catch {
          }
      }
    ), A;
  }, E = function(B) {
    var A = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      w,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(R, D) {
        if (!A)
          try {
            R(B), A = /** @type {import('.').TypedArrayName} */
            m(D, 1);
          } catch {
          }
      }
    ), A;
  };
  return rf = function(B) {
    if (!B || typeof B != "object")
      return !1;
    if (!p) {
      var A = m(f(B), 8, -1);
      return v(g, A) > -1 ? A : A !== "Object" ? !1 : E(B);
    }
    return u ? M(B) : null;
  }, rf;
}
var of, Py;
function qx() {
  if (Py) return of;
  Py = 1;
  var e = /* @__PURE__ */ Em();
  return of = function(i) {
    return !!e(i);
  }, of;
}
var My;
function Ux() {
  return My || (My = 1, (function(e) {
    var r = /* @__PURE__ */ Ox(), i = xx(), a = /* @__PURE__ */ Em(), u = /* @__PURE__ */ qx();
    function c(Y) {
      return Y.call.bind(Y);
    }
    var f = typeof BigInt < "u", p = typeof Symbol < "u", d = c(Object.prototype.toString), g = c(Number.prototype.valueOf), m = c(String.prototype.valueOf), v = c(Boolean.prototype.valueOf);
    if (f)
      var w = c(BigInt.prototype.valueOf);
    if (p)
      var M = c(Symbol.prototype.valueOf);
    function E(Y, Te) {
      if (typeof Y != "object")
        return !1;
      try {
        return Te(Y), !0;
      } catch {
        return !1;
      }
    }
    e.isArgumentsObject = r, e.isGeneratorFunction = i, e.isTypedArray = u;
    function x(Y) {
      return typeof Promise < "u" && Y instanceof Promise || Y !== null && typeof Y == "object" && typeof Y.then == "function" && typeof Y.catch == "function";
    }
    e.isPromise = x;
    function B(Y) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Y) : u(Y) || N(Y);
    }
    e.isArrayBufferView = B;
    function A(Y) {
      return a(Y) === "Uint8Array";
    }
    e.isUint8Array = A;
    function R(Y) {
      return a(Y) === "Uint8ClampedArray";
    }
    e.isUint8ClampedArray = R;
    function D(Y) {
      return a(Y) === "Uint16Array";
    }
    e.isUint16Array = D;
    function S(Y) {
      return a(Y) === "Uint32Array";
    }
    e.isUint32Array = S;
    function P(Y) {
      return a(Y) === "Int8Array";
    }
    e.isInt8Array = P;
    function L(Y) {
      return a(Y) === "Int16Array";
    }
    e.isInt16Array = L;
    function j(Y) {
      return a(Y) === "Int32Array";
    }
    e.isInt32Array = j;
    function z(Y) {
      return a(Y) === "Float32Array";
    }
    e.isFloat32Array = z;
    function Z(Y) {
      return a(Y) === "Float64Array";
    }
    e.isFloat64Array = Z;
    function J(Y) {
      return a(Y) === "BigInt64Array";
    }
    e.isBigInt64Array = J;
    function fn(Y) {
      return a(Y) === "BigUint64Array";
    }
    e.isBigUint64Array = fn;
    function bn(Y) {
      return d(Y) === "[object Map]";
    }
    bn.working = typeof Map < "u" && bn(/* @__PURE__ */ new Map());
    function Ln(Y) {
      return typeof Map > "u" ? !1 : bn.working ? bn(Y) : Y instanceof Map;
    }
    e.isMap = Ln;
    function Fn(Y) {
      return d(Y) === "[object Set]";
    }
    Fn.working = typeof Set < "u" && Fn(/* @__PURE__ */ new Set());
    function Se(Y) {
      return typeof Set > "u" ? !1 : Fn.working ? Fn(Y) : Y instanceof Set;
    }
    e.isSet = Se;
    function Oe(Y) {
      return d(Y) === "[object WeakMap]";
    }
    Oe.working = typeof WeakMap < "u" && Oe(/* @__PURE__ */ new WeakMap());
    function Jn(Y) {
      return typeof WeakMap > "u" ? !1 : Oe.working ? Oe(Y) : Y instanceof WeakMap;
    }
    e.isWeakMap = Jn;
    function Dn(Y) {
      return d(Y) === "[object WeakSet]";
    }
    Dn.working = typeof WeakSet < "u" && Dn(/* @__PURE__ */ new WeakSet());
    function $n(Y) {
      return Dn(Y);
    }
    e.isWeakSet = $n;
    function te(Y) {
      return d(Y) === "[object ArrayBuffer]";
    }
    te.working = typeof ArrayBuffer < "u" && te(new ArrayBuffer());
    function q(Y) {
      return typeof ArrayBuffer > "u" ? !1 : te.working ? te(Y) : Y instanceof ArrayBuffer;
    }
    e.isArrayBuffer = q;
    function T(Y) {
      return d(Y) === "[object DataView]";
    }
    T.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && T(new DataView(new ArrayBuffer(1), 0, 1));
    function N(Y) {
      return typeof DataView > "u" ? !1 : T.working ? T(Y) : Y instanceof DataView;
    }
    e.isDataView = N;
    var W = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function X(Y) {
      return d(Y) === "[object SharedArrayBuffer]";
    }
    function cn(Y) {
      return typeof W > "u" ? !1 : (typeof X.working > "u" && (X.working = X(new W())), X.working ? X(Y) : Y instanceof W);
    }
    e.isSharedArrayBuffer = cn;
    function en(Y) {
      return d(Y) === "[object AsyncFunction]";
    }
    e.isAsyncFunction = en;
    function tn(Y) {
      return d(Y) === "[object Map Iterator]";
    }
    e.isMapIterator = tn;
    function Q(Y) {
      return d(Y) === "[object Set Iterator]";
    }
    e.isSetIterator = Q;
    function nn(Y) {
      return d(Y) === "[object Generator]";
    }
    e.isGeneratorObject = nn;
    function yn(Y) {
      return d(Y) === "[object WebAssembly.Module]";
    }
    e.isWebAssemblyCompiledModule = yn;
    function wn(Y) {
      return E(Y, g);
    }
    e.isNumberObject = wn;
    function Bn(Y) {
      return E(Y, m);
    }
    e.isStringObject = Bn;
    function Sn(Y) {
      return E(Y, v);
    }
    e.isBooleanObject = Sn;
    function Vn(Y) {
      return f && E(Y, w);
    }
    e.isBigIntObject = Vn;
    function zn(Y) {
      return p && E(Y, M);
    }
    e.isSymbolObject = zn;
    function re(Y) {
      return wn(Y) || Bn(Y) || Sn(Y) || Vn(Y) || zn(Y);
    }
    e.isBoxedPrimitive = re;
    function $t(Y) {
      return typeof Uint8Array < "u" && (q(Y) || cn(Y));
    }
    e.isAnyArrayBuffer = $t, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Y) {
      Object.defineProperty(e, Y, {
        enumerable: !1,
        value: function() {
          throw new Error(Y + " is not supported in userland");
        }
      });
    });
  })(ac)), ac;
}
var af, Cy;
function kx() {
  return Cy || (Cy = 1, af = function(r) {
    return r && typeof r == "object" && typeof r.copy == "function" && typeof r.fill == "function" && typeof r.readUInt8 == "function";
  }), af;
}
var Pa = { exports: {} }, Dy;
function Wx() {
  return Dy || (Dy = 1, typeof Object.create == "function" ? Pa.exports = function(r, i) {
    i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : Pa.exports = function(r, i) {
    if (i) {
      r.super_ = i;
      var a = function() {
      };
      a.prototype = i.prototype, r.prototype = new a(), r.prototype.constructor = r;
    }
  }), Pa.exports;
}
var Ny;
function Ly() {
  return Ny || (Ny = 1, (function(e) {
    var r = Object.getOwnPropertyDescriptors || function(N) {
      for (var W = Object.keys(N), X = {}, cn = 0; cn < W.length; cn++)
        X[W[cn]] = Object.getOwnPropertyDescriptor(N, W[cn]);
      return X;
    }, i = /%[sdj%]/g;
    e.format = function(T) {
      if (!P(T)) {
        for (var N = [], W = 0; W < arguments.length; W++)
          N.push(f(arguments[W]));
        return N.join(" ");
      }
      for (var W = 1, X = arguments, cn = X.length, en = String(T).replace(i, function(Q) {
        if (Q === "%%") return "%";
        if (W >= cn) return Q;
        switch (Q) {
          case "%s":
            return String(X[W++]);
          case "%d":
            return Number(X[W++]);
          case "%j":
            try {
              return JSON.stringify(X[W++]);
            } catch {
              return "[Circular]";
            }
          default:
            return Q;
        }
      }), tn = X[W]; W < cn; tn = X[++W])
        R(tn) || !Z(tn) ? en += " " + tn : en += " " + f(tn);
      return en;
    }, e.deprecate = function(T, N) {
      if (typeof process < "u" && process.noDeprecation === !0)
        return T;
      if (typeof process > "u")
        return function() {
          return e.deprecate(T, N).apply(this, arguments);
        };
      var W = !1;
      function X() {
        if (!W) {
          if (process.throwDeprecation)
            throw new Error(N);
          process.traceDeprecation ? console.trace(N) : console.error(N), W = !0;
        }
        return T.apply(this, arguments);
      }
      return X;
    };
    var a = {}, u = /^$/;
    if (process.env.NODE_DEBUG) {
      var c = process.env.NODE_DEBUG;
      c = c.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), u = new RegExp("^" + c + "$", "i");
    }
    e.debuglog = function(T) {
      if (T = T.toUpperCase(), !a[T])
        if (u.test(T)) {
          var N = process.pid;
          a[T] = function() {
            var W = e.format.apply(e, arguments);
            console.error("%s %d: %s", T, N, W);
          };
        } else
          a[T] = function() {
          };
      return a[T];
    };
    function f(T, N) {
      var W = {
        seen: [],
        stylize: d
      };
      return arguments.length >= 3 && (W.depth = arguments[2]), arguments.length >= 4 && (W.colors = arguments[3]), A(N) ? W.showHidden = N : N && e._extend(W, N), j(W.showHidden) && (W.showHidden = !1), j(W.depth) && (W.depth = 2), j(W.colors) && (W.colors = !1), j(W.customInspect) && (W.customInspect = !0), W.colors && (W.stylize = p), m(W, T, W.depth);
    }
    e.inspect = f, f.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, f.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function p(T, N) {
      var W = f.styles[N];
      return W ? "\x1B[" + f.colors[W][0] + "m" + T + "\x1B[" + f.colors[W][1] + "m" : T;
    }
    function d(T, N) {
      return T;
    }
    function g(T) {
      var N = {};
      return T.forEach(function(W, X) {
        N[W] = !0;
      }), N;
    }
    function m(T, N, W) {
      if (T.customInspect && N && bn(N.inspect) && // Filter out the util module, it's inspect function is special
      N.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
      !(N.constructor && N.constructor.prototype === N)) {
        var X = N.inspect(W, T);
        return P(X) || (X = m(T, X, W)), X;
      }
      var cn = v(T, N);
      if (cn)
        return cn;
      var en = Object.keys(N), tn = g(en);
      if (T.showHidden && (en = Object.getOwnPropertyNames(N)), fn(N) && (en.indexOf("message") >= 0 || en.indexOf("description") >= 0))
        return w(N);
      if (en.length === 0) {
        if (bn(N)) {
          var Q = N.name ? ": " + N.name : "";
          return T.stylize("[Function" + Q + "]", "special");
        }
        if (z(N))
          return T.stylize(RegExp.prototype.toString.call(N), "regexp");
        if (J(N))
          return T.stylize(Date.prototype.toString.call(N), "date");
        if (fn(N))
          return w(N);
      }
      var nn = "", yn = !1, wn = ["{", "}"];
      if (B(N) && (yn = !0, wn = ["[", "]"]), bn(N)) {
        var Bn = N.name ? ": " + N.name : "";
        nn = " [Function" + Bn + "]";
      }
      if (z(N) && (nn = " " + RegExp.prototype.toString.call(N)), J(N) && (nn = " " + Date.prototype.toUTCString.call(N)), fn(N) && (nn = " " + w(N)), en.length === 0 && (!yn || N.length == 0))
        return wn[0] + nn + wn[1];
      if (W < 0)
        return z(N) ? T.stylize(RegExp.prototype.toString.call(N), "regexp") : T.stylize("[Object]", "special");
      T.seen.push(N);
      var Sn;
      return yn ? Sn = M(T, N, W, tn, en) : Sn = en.map(function(Vn) {
        return E(T, N, W, tn, Vn, yn);
      }), T.seen.pop(), x(Sn, nn, wn);
    }
    function v(T, N) {
      if (j(N))
        return T.stylize("undefined", "undefined");
      if (P(N)) {
        var W = "'" + JSON.stringify(N).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return T.stylize(W, "string");
      }
      if (S(N))
        return T.stylize("" + N, "number");
      if (A(N))
        return T.stylize("" + N, "boolean");
      if (R(N))
        return T.stylize("null", "null");
    }
    function w(T) {
      return "[" + Error.prototype.toString.call(T) + "]";
    }
    function M(T, N, W, X, cn) {
      for (var en = [], tn = 0, Q = N.length; tn < Q; ++tn)
        Dn(N, String(tn)) ? en.push(E(
          T,
          N,
          W,
          X,
          String(tn),
          !0
        )) : en.push("");
      return cn.forEach(function(nn) {
        nn.match(/^\d+$/) || en.push(E(
          T,
          N,
          W,
          X,
          nn,
          !0
        ));
      }), en;
    }
    function E(T, N, W, X, cn, en) {
      var tn, Q, nn;
      if (nn = Object.getOwnPropertyDescriptor(N, cn) || { value: N[cn] }, nn.get ? nn.set ? Q = T.stylize("[Getter/Setter]", "special") : Q = T.stylize("[Getter]", "special") : nn.set && (Q = T.stylize("[Setter]", "special")), Dn(X, cn) || (tn = "[" + cn + "]"), Q || (T.seen.indexOf(nn.value) < 0 ? (R(W) ? Q = m(T, nn.value, null) : Q = m(T, nn.value, W - 1), Q.indexOf(`
`) > -1 && (en ? Q = Q.split(`
`).map(function(yn) {
        return "  " + yn;
      }).join(`
`).slice(2) : Q = `
` + Q.split(`
`).map(function(yn) {
        return "   " + yn;
      }).join(`
`))) : Q = T.stylize("[Circular]", "special")), j(tn)) {
        if (en && cn.match(/^\d+$/))
          return Q;
        tn = JSON.stringify("" + cn), tn.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (tn = tn.slice(1, -1), tn = T.stylize(tn, "name")) : (tn = tn.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), tn = T.stylize(tn, "string"));
      }
      return tn + ": " + Q;
    }
    function x(T, N, W) {
      var X = T.reduce(function(cn, en) {
        return en.indexOf(`
`) >= 0, cn + en.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return X > 60 ? W[0] + (N === "" ? "" : N + `
 `) + " " + T.join(`,
  `) + " " + W[1] : W[0] + N + " " + T.join(", ") + " " + W[1];
    }
    e.types = Ux();
    function B(T) {
      return Array.isArray(T);
    }
    e.isArray = B;
    function A(T) {
      return typeof T == "boolean";
    }
    e.isBoolean = A;
    function R(T) {
      return T === null;
    }
    e.isNull = R;
    function D(T) {
      return T == null;
    }
    e.isNullOrUndefined = D;
    function S(T) {
      return typeof T == "number";
    }
    e.isNumber = S;
    function P(T) {
      return typeof T == "string";
    }
    e.isString = P;
    function L(T) {
      return typeof T == "symbol";
    }
    e.isSymbol = L;
    function j(T) {
      return T === void 0;
    }
    e.isUndefined = j;
    function z(T) {
      return Z(T) && Fn(T) === "[object RegExp]";
    }
    e.isRegExp = z, e.types.isRegExp = z;
    function Z(T) {
      return typeof T == "object" && T !== null;
    }
    e.isObject = Z;
    function J(T) {
      return Z(T) && Fn(T) === "[object Date]";
    }
    e.isDate = J, e.types.isDate = J;
    function fn(T) {
      return Z(T) && (Fn(T) === "[object Error]" || T instanceof Error);
    }
    e.isError = fn, e.types.isNativeError = fn;
    function bn(T) {
      return typeof T == "function";
    }
    e.isFunction = bn;
    function Ln(T) {
      return T === null || typeof T == "boolean" || typeof T == "number" || typeof T == "string" || typeof T == "symbol" || // ES6 symbol
      typeof T > "u";
    }
    e.isPrimitive = Ln, e.isBuffer = kx();
    function Fn(T) {
      return Object.prototype.toString.call(T);
    }
    function Se(T) {
      return T < 10 ? "0" + T.toString(10) : T.toString(10);
    }
    var Oe = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function Jn() {
      var T = /* @__PURE__ */ new Date(), N = [
        Se(T.getHours()),
        Se(T.getMinutes()),
        Se(T.getSeconds())
      ].join(":");
      return [T.getDate(), Oe[T.getMonth()], N].join(" ");
    }
    e.log = function() {
      console.log("%s - %s", Jn(), e.format.apply(e, arguments));
    }, e.inherits = Wx(), e._extend = function(T, N) {
      if (!N || !Z(N)) return T;
      for (var W = Object.keys(N), X = W.length; X--; )
        T[W[X]] = N[W[X]];
      return T;
    };
    function Dn(T, N) {
      return Object.prototype.hasOwnProperty.call(T, N);
    }
    var $n = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    e.promisify = function(N) {
      if (typeof N != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if ($n && N[$n]) {
        var W = N[$n];
        if (typeof W != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(W, $n, {
          value: W,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), W;
      }
      function W() {
        for (var X, cn, en = new Promise(function(nn, yn) {
          X = nn, cn = yn;
        }), tn = [], Q = 0; Q < arguments.length; Q++)
          tn.push(arguments[Q]);
        tn.push(function(nn, yn) {
          nn ? cn(nn) : X(yn);
        });
        try {
          N.apply(this, tn);
        } catch (nn) {
          cn(nn);
        }
        return en;
      }
      return Object.setPrototypeOf(W, Object.getPrototypeOf(N)), $n && Object.defineProperty(W, $n, {
        value: W,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        W,
        r(N)
      );
    }, e.promisify.custom = $n;
    function te(T, N) {
      if (!T) {
        var W = new Error("Promise was rejected with a falsy value");
        W.reason = T, T = W;
      }
      return N(T);
    }
    function q(T) {
      if (typeof T != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function N() {
        for (var W = [], X = 0; X < arguments.length; X++)
          W.push(arguments[X]);
        var cn = W.pop();
        if (typeof cn != "function")
          throw new TypeError("The last argument must be of type Function");
        var en = this, tn = function() {
          return cn.apply(en, arguments);
        };
        T.apply(this, W).then(
          function(Q) {
            process.nextTick(tn.bind(null, null, Q));
          },
          function(Q) {
            process.nextTick(te.bind(null, Q, tn));
          }
        );
      }
      return Object.setPrototypeOf(N, Object.getPrototypeOf(T)), Object.defineProperties(
        N,
        r(T)
      ), N;
    }
    e.callbackify = q;
  })(oc)), oc;
}
var uf = {}, Fy;
function Yx() {
  return Fy || (Fy = 1, (function(e) {
    (function() {
      var r = {
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
      };
      function i(p) {
        return u(f(p), arguments);
      }
      function a(p, d) {
        return i.apply(null, [p].concat(d || []));
      }
      function u(p, d) {
        var g = 1, m = p.length, v, w = "", M, E, x, B, A, R, D, S;
        for (M = 0; M < m; M++)
          if (typeof p[M] == "string")
            w += p[M];
          else if (typeof p[M] == "object") {
            if (x = p[M], x.keys)
              for (v = d[g], E = 0; E < x.keys.length; E++) {
                if (v == null)
                  throw new Error(i('[sprintf] Cannot access property "%s" of undefined value "%s"', x.keys[E], x.keys[E - 1]));
                v = v[x.keys[E]];
              }
            else x.param_no ? v = d[x.param_no] : v = d[g++];
            if (r.not_type.test(x.type) && r.not_primitive.test(x.type) && v instanceof Function && (v = v()), r.numeric_arg.test(x.type) && typeof v != "number" && isNaN(v))
              throw new TypeError(i("[sprintf] expecting number but found %T", v));
            switch (r.number.test(x.type) && (D = v >= 0), x.type) {
              case "b":
                v = parseInt(v, 10).toString(2);
                break;
              case "c":
                v = String.fromCharCode(parseInt(v, 10));
                break;
              case "d":
              case "i":
                v = parseInt(v, 10);
                break;
              case "j":
                v = JSON.stringify(v, null, x.width ? parseInt(x.width) : 0);
                break;
              case "e":
                v = x.precision ? parseFloat(v).toExponential(x.precision) : parseFloat(v).toExponential();
                break;
              case "f":
                v = x.precision ? parseFloat(v).toFixed(x.precision) : parseFloat(v);
                break;
              case "g":
                v = x.precision ? String(Number(v.toPrecision(x.precision))) : parseFloat(v);
                break;
              case "o":
                v = (parseInt(v, 10) >>> 0).toString(8);
                break;
              case "s":
                v = String(v), v = x.precision ? v.substring(0, x.precision) : v;
                break;
              case "t":
                v = String(!!v), v = x.precision ? v.substring(0, x.precision) : v;
                break;
              case "T":
                v = Object.prototype.toString.call(v).slice(8, -1).toLowerCase(), v = x.precision ? v.substring(0, x.precision) : v;
                break;
              case "u":
                v = parseInt(v, 10) >>> 0;
                break;
              case "v":
                v = v.valueOf(), v = x.precision ? v.substring(0, x.precision) : v;
                break;
              case "x":
                v = (parseInt(v, 10) >>> 0).toString(16);
                break;
              case "X":
                v = (parseInt(v, 10) >>> 0).toString(16).toUpperCase();
                break;
            }
            r.json.test(x.type) ? w += v : (r.number.test(x.type) && (!D || x.sign) ? (S = D ? "+" : "-", v = v.toString().replace(r.sign, "")) : S = "", A = x.pad_char ? x.pad_char === "0" ? "0" : x.pad_char.charAt(1) : " ", R = x.width - (S + v).length, B = x.width && R > 0 ? A.repeat(R) : "", w += x.align ? S + v + B : A === "0" ? S + B + v : B + S + v);
          }
        return w;
      }
      var c = /* @__PURE__ */ Object.create(null);
      function f(p) {
        if (c[p])
          return c[p];
        for (var d = p, g, m = [], v = 0; d; ) {
          if ((g = r.text.exec(d)) !== null)
            m.push(g[0]);
          else if ((g = r.modulo.exec(d)) !== null)
            m.push("%");
          else if ((g = r.placeholder.exec(d)) !== null) {
            if (g[2]) {
              v |= 1;
              var w = [], M = g[2], E = [];
              if ((E = r.key.exec(M)) !== null)
                for (w.push(E[1]); (M = M.substring(E[0].length)) !== ""; )
                  if ((E = r.key_access.exec(M)) !== null)
                    w.push(E[1]);
                  else if ((E = r.index_access.exec(M)) !== null)
                    w.push(E[1]);
                  else
                    throw new SyntaxError("[sprintf] failed to parse named argument key");
              else
                throw new SyntaxError("[sprintf] failed to parse named argument key");
              g[2] = w;
            } else
              v |= 2;
            if (v === 3)
              throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
            m.push(
              {
                placeholder: g[0],
                param_no: g[1],
                keys: g[2],
                sign: g[3],
                pad_char: g[4],
                align: g[5],
                width: g[6],
                precision: g[7],
                type: g[8]
              }
            );
          } else
            throw new SyntaxError("[sprintf] unexpected placeholder");
          d = d.substring(g[0].length);
        }
        return c[p] = m;
      }
      e.sprintf = i, e.vsprintf = a, typeof window < "u" && (window.sprintf = i, window.vsprintf = a);
    })();
  })(uf)), uf;
}
var Ma = { exports: {} }, By;
function $x() {
  if (By) return Ma.exports;
  By = 1;
  var e = typeof Reflect == "object" ? Reflect : null, r = e && typeof e.apply == "function" ? e.apply : function(P, L, j) {
    return Function.prototype.apply.call(P, L, j);
  }, i;
  e && typeof e.ownKeys == "function" ? i = e.ownKeys : Object.getOwnPropertySymbols ? i = function(P) {
    return Object.getOwnPropertyNames(P).concat(Object.getOwnPropertySymbols(P));
  } : i = function(P) {
    return Object.getOwnPropertyNames(P);
  };
  function a(S) {
    console && console.warn && console.warn(S);
  }
  var u = Number.isNaN || function(P) {
    return P !== P;
  };
  function c() {
    c.init.call(this);
  }
  Ma.exports = c, Ma.exports.once = A, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
  var f = 10;
  function p(S) {
    if (typeof S != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof S);
  }
  Object.defineProperty(c, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return f;
    },
    set: function(S) {
      if (typeof S != "number" || S < 0 || u(S))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + S + ".");
      f = S;
    }
  }), c.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, c.prototype.setMaxListeners = function(P) {
    if (typeof P != "number" || P < 0 || u(P))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + P + ".");
    return this._maxListeners = P, this;
  };
  function d(S) {
    return S._maxListeners === void 0 ? c.defaultMaxListeners : S._maxListeners;
  }
  c.prototype.getMaxListeners = function() {
    return d(this);
  }, c.prototype.emit = function(P) {
    for (var L = [], j = 1; j < arguments.length; j++) L.push(arguments[j]);
    var z = P === "error", Z = this._events;
    if (Z !== void 0)
      z = z && Z.error === void 0;
    else if (!z)
      return !1;
    if (z) {
      var J;
      if (L.length > 0 && (J = L[0]), J instanceof Error)
        throw J;
      var fn = new Error("Unhandled error." + (J ? " (" + J.message + ")" : ""));
      throw fn.context = J, fn;
    }
    var bn = Z[P];
    if (bn === void 0)
      return !1;
    if (typeof bn == "function")
      r(bn, this, L);
    else
      for (var Ln = bn.length, Fn = E(bn, Ln), j = 0; j < Ln; ++j)
        r(Fn[j], this, L);
    return !0;
  };
  function g(S, P, L, j) {
    var z, Z, J;
    if (p(L), Z = S._events, Z === void 0 ? (Z = S._events = /* @__PURE__ */ Object.create(null), S._eventsCount = 0) : (Z.newListener !== void 0 && (S.emit(
      "newListener",
      P,
      L.listener ? L.listener : L
    ), Z = S._events), J = Z[P]), J === void 0)
      J = Z[P] = L, ++S._eventsCount;
    else if (typeof J == "function" ? J = Z[P] = j ? [L, J] : [J, L] : j ? J.unshift(L) : J.push(L), z = d(S), z > 0 && J.length > z && !J.warned) {
      J.warned = !0;
      var fn = new Error("Possible EventEmitter memory leak detected. " + J.length + " " + String(P) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      fn.name = "MaxListenersExceededWarning", fn.emitter = S, fn.type = P, fn.count = J.length, a(fn);
    }
    return S;
  }
  c.prototype.addListener = function(P, L) {
    return g(this, P, L, !1);
  }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(P, L) {
    return g(this, P, L, !0);
  };
  function m() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function v(S, P, L) {
    var j = { fired: !1, wrapFn: void 0, target: S, type: P, listener: L }, z = m.bind(j);
    return z.listener = L, j.wrapFn = z, z;
  }
  c.prototype.once = function(P, L) {
    return p(L), this.on(P, v(this, P, L)), this;
  }, c.prototype.prependOnceListener = function(P, L) {
    return p(L), this.prependListener(P, v(this, P, L)), this;
  }, c.prototype.removeListener = function(P, L) {
    var j, z, Z, J, fn;
    if (p(L), z = this._events, z === void 0)
      return this;
    if (j = z[P], j === void 0)
      return this;
    if (j === L || j.listener === L)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete z[P], z.removeListener && this.emit("removeListener", P, j.listener || L));
    else if (typeof j != "function") {
      for (Z = -1, J = j.length - 1; J >= 0; J--)
        if (j[J] === L || j[J].listener === L) {
          fn = j[J].listener, Z = J;
          break;
        }
      if (Z < 0)
        return this;
      Z === 0 ? j.shift() : x(j, Z), j.length === 1 && (z[P] = j[0]), z.removeListener !== void 0 && this.emit("removeListener", P, fn || L);
    }
    return this;
  }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(P) {
    var L, j, z;
    if (j = this._events, j === void 0)
      return this;
    if (j.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : j[P] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete j[P]), this;
    if (arguments.length === 0) {
      var Z = Object.keys(j), J;
      for (z = 0; z < Z.length; ++z)
        J = Z[z], J !== "removeListener" && this.removeAllListeners(J);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (L = j[P], typeof L == "function")
      this.removeListener(P, L);
    else if (L !== void 0)
      for (z = L.length - 1; z >= 0; z--)
        this.removeListener(P, L[z]);
    return this;
  };
  function w(S, P, L) {
    var j = S._events;
    if (j === void 0)
      return [];
    var z = j[P];
    return z === void 0 ? [] : typeof z == "function" ? L ? [z.listener || z] : [z] : L ? B(z) : E(z, z.length);
  }
  c.prototype.listeners = function(P) {
    return w(this, P, !0);
  }, c.prototype.rawListeners = function(P) {
    return w(this, P, !1);
  }, c.listenerCount = function(S, P) {
    return typeof S.listenerCount == "function" ? S.listenerCount(P) : M.call(S, P);
  }, c.prototype.listenerCount = M;
  function M(S) {
    var P = this._events;
    if (P !== void 0) {
      var L = P[S];
      if (typeof L == "function")
        return 1;
      if (L !== void 0)
        return L.length;
    }
    return 0;
  }
  c.prototype.eventNames = function() {
    return this._eventsCount > 0 ? i(this._events) : [];
  };
  function E(S, P) {
    for (var L = new Array(P), j = 0; j < P; ++j)
      L[j] = S[j];
    return L;
  }
  function x(S, P) {
    for (; P + 1 < S.length; P++)
      S[P] = S[P + 1];
    S.pop();
  }
  function B(S) {
    for (var P = new Array(S.length), L = 0; L < P.length; ++L)
      P[L] = S[L].listener || S[L];
    return P;
  }
  function A(S, P) {
    return new Promise(function(L, j) {
      function z(J) {
        S.removeListener(P, Z), j(J);
      }
      function Z() {
        typeof S.removeListener == "function" && S.removeListener("error", z), L([].slice.call(arguments));
      }
      D(S, P, Z, { once: !0 }), P !== "error" && R(S, z, { once: !0 });
    });
  }
  function R(S, P, L) {
    typeof S.on == "function" && D(S, "error", P, L);
  }
  function D(S, P, L, j) {
    if (typeof S.on == "function")
      j.once ? S.once(P, L) : S.on(P, L);
    else if (typeof S.addEventListener == "function")
      S.addEventListener(P, function z(Z) {
        j.once && S.removeEventListener(P, z), L(Z);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof S);
  }
  return Ma.exports;
}
var sf, jy;
function zx() {
  if (jy) return sf;
  jy = 1;
  var e = [].indexOf;
  return sf = function(r, i) {
    if (e) return r.indexOf(i);
    for (var a = 0; a < r.length; ++a)
      if (r[a] === i) return a;
    return -1;
  }, sf;
}
var cf, qy;
function Gx() {
  if (qy) return cf;
  qy = 1;
  var e = Array.prototype, r = e.concat, i = e.slice, a = zx();
  function u(c) {
    var f = {}, p = r.apply(e, i.call(arguments, 1));
    for (var d in c)
      a(p, d) === -1 && (f[d] = c[d]);
    return f;
  }
  return cf = u, cf;
}
var ff, Uy;
function Am() {
  return Uy || (Uy = 1, ff = {
    __locale: "en",
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    abbreviated_days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    abbreviated_months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    am: "AM",
    pm: "PM"
  }), ff;
}
var lf, ky;
function Zx() {
  return ky || (ky = 1, lf = Am()), lf;
}
var pf, Wy;
function Hx() {
  if (Wy) return pf;
  Wy = 1;
  var e = Zx();
  function r(f, p, d) {
    var g = f.getTime();
    return d = d || e, p.replace(/%([-_0]?.)/g, function(m, v) {
      var w = null;
      if (v.length == 2) {
        switch (v[0]) {
          case "-":
            w = "";
            break;
          case "_":
            w = " ";
            break;
          case "0":
            w = "0";
            break;
          default:
            return m;
        }
        v = v[1];
      }
      switch (v) {
        case "A":
          return d.days[f.getDay()];
        case "a":
          return d.abbreviated_days[f.getDay()];
        case "B":
          return d.months[f.getMonth()];
        case "b":
          return d.abbreviated_months[f.getMonth()];
        case "C":
          return i(Math.floor(f.getFullYear() / 100), w);
        case "D":
          return r(f, "%m/%d/%y");
        case "d":
          return i(f.getDate(), w);
        case "e":
          return f.getDate();
        case "F":
          return r(f, "%Y-%m-%d");
        case "H":
          return i(f.getHours(), w);
        case "h":
          return d.abbreviated_months[f.getMonth()];
        case "I":
          return i(a(f), w);
        case "j":
          return i(Math.ceil((f.getTime() - new Date(f.getFullYear(), 0, 1).getTime()) / (1e3 * 60 * 60 * 24)), 3);
        case "k":
          return i(f.getHours(), w === null ? " " : w);
        case "L":
          return i(Math.floor(g % 1e3), 3);
        case "l":
          return i(a(f), w === null ? " " : w);
        case "M":
          return i(f.getMinutes(), w);
        case "m":
          return i(f.getMonth() + 1, w);
        case "n":
          return `
`;
        case "o":
          return String(f.getDate()) + u(f.getDate());
        case "P":
          return f.getHours() < 12 ? d.am.toLowerCase() : d.pm.toLowerCase();
        case "p":
          return f.getHours() < 12 ? d.am.toUpperCase() : d.pm.toUpperCase();
        case "R":
          return r(f, "%H:%M");
        case "r":
          return r(f, "%I:%M:%S %p");
        case "S":
          return i(f.getSeconds(), w);
        case "s":
          return Math.floor(g / 1e3);
        case "T":
          return r(f, "%H:%M:%S");
        case "t":
          return "	";
        case "U":
          return i(c(f, "sunday"), w);
        case "u":
          return f.getDay() === 0 ? 7 : f.getDay();
        case "v":
          return r(f, "%e-%b-%Y");
        case "W":
          return i(c(f, "monday"), w);
        case "w":
          return f.getDay();
        case "Y":
          return f.getFullYear();
        case "y":
          var M = String(f.getFullYear());
          return M.slice(M.length - 2);
        case "Z":
          var E = f.toString().match(/\((\w+)\)/);
          return E && E[1] || "";
        case "z":
          var x = f.getTimezoneOffset();
          return (x > 0 ? "-" : "+") + i(Math.round(Math.abs(x / 60)), 2) + ":" + i(x % 60, 2);
        default:
          return v;
      }
    });
  }
  function i(f, p, d) {
    typeof p == "number" && (d = p, p = "0"), p === null && (p = "0"), d = d || 2;
    var g = String(f);
    if (p)
      for (; g.length < d; )
        g = p + g;
    return g;
  }
  function a(f) {
    var p = f.getHours();
    return p === 0 ? p = 12 : p > 12 && (p -= 12), p;
  }
  function u(f) {
    var p = f % 10, d = f % 100;
    if (d >= 11 && d <= 13 || p === 0 || p >= 4)
      return "th";
    switch (p) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
    }
  }
  function c(f, p) {
    p = p || "sunday";
    var d = f.getDay();
    p == "monday" && (d === 0 ? d = 6 : d--);
    var g = new Date(f.getFullYear(), 0, 1), m = (f - g) / 864e5, v = (m + 7 - d) / 7;
    return Math.floor(v);
  }
  return pf = r, pf;
}
var hf, Yy;
function Kx() {
  return Yy || (Yy = 1, hf = function(e, r) {
    var i;
    return r === 0 && "zero" in e && (i = "zero"), i = i || (r === 1 ? "one" : "other"), e[i];
  }), hf;
}
var df, $y;
function Jx() {
  return $y || ($y = 1, df = {
    counterpart: {
      names: Am(),
      pluralize: Kx(),
      formats: {
        date: {
          default: "%a, %e %b %Y",
          long: "%A, %B %o, %Y",
          short: "%b %e"
        },
        time: {
          default: "%H:%M",
          long: "%H:%M:%S %z",
          short: "%H:%M"
        },
        datetime: {
          default: "%a, %e %b %Y %H:%M",
          long: "%A, %B %o, %Y %H:%M:%S %z",
          short: "%e %b %H:%M"
        }
      }
    }
  }), df;
}
var gf, zy;
function Vx() {
  if (zy) return gf;
  zy = 1;
  var e = ax(), r = Ly().isArray, i = Ly().isDate, a = Yx().sprintf, u = $x(), c = Gx(), f = Hx(), p = "counterpart";
  function d(A) {
    return typeof A == "string" || Object.prototype.toString.call(A) === "[object String]";
  }
  function g(A) {
    return typeof A == "function" || Object.prototype.toString.call(A) === "[object Function]";
  }
  function m(A) {
    return A === null ? !1 : Object.prototype.toString.call(A) === "[object Object]";
  }
  function v(A) {
    return d(A) && A[0] === ":";
  }
  function w(A, R) {
    return Object.prototype.hasOwnProperty.call(A, R);
  }
  function M(A, R) {
    return R.reduce(function(D, S) {
      return m(D) && w(D, S) ? D[S] : null;
    }, A);
  }
  function E() {
    u.EventEmitter.apply(this), this._registry = {
      locale: "en",
      interpolate: !0,
      fallbackLocales: [],
      scope: null,
      translations: {},
      interpolations: {},
      normalizedKeys: {},
      separator: ".",
      keepTrailingDot: !1,
      keyTransformer: function(A) {
        return A;
      },
      generateMissingEntry: function(A) {
        return "missing translation: " + A;
      }
    }, this.registerTranslations("en", Jx()), this.setMaxListeners(0);
  }
  E.prototype = u.EventEmitter.prototype, E.prototype.constructor = u.EventEmitter, E.prototype.getLocale = function() {
    return this._registry.locale;
  }, E.prototype.setLocale = function(A) {
    var R = this._registry.locale;
    return R != A && (this._registry.locale = A, this.emit("localechange", A, R)), R;
  }, E.prototype.getFallbackLocale = function() {
    return this._registry.fallbackLocales;
  }, E.prototype.setFallbackLocale = function(A) {
    var R = this._registry.fallbackLocales;
    return this._registry.fallbackLocales = [].concat(A || []), R;
  }, E.prototype.getAvailableLocales = function() {
    return this._registry.availableLocales || Object.keys(this._registry.translations);
  }, E.prototype.setAvailableLocales = function(A) {
    var R = this.getAvailableLocales();
    return this._registry.availableLocales = A, R;
  }, E.prototype.getSeparator = function() {
    return this._registry.separator;
  }, E.prototype.setSeparator = function(A) {
    var R = this._registry.separator;
    return this._registry.separator = A, R;
  }, E.prototype.setInterpolate = function(A) {
    var R = this._registry.interpolate;
    return this._registry.interpolate = A, R;
  }, E.prototype.getInterpolate = function() {
    return this._registry.interpolate;
  }, E.prototype.setKeyTransformer = function(A) {
    var R = this._registry.keyTransformer;
    return this._registry.keyTransformer = A, R;
  }, E.prototype.getKeyTransformer = function() {
    return this._registry.keyTransformer;
  }, E.prototype.setMissingEntryGenerator = function(A) {
    var R = this._registry.generateMissingEntry;
    return this._registry.generateMissingEntry = A, R;
  }, E.prototype.getMissingEntryGenerator = function() {
    return this._registry.generateMissingEntry;
  }, E.prototype.registerTranslations = function(A, R) {
    var D = {};
    return D[A] = R, e(!0, this._registry.translations, D), D;
  }, E.prototype.registerInterpolations = function(A) {
    return e(!0, this._registry.interpolations, A);
  }, E.prototype.onLocaleChange = E.prototype.addLocaleChangeListener = function(A) {
    this.addListener("localechange", A);
  }, E.prototype.offLocaleChange = E.prototype.removeLocaleChangeListener = function(A) {
    this.removeListener("localechange", A);
  }, E.prototype.onTranslationNotFound = E.prototype.addTranslationNotFoundListener = function(A) {
    this.addListener("translationnotfound", A);
  }, E.prototype.offTranslationNotFound = E.prototype.removeTranslationNotFoundListener = function(A) {
    this.removeListener("translationnotfound", A);
  }, E.prototype.onError = E.prototype.addErrorListener = function(A) {
    this.addListener("error", A);
  }, E.prototype.offError = E.prototype.removeErrorListener = function(A) {
    this.removeListener("error", A);
  }, E.prototype.translate = function(A, R) {
    if (!r(A) && !d(A) || !A.length)
      throw new Error("invalid argument: key");
    v(A) && (A = A.substr(1)), A = this._registry.keyTransformer(A, R), R = e(!0, {}, R);
    var D = R.locale || this._registry.locale;
    delete R.locale;
    var S = R.scope || this._registry.scope;
    delete R.scope;
    var P = R.separator || this._registry.separator;
    delete R.separator;
    var L = [].concat(R.fallbackLocale || this._registry.fallbackLocales);
    delete R.fallbackLocale;
    var j = this._normalizeKeys(D, S, A, P), z = M(this._registry.translations, j);
    if (z === null && (this.emit("translationnotfound", D, A, R.fallback, S), R.fallback && (z = this._fallback(D, S, A, R.fallback, R))), z === null && L.length > 0 && L.indexOf(D) === -1)
      for (var Z = 0, J = L.length; Z < J; Z++) {
        var fn = L[Z], bn = this._normalizeKeys(fn, S, A, P);
        if (z = M(this._registry.translations, bn), z) {
          D = fn;
          break;
        }
      }
    return z === null && (z = this._registry.generateMissingEntry(j.join(P))), z = this._pluralize(D, z, R.count), this._registry.interpolate !== !1 && R.interpolate !== !1 && (z = this._interpolate(z, R)), z;
  }, E.prototype.localize = function(A, R) {
    if (!i(A))
      throw new Error("invalid argument: object must be a date");
    R = e(!0, {}, R);
    var D = R.locale || this._registry.locale, S = R.scope || p, P = R.type || "datetime", L = R.format || "default";
    return R = { locale: D, scope: S, interpolate: !1 }, L = this.translate(["formats", P, L], e(!0, {}, R)), f(A, L, this.translate("names", R));
  }, E.prototype._pluralize = function(A, R, D) {
    if (typeof R != "object" || R === null || typeof D != "number")
      return R;
    var S = this.translate("pluralize", { locale: A, scope: p });
    return Object.prototype.toString.call(S) !== "[object Function]" ? S : S(R, D);
  }, E.prototype.withLocale = function(A, R, D) {
    var S = this._registry.locale;
    this._registry.locale = A;
    var P = R.call(D);
    return this._registry.locale = S, P;
  }, E.prototype.withScope = function(A, R, D) {
    var S = this._registry.scope;
    this._registry.scope = A;
    var P = R.call(D);
    return this._registry.scope = S, P;
  }, E.prototype.withSeparator = function(A, R, D) {
    var S = this.setSeparator(A), P = R.call(D);
    return this.setSeparator(S), P;
  }, E.prototype._normalizeKeys = function(A, R, D, S) {
    var P = [];
    return P = P.concat(this._normalizeKey(A, S)), P = P.concat(this._normalizeKey(R, S)), P = P.concat(this._normalizeKey(D, S)), P;
  }, E.prototype._normalizeKey = function(A, R) {
    return this._registry.normalizedKeys[R] = this._registry.normalizedKeys[R] || {}, this._registry.normalizedKeys[R][A] = this._registry.normalizedKeys[R][A] || (function(D) {
      if (r(D)) {
        var S = D.map((function(j) {
          return this._normalizeKey(j, R);
        }).bind(this));
        return [].concat.apply([], S);
      } else {
        if (typeof D > "u" || D === null)
          return [];
        for (var P = D.split(R), L = P.length - 1; L >= 0; L--)
          P[L] === "" && (P.splice(L, 1), this._registry.keepTrailingDot === !0 && L == P.length && (P[P.length - 1] += "" + R));
        return P;
      }
    }).bind(this)(A), this._registry.normalizedKeys[R][A];
  }, E.prototype._interpolate = function(A, R) {
    if (typeof A != "string")
      return A;
    try {
      return a(A, e({}, this._registry.interpolations, R));
    } catch (D) {
      if (this.listenerCount("error") > 0)
        this.emit("error", D, A, R);
      else
        throw D;
      return null;
    }
  }, E.prototype._resolve = function(A, R, D, S, P) {
    if (P = P || {}, P.resolve === !1)
      return S;
    var L;
    if (v(S))
      L = this.translate(S, e({}, P, { locale: A, scope: R }));
    else if (g(S)) {
      var j;
      P.object ? (j = P.object, delete P.object) : j = D, L = this._resolve(A, R, D, S(j, P));
    } else
      L = S;
    return /^missing translation:/.test(L) ? null : L;
  }, E.prototype._fallback = function(A, R, D, S, P) {
    if (P = c(P, "fallback"), r(S)) {
      for (var L = 0, j = S.length; L < j; L++) {
        var z = this._resolve(A, R, D, S[L], P);
        if (z)
          return z;
      }
      return null;
    } else
      return this._resolve(A, R, D, S, P);
  };
  var x = new E();
  function B() {
    return x.translate.apply(x, arguments);
  }
  return e(B, x, {
    Instance: E,
    Translator: E
  }), gf = B, gf;
}
var Xx = Vx();
const it = /* @__PURE__ */ av(Xx), Qx = "cs.4c75826.json", nP = "cy.035dc87.json", eP = "de_DE.c89acd8.json", tP = "el.9da3e33.json", rP = "en_EN.a58a2bd.json", iP = "eo.03dd57f.json", oP = "es.2efe1b1.json", aP = "et.4c7195f.json", uP = "fa.8c12691.json", sP = "fi.22b54d2.json", cP = "fr.5a4583a.json", fP = "gl.7065ccc.json", lP = "he.b83d000.json", pP = "hu.cc250cb.json", hP = "hy.de33a67.json", dP = "id.06ce851.json", gP = "is.863e288.json", yP = "it.74bccd9.json", vP = "ja.2aeddc4.json", mP = "ka.e064701.json", _P = "lo.48b8551.json", wP = "lt.4e7eaae.json", bP = "lv.9d75a93.json", EP = "mg_MG.a1da06d.json", AP = "nl.a5c8438.json", SP = "pl.58f9f8c.json", OP = "pt.c39ae76.json", TP = "ru.b4cbb4e.json", RP = "sk.658b388.json", IP = "sq.0a454c4.json", xP = "sv.89ad476.json", PP = "tr.0085c6b.json", MP = "uk.1949a1a.json", CP = "vi.f7d2307.json", Gy = {
  cs: Qx,
  cy: nP,
  de: eP,
  el: tP,
  en: rP,
  eo: iP,
  es: oP,
  et: aP,
  fa: uP,
  fi: sP,
  fr: cP,
  gl: fP,
  he: lP,
  hu: pP,
  hy: hP,
  id: dP,
  is: gP,
  it: yP,
  ja: vP,
  ka: mP,
  lo: _P,
  lt: wP,
  lv: bP,
  mg: EP,
  "nb-no": "nb_NO.cc8fcc5.json",
  nl: AP,
  pl: SP,
  pt: OP,
  "pt-br": "pt_BR.dec1bce.json",
  ru: TP,
  sk: RP,
  sq: IP,
  sv: xP,
  tr: PP,
  uk: MP,
  vi: CP,
  "zh-hans": "zh_Hans.bda4f9c.json",
  "zh-hant": "zh_Hant.d964491.json"
}, Sm = "i18n/";
it.setSeparator(Au.KEY_SEPARATOR);
const Om = "en";
it.setFallbackLocale(Om);
function DP(e, r) {
  it.registerTranslations(e, r);
}
function yM(e) {
  it.setMissingEntryGenerator(e);
}
function NP() {
  return it.getLocale();
}
function vM(e) {
  return it.setLocale(e);
}
function mM(e) {
  return e;
}
function Zy(e) {
  return typeof e == "string" && !e.startsWith("missing translation:");
}
const LP = (e, r) => {
  const i = it.translate(e, { ...r, fallbackLocale: it.getLocale() });
  if (Zy(i))
    return { translated: i };
  const a = it.translate(e, { ...r, locale: Om });
  return Zy(a) ? { translated: a, isFallback: !0 } : { translated: e, isFallback: !0 };
};
function up(e, r) {
  const i = { ...r, interpolate: !1 };
  return i && typeof i == "object" && Object.keys(i).forEach((a) => {
    i[a] === void 0 && (console.warn("safeCounterpartTranslate called with undefined interpolation name: " + a), i[a] = "undefined"), i[a] === null && (console.warn("safeCounterpartTranslate called with null interpolation name: " + a), i[a] = "null");
  }), LP(e, i);
}
const Tm = (e, r) => e;
function sp(e, r, i) {
  const { translated: a } = up(e, r), u = Rm(a, r, i);
  return Tm(u);
}
function _M(e) {
  return up(e, {}).translated;
}
function wM(e, r, i) {
  const { translated: a, isFallback: u } = up(e, r), c = Rm(a, r, i);
  return Tm(u ? /* @__PURE__ */ V.createElement("span", { lang: "en" }, c) : c);
}
function bM(e) {
  return e.replace(/%\(([^)]*)\)/g, "% ($1)");
}
function Rm(e, r, i) {
  let a = e;
  if (r !== void 0) {
    const u = {};
    for (const c in r)
      u[`%\\(${c}\\)s`] = r[c];
    a = Hy(a, u);
  }
  if (i !== void 0) {
    const u = {};
    for (const c in i)
      u[`(<${c}>(.*?)<\\/${c}>|<${c}>|<${c}\\s*\\/>)`] = i[c];
    a = Hy(a, u);
  }
  return a;
}
function Hy(e, r) {
  const i = [e];
  let a = !1;
  for (const u in r) {
    const c = new RegExp(u, "g");
    let f = !1;
    for (let p = 0; p < i.length; p++) {
      const d = i[p];
      if (typeof d != "string")
        continue;
      let g = c.exec(d);
      if (!g) continue;
      f = !0;
      const m = d.slice(0, g.index), v = [];
      let w;
      for (; g; ) {
        w = g;
        const M = g.slice(2);
        let E;
        r[u] instanceof Function ? E = r[u](...M) : E = r[u], typeof E == "object" && (a = !0), (typeof E != "string" || E !== "") && v.push(E), g = c.exec(d);
        let x;
        if (g) {
          const B = w.index + w[0].length;
          x = d.slice(B, g.index);
        } else
          x = d.slice(w.index + w[0].length);
        x && v.push(x);
      }
      i.splice(p, 1, ...v), m !== "" && i.splice(p, 0, m);
    }
    f || // The current regexp did not match anything in the input. Missing
    // matches is entirely possible because you might choose to show some
    // variables only in the case of e.g. plurals. It's still a bit
    // suspicious, and could be due to an error, so log it. However, not
    // showing count is so common that it's not worth logging. And other
    // commonly unused variables here, if there are any.
    u !== "%\\(count\\)s" && // Ignore the `locale` option which can be used to override the locale
    // in counterpart
    u !== "%\\(locale\\)s" && console.log(`Could not find ${c} in ${e}`);
  }
  return a ? V.createElement("span", null, ...i) : i.join("");
}
async function EM(e) {
  const r = await BP(), i = e in r ? e : "en", a = await FP(Sm + r[i]);
  it.registerTranslations(i, a), it.setLocale(i);
}
async function FP(e) {
  console.log("Loading language from", e);
  const r = await fetch(e, { method: "GET" });
  if (!r.ok)
    throw new Error(`Failed to load ${e}, got ${r.status}`);
  return r.json();
}
async function BP() {
  let e;
  typeof Gy == "string" ? e = Gy : e = Sm + "languages.json";
  const r = await fetch(e, { method: "GET" });
  if (!r.ok)
    throw new Error(`Failed to load ${e}, got ${r.status}`);
  return r.json();
}
function AM({
  type: e,
  children: r,
  avatar: i,
  className: a,
  actions: u,
  onClose: c,
  ...f
}) {
  const p = ot(xa.banner, a), d = _i(() => {
    switch (e) {
      case "critical":
        return /* @__PURE__ */ V.createElement(XI, { fontSize: 24, ...f });
      case "info":
        return /* @__PURE__ */ V.createElement(Ig, { fontSize: 24, ...f });
      case "success":
        return /* @__PURE__ */ V.createElement(VI, { fontSize: 24, ...f });
      default:
        return /* @__PURE__ */ V.createElement(Ig, { fontSize: 24, ...f });
    }
  }, [e, f]);
  return /* @__PURE__ */ V.createElement("div", { ...f, className: p, "data-type": e }, /* @__PURE__ */ V.createElement("div", { className: xa.icon }, i ?? d), /* @__PURE__ */ V.createElement("span", { className: xa.content }, r), /* @__PURE__ */ V.createElement("div", { className: xa.actions }, u, c && /* @__PURE__ */ V.createElement(mO, { kind: "secondary", size: "sm", onClick: c }, sp("action|dismiss"))));
}
function SM({ vm: e }) {
  const r = ov(e);
  return /* @__PURE__ */ V.createElement("div", { className: "mx_TextualEvent" }, r.content);
}
function Im(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "M6.293 6.293a1 1 0 0 1 1.414 0L12 10.586l4.293-4.293a1 1 0 1 1 1.414 1.414L13.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414L12 13.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L10.586 12 6.293 7.707a1 1 0 0 1 0-1.414"
    })
  });
}
Im.displayName = "CloseIcon";
const jP = Br(Im), qP = "_pill_1i8jm_8", UP = "_label_1i8jm_14", Ky = {
  pill: qP,
  label: UP
};
function OM({ className: e, children: r, label: i, onClick: a, ...u }) {
  const c = tv(), { translate: f } = go();
  return /* @__PURE__ */ V.createElement(
    et,
    {
      display: "inline-flex",
      gap: "var(--cpd-space-1-5x)",
      align: "center",
      className: ot(Ky.pill, e),
      ...u
    },
    r,
    /* @__PURE__ */ V.createElement("span", { id: c, className: Ky.label }, i),
    a && /* @__PURE__ */ V.createElement(
      iv,
      {
        "aria-describedby": c,
        size: "16px",
        onClick: a,
        "aria-label": f("action|delete"),
        className: "mx_Dialog_nonDialogButton"
      },
      /* @__PURE__ */ V.createElement(jP, { color: "var(--cpd-color-icon-tertiary)" })
    )
  );
}
function kP(e) {
  return (r) => {
    for (const i of e) Rf(i, r);
  };
}
function WP(e) {
  return (r) => {
    const i = [];
    for (const a of e) {
      const u = Rf(a, r), c = typeof u == "function";
      i.push(c ? u : () => Rf(a, null));
    }
    return () => {
      for (const a of i) a();
    };
  };
}
function Rf(e, r) {
  if (typeof e == "function")
    return e(r);
  e && (e.current = r);
}
var YP = parseInt(gO.split(".")[0], 10) >= 19 ? WP : kP;
function $P(e) {
  return _i(() => YP(e), e);
}
const zP = "_pillInput_1yam9_8", GP = "_input_1yam9_16", ZP = "_largerInput_1yam9_32", yf = {
  pillInput: zP,
  input: GP,
  largerInput: ZP
};
function TM({
  className: e,
  children: r,
  onRemoveChildren: i,
  inputProps: a,
  ...u
}) {
  const c = rv(null), f = fm.omit(a, ["onKeyDown", "ref"]), p = $P([c, a?.ref]), d = yO.toArray(r).length > 0;
  return /* @__PURE__ */ V.createElement(
    et,
    {
      ...u,
      gap: "var(--cpd-space-1x)",
      direction: "column",
      className: ot(yf.pillInput, e),
      onClick: (g) => {
        g.preventDefault(), g.stopPropagation(), c.current?.focus();
      }
    },
    d && /* @__PURE__ */ V.createElement(et, { gap: "var(--cpd-space-1x)", wrap: "wrap", align: "center" }, r),
    /* @__PURE__ */ V.createElement(
      "input",
      {
        ref: p,
        autoComplete: "off",
        className: ot(yf.input, { [yf.largerInput]: d }),
        onKeyDown: (g) => {
          const m = g.currentTarget.value.trim();
          if (g.key === "Backspace" && !m) {
            g.preventDefault(), i?.(g);
            return;
          }
          a?.onKeyDown?.(g);
        },
        ...f
      }
    )
  );
}
function xm(e, r) {
  return /* @__PURE__ */ pe.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: r,
    ...e,
    children: /* @__PURE__ */ pe.jsx("path", {
      d: "M9.55 17.575q-.2 0-.375-.062a.9.9 0 0 1-.325-.213L4.55 13q-.274-.274-.262-.713.012-.437.287-.712a.95.95 0 0 1 .7-.275q.425 0 .7.275L9.55 15.15l8.475-8.475q.274-.275.713-.275.437 0 .712.275.275.274.275.713 0 .437-.275.712l-9.2 9.2q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063"
    })
  });
}
xm.displayName = "CheckIcon";
const HP = Br(xm), KP = "_richItem_1c0uo_8", JP = "_avatar_1c0uo_36", VP = "_title_1c0uo_41", XP = "_description_1c0uo_47", QP = "_timestamp_1c0uo_51", nM = "_checkmark_1c0uo_69", pi = {
  richItem: KP,
  avatar: JP,
  title: VP,
  description: XP,
  timestamp: QP,
  checkmark: nM
}, RM = vO(function({
  avatar: r,
  title: i,
  description: a,
  timestamp: u,
  selected: c,
  ...f
}) {
  const p = go();
  return /* @__PURE__ */ V.createElement(
    "li",
    {
      className: pi.richItem,
      role: "option",
      tabIndex: -1,
      "aria-selected": c,
      "aria-label": i,
      ...f
    },
    c ? /* @__PURE__ */ V.createElement(eM, null) : /* @__PURE__ */ V.createElement(et, { className: pi.avatar }, r),
    /* @__PURE__ */ V.createElement("span", { className: pi.title }, i),
    /* @__PURE__ */ V.createElement("span", { className: pi.description }, a),
    u && /* @__PURE__ */ V.createElement("span", { role: "timer", className: pi.timestamp }, p.humanizeTime(u))
  );
});
function eM() {
  return /* @__PURE__ */ V.createElement(et, { align: "center", justify: "center", "aria-hidden": "true", className: pi.checkmark }, /* @__PURE__ */ V.createElement(HP, { width: "24px", height: "24px", color: "var(--cpd-color-icon-on-solid-primary)" }));
}
const tM = "_richList_1mcas_8", rM = "_title_1mcas_12", iM = "_content_1mcas_18", oM = "_empty_1mcas_26", Ca = {
  richList: tM,
  title: rM,
  content: iM,
  empty: oM
};
function aM() {
  const e = rv(null), r = jd((a) => {
    if (e.current && a.target === e.current) {
      let u = e.current?.firstElementChild;
      for (const c of e.current.children)
        if (c.getAttribute("aria-selected") === "true") {
          u = c;
          break;
        }
      u?.focus();
    }
  }, []), i = jd((a) => {
    const { key: u } = a;
    let c = !1;
    switch (u) {
      case "Enter":
      case " ": {
        c = !0, document.activeElement.click();
        break;
      }
      case "ArrowDown": {
        c = !0;
        const f = document.activeElement;
        e.current?.contains(f) && f && f.nextElementSibling?.focus();
        break;
      }
      case "ArrowUp": {
        c = !0;
        const f = document.activeElement;
        e.current?.contains(f) && f && f.previousElementSibling?.focus();
        break;
      }
      case "Home": {
        c = !0, e.current?.firstElementChild?.focus();
        break;
      }
      case "End": {
        c = !0, e.current?.lastElementChild?.focus();
        break;
      }
    }
    c && a.preventDefault();
  }, []);
  return { listRef: e, onKeyDown: i, onFocus: r };
}
function IM({
  children: e,
  title: r,
  className: i,
  titleAttributes: a,
  isEmpty: u = !1,
  ...c
}) {
  const f = tv(), { listRef: p, onKeyDown: d, onFocus: g } = aM();
  return /* @__PURE__ */ V.createElement(et, { className: ot(Ca.richList, i), direction: "column", ...c }, /* @__PURE__ */ V.createElement("span", { id: f, className: Ca.title, ...a }, r), u ? /* @__PURE__ */ V.createElement("span", { className: Ca.empty }, e) : /* @__PURE__ */ V.createElement(
    "ul",
    {
      ref: p,
      role: "listbox",
      className: Ca.content,
      "aria-labelledby": f,
      tabIndex: 0,
      onKeyDown: d,
      onFocus: g
    },
    e
  ));
}
const vf = {
  "box-flex": "_box-flex_1odfs_9",
  "box-shrink": "_box-shrink_1odfs_13",
  "box-grow": "_box-grow_1odfs_17"
};
function xM({
  as: e = "div",
  flex: r = null,
  shrink: i = null,
  grow: a = null,
  className: u,
  children: c,
  ...f
}) {
  const p = _i(() => {
    const d = {};
    return r && (d["--mx-box-flex"] = r), i && (d["--mx-box-shrink"] = i), a && (d["--mx-box-grow"] = a), d;
  }, [r, a, i]);
  return V.createElement(
    e,
    {
      ...f,
      className: ot(u, {
        [vf["box-flex"]]: !!r,
        [vf["box-shrink"]]: !!i,
        [vf["box-grow"]]: !!a
      }),
      style: p
    },
    c
  );
}
const Jy = 15e3, Vy = 75e3, Xy = 45, Qy = 75, nv = 23, ev = 26;
function uM(e, r) {
  let a = Date.now() - e;
  const u = Math.abs(Math.ceil(a / 6e4)), c = Math.ceil(u / 60), f = Math.ceil(c / 24), p = r?.translate ?? sp;
  return a >= 0 ? a <= Jy ? p("time|few_seconds_ago") : a <= Vy ? p("time|about_minute_ago") : u <= Xy ? p("time|n_minutes_ago", { num: u }) : u <= Qy ? p("time|about_hour_ago") : c <= nv ? p("time|n_hours_ago", { num: c }) : c <= ev ? p("time|about_day_ago") : p("time|n_days_ago", { num: f }) : (a = Math.abs(a), a <= Jy ? p("time|in_few_seconds") : a <= Vy ? p("time|in_about_minute") : u <= Xy ? p("time|in_n_minutes", { num: u }) : u <= Qy ? p("time|in_about_hour") : c <= nv ? p("time|in_n_hours", { num: c }) : c <= ev ? p("time|in_about_day") : p("time|in_n_days", { num: f }));
}
function PM(e, r) {
  return Number.isFinite(e) ? Number(e) : r;
}
function MM(e, r, i) {
  return Math.min(Math.max(e, r), i);
}
function CM(...e) {
  return [...e].reduce((r, i) => i + r, 0);
}
function DM(e, r, i) {
  return e * (i - r) + r;
}
function NM(e, r, i) {
  const a = (e - r) / (i - r);
  return Number.isNaN(a) ? 0 : a;
}
class LM {
  /**
   * Read the current language of the user in IETF Language Tag format
   */
  get language() {
    return NP();
  }
  /**
   * Register translations for the module, may override app's existing translations
   */
  register(r) {
    const i = {};
    for (const a in r)
      for (const u in r[a])
        i[u] = i[u] || {}, i[u][a] = r[a][u];
    for (const a in i)
      DP(a, i[a]);
  }
  /**
   * Perform a translation, with optional variables
   * @param key - The key to translate
   * @param variables - Optional variables to interpolate into the translation
   */
  translate(r, i) {
    return sp(r, i);
  }
  humanizeTime(r) {
    return uM(r, this);
  }
}
class sM {
  disposables = [];
  _isDisposed = !1;
  /**
   * Relinquish all tracked disposable values
   */
  dispose() {
    if (!this.isDisposed) {
      this._isDisposed = !0;
      for (const r of this.disposables)
        typeof r == "function" ? r() : r.dispose();
    }
  }
  /**
   * Track a value that needs to be eventually relinquished
   */
  track(r) {
    return this.throwIfDisposed(), this.disposables.push(r), r;
  }
  /**
   * Add an event listener that will be removed on dispose
   */
  trackListener(r, i, a) {
    this.throwIfDisposed(), r.on(i, a), this.track(() => {
      r.off(i, a);
    });
  }
  throwIfDisposed() {
    if (this.isDisposed) throw new Error("Disposable is already disposed");
  }
  /**
   * Whether this disposable has been disposed
   */
  get isDisposed() {
    return this._isDisposed;
  }
}
class cM {
  constructor(r, i) {
    this.snapshot = r, this.emit = i;
  }
  /**
   * Replace current snapshot with a new snapshot value.
   * @param snapshot New snapshot value
   */
  set(r) {
    this.snapshot = r, this.emit();
  }
  /**
   * Update a part of the current snapshot by merging into the existing snapshot.
   * @param snapshot A subset of the snapshot to merge into the current snapshot.
   */
  merge(r) {
    this.snapshot = { ...this.snapshot, ...r }, this.emit();
  }
  /**
   * The current value of the snapshot.
   */
  get current() {
    return this.snapshot;
  }
}
class fM {
  listeners = /* @__PURE__ */ new Set();
  /**
   * Subscribe to changes in the view model.
   * @param listener Will be called whenever the snapshot changes.
   * @returns A function to unsubscribe from the view model updates.
   */
  add = (r) => (this.listeners.add(r), () => {
    this.listeners.delete(r);
  });
  /**
   * Emit an update to all subscribed listeners.
   */
  emit = () => {
    for (const r of this.listeners)
      r();
  };
}
class FM {
  subs;
  snapshot;
  props;
  disposables = new sM();
  constructor(r, i) {
    this.props = r, this.subs = new fM(), this.snapshot = new cM(i, () => {
      this.subs.emit();
    });
  }
  subscribe = (r) => this.subs.add(r);
  /**
   * Returns the current snapshot of the view model.
   */
  getSnapshot = () => this.snapshot.current;
  /**
   * Relinquish any resources held by this view-model.
   */
  dispose() {
    this.disposables.dispose();
  }
  /**
   * Whether this view-model has been disposed.
   */
  get isDisposed() {
    return this.disposables.isDisposed;
  }
}
class lM {
  constructor(r) {
    this.snapshot = r;
  }
  getSnapshot = () => this.snapshot;
  subscribe(r) {
    return () => {
    };
  }
}
function BM(e, r) {
  return _i(() => {
    const i = new lM(e);
    return Object.assign(i, r), i;
  }, [e, r]);
}
const jM = Au.KEY_SEPARATOR, qM = Au.getNormalizedLanguageKeys, UM = Au.normalizeLanguageKey;
export {
  dM as AudioPlayerView,
  gM as AvatarWithDetails,
  AM as Banner,
  FM as BaseViewModel,
  xM as Box,
  Tg as Clock,
  sM as Disposables,
  et as Flex,
  LM as I18nApi,
  cv as I18nContext,
  jM as KEY_SEPARATOR,
  AO as MediaBody,
  lM as MockViewModel,
  OM as Pill,
  TM as PillInput,
  qO as PlayPauseButton,
  RM as RichItem,
  IM as RichList,
  ZI as SeekBar,
  cM as Snapshot,
  SM as TextualEventView,
  fM as ViewModelSubscriptions,
  sp as _t,
  wM as _tDom,
  mM as _td,
  MM as clamp,
  PM as defaultNumber,
  UO as formatBytes,
  WI as formatSeconds,
  BP as getLangsJson,
  NP as getLocale,
  qM as getNormalizedLanguageKeys,
  uM as humanizeTime,
  _M as lookupString,
  UM as normalizeLanguageKey,
  NM as percentageOf,
  DM as percentageWithin,
  DP as registerTranslations,
  Hy as replaceByRegexes,
  bM as sanitizeForTranslation,
  EM as setLanguage,
  vM as setLocale,
  yM as setMissingEntryGenerator,
  Rm as substitute,
  CM as sum,
  go as useI18n,
  BM as useMockedViewModel,
  ov as useViewModel
};
